//省市县code编码库
const aLocation = {
    '0': {
        '110000': '\u5317\u4eac',
        '120000': '\u5929\u6d25',
        '130000': '\u6cb3\u5317\u7701',
        '140000': '\u5c71\u897f\u7701',
        '150000': '\u5185\u8499\u53e4\u81ea\u6cbb\u533a',
        '210000': '\u8fbd\u5b81\u7701',
        '220000': '\u5409\u6797\u7701',
        '230000': '\u9ed1\u9f99\u6c5f\u7701',
        '310000': '\u4e0a\u6d77',
        '320000': '\u6c5f\u82cf\u7701',
        '330000': '\u6d59\u6c5f\u7701',
        '340000': '\u5b89\u5fbd\u7701',
        '350000': '\u798f\u5efa\u7701',
        '360000': '\u6c5f\u897f\u7701',
        '370000': '\u5c71\u4e1c\u7701',
        '410000': '\u6cb3\u5357\u7701',
        '420000': '\u6e56\u5317\u7701',
        '430000': '\u6e56\u5357\u7701',
        '440000': '\u5e7f\u4e1c\u7701',
        '450000': '\u5e7f\u897f\u58ee\u65cf\u81ea\u6cbb\u533a',
        '460000': '\u6d77\u5357\u7701',
        '500000': '\u91cd\u5e86',
        '510000': '\u56db\u5ddd\u7701',
        '520000': '\u8d35\u5dde\u7701',
        '530000': '\u4e91\u5357\u7701',
        '540000': '\u897f\u85cf\u81ea\u6cbb\u533a',
        '610000': '\u9655\u897f\u7701',
        '620000': '\u7518\u8083\u7701',
        '630000': '\u9752\u6d77\u7701',
        '640000': '\u5b81\u590f\u56de\u65cf\u81ea\u6cbb\u533a',
        '650000': '\u65b0\u7586\u7ef4\u543e\u5c14\u81ea\u6cbb\u533a',
        '710000': '\u53f0\u6e7e\u7701',
        '810000': '\u9999\u6e2f\u7279\u522b\u884c\u653f\u533a',
        '820000': '\u6fb3\u95e8\u7279\u522b\u884c\u653f\u533a',
        '990000': '\u6d77\u5916',
    },
    '0,110000': {
        '110100': '\u5317\u4eac\u5e02',
    },
    '0,110000,110100': {
        '110101': '\u4e1c\u57ce\u533a',
        '110102': '\u897f\u57ce\u533a',
        '110103': '\u5d07\u6587\u533a',
        '110104': '\u5ba3\u6b66\u533a',
        '110105': '\u671d\u9633\u533a',
        '110106': '\u4e30\u53f0\u533a',
        '110107': '\u77f3\u666f\u5c71\u533a',
        '110108': '\u6d77\u6dc0\u533a',
        '110109': '\u95e8\u5934\u6c9f\u533a',
        '110111': '\u623f\u5c71\u533a',
        '110112': '\u901a\u5dde\u533a',
        '110113': '\u987a\u4e49\u533a',
        '110114': '\u660c\u5e73\u533a',
        '110115': '\u5927\u5174\u533a',
        '110116': '\u6000\u67d4\u533a',
        '110117': '\u5e73\u8c37\u533a',
        '110228': '\u5bc6\u4e91\u53bf',
        '110229': '\u5ef6\u5e86\u53bf',
        '110230': '\u5176\u5b83\u533a',
    },
    '0,120000': {
        '120100': '\u5929\u6d25\u5e02',
    },
    '0,120000,120100': {
        '120101': '\u548c\u5e73\u533a',
        '120102': '\u6cb3\u4e1c\u533a',
        '120103': '\u6cb3\u897f\u533a',
        '120104': '\u5357\u5f00\u533a',
        '120105': '\u6cb3\u5317\u533a',
        '120106': '\u7ea2\u6865\u533a',
        '120107': '\u5858\u6cbd\u533a',
        '120108': '\u6c49\u6cbd\u533a',
        '120109': '\u5927\u6e2f\u533a',
        '120110': '\u4e1c\u4e3d\u533a',
        '120111': '\u897f\u9752\u533a',
        '120112': '\u6d25\u5357\u533a',
        '120113': '\u5317\u8fb0\u533a',
        '120114': '\u6b66\u6e05\u533a',
        '120115': '\u5b9d\u577b\u533a',
        '120116': '\u6ee8\u6d77\u65b0\u533a',
        '120221': '\u5b81\u6cb3\u53bf',
        '120223': '\u9759\u6d77\u53bf',
        '120225': '\u84df\u53bf',
        '120226': '\u5176\u5b83\u533a',
    },
    '0,130000': {
        '130100': '\u77f3\u5bb6\u5e84\u5e02',
        '130200': '\u5510\u5c71\u5e02',
        '130300': '\u79e6\u7687\u5c9b\u5e02',
        '130400': '\u90af\u90f8\u5e02',
        '130500': '\u90a2\u53f0\u5e02',
        '130600': '\u4fdd\u5b9a\u5e02',
        '130700': '\u5f20\u5bb6\u53e3\u5e02',
        '130800': '\u627f\u5fb7\u5e02',
        '130900': '\u6ca7\u5dde\u5e02',
        '131000': '\u5eca\u574a\u5e02',
        '131100': '\u8861\u6c34\u5e02',
    },
    '0,130000,130100': {
        '130102': '\u957f\u5b89\u533a',
        '130103': '\u6865\u4e1c\u533a',
        '130104': '\u6865\u897f\u533a',
        '130105': '\u65b0\u534e\u533a',
        '130107': '\u4e95\u9649\u77ff\u533a',
        '130108': '\u88d5\u534e\u533a',
        '130121': '\u4e95\u9649\u53bf',
        '130123': '\u6b63\u5b9a\u53bf',
        '130124': '\u683e\u57ce\u53bf',
        '130125': '\u884c\u5510\u53bf',
        '130126': '\u7075\u5bff\u53bf',
        '130127': '\u9ad8\u9091\u53bf',
        '130128': '\u6df1\u6cfd\u53bf',
        '130129': '\u8d5e\u7687\u53bf',
        '130130': '\u65e0\u6781\u53bf',
        '130131': '\u5e73\u5c71\u53bf',
        '130132': '\u5143\u6c0f\u53bf',
        '130133': '\u8d75\u53bf',
        '130181': '\u8f9b\u96c6\u5e02',
        '130182': '\u85c1\u57ce\u5e02',
        '130183': '\u664b\u5dde\u5e02',
        '130184': '\u65b0\u4e50\u5e02',
        '130185': '\u9e7f\u6cc9\u5e02',
        '130186': '\u5176\u5b83\u533a',
    },
    '0,130000,130200': {
        '130202': '\u8def\u5357\u533a',
        '130203': '\u8def\u5317\u533a',
        '130204': '\u53e4\u51b6\u533a',
        '130205': '\u5f00\u5e73\u533a',
        '130207': '\u4e30\u5357\u533a',
        '130208': '\u4e30\u6da6\u533a',
        '130223': '\u6ee6\u53bf',
        '130224': '\u6ee6\u5357\u53bf',
        '130225': '\u4e50\u4ead\u53bf',
        '130227': '\u8fc1\u897f\u53bf',
        '130229': '\u7389\u7530\u53bf',
        '130230': '\u5510\u6d77\u53bf',
        '130281': '\u9075\u5316\u5e02',
        '130283': '\u8fc1\u5b89\u5e02',
        '130284': '\u5176\u5b83\u533a',
    },
    '0,130000,130300': {
        '130302': '\u6d77\u6e2f\u533a',
        '130303': '\u5c71\u6d77\u5173\u533a',
        '130304': '\u5317\u6234\u6cb3\u533a',
        '130321': '\u9752\u9f99\u6ee1\u65cf\u81ea\u6cbb\u53bf',
        '130322': '\u660c\u9ece\u53bf',
        '130323': '\u629a\u5b81\u53bf',
        '130324': '\u5362\u9f99\u53bf',
        '130398': '\u5176\u5b83\u533a',
        '130399': '\u7ecf\u6d4e\u6280\u672f\u5f00\u53d1\u533a',
    },
    '0,130000,130400': {
        '130402': '\u90af\u5c71\u533a',
        '130403': '\u4e1b\u53f0\u533a',
        '130404': '\u590d\u5174\u533a',
        '130406': '\u5cf0\u5cf0\u77ff\u533a',
        '130421': '\u90af\u90f8\u53bf',
        '130423': '\u4e34\u6f33\u53bf',
        '130424': '\u6210\u5b89\u53bf',
        '130425': '\u5927\u540d\u53bf',
        '130426': '\u6d89\u53bf',
        '130427': '\u78c1\u53bf',
        '130428': '\u80a5\u4e61\u53bf',
        '130429': '\u6c38\u5e74\u53bf',
        '130430': '\u90b1\u53bf',
        '130431': '\u9e21\u6cfd\u53bf',
        '130432': '\u5e7f\u5e73\u53bf',
        '130433': '\u9986\u9676\u53bf',
        '130434': '\u9b4f\u53bf',
        '130435': '\u66f2\u5468\u53bf',
        '130481': '\u6b66\u5b89\u5e02',
        '130482': '\u5176\u5b83\u533a',
    },
    '0,130000,130500': {
        '130502': '\u6865\u4e1c\u533a',
        '130503': '\u6865\u897f\u533a',
        '130521': '\u90a2\u53f0\u53bf',
        '130522': '\u4e34\u57ce\u53bf',
        '130523': '\u5185\u4e18\u53bf',
        '130524': '\u67cf\u4e61\u53bf',
        '130525': '\u9686\u5c27\u53bf',
        '130526': '\u4efb\u53bf',
        '130527': '\u5357\u548c\u53bf',
        '130528': '\u5b81\u664b\u53bf',
        '130529': '\u5de8\u9e7f\u53bf',
        '130530': '\u65b0\u6cb3\u53bf',
        '130531': '\u5e7f\u5b97\u53bf',
        '130532': '\u5e73\u4e61\u53bf',
        '130533': '\u5a01\u53bf',
        '130534': '\u6e05\u6cb3\u53bf',
        '130535': '\u4e34\u897f\u53bf',
        '130581': '\u5357\u5bab\u5e02',
        '130582': '\u6c99\u6cb3\u5e02',
        '130583': '\u5176\u5b83\u533a',
    },
    '0,130000,130600': {
        '130602': '\u65b0\u5e02\u533a',
        '130603': '\u5317\u5e02\u533a',
        '130604': '\u5357\u5e02\u533a',
        '130621': '\u6ee1\u57ce\u53bf',
        '130622': '\u6e05\u82d1\u53bf',
        '130623': '\u6d9e\u6c34\u53bf',
        '130624': '\u961c\u5e73\u53bf',
        '130625': '\u5f90\u6c34\u53bf',
        '130626': '\u5b9a\u5174\u53bf',
        '130627': '\u5510\u53bf',
        '130628': '\u9ad8\u9633\u53bf',
        '130629': '\u5bb9\u57ce\u53bf',
        '130630': '\u6d9e\u6e90\u53bf',
        '130631': '\u671b\u90fd\u53bf',
        '130632': '\u5b89\u65b0\u53bf',
        '130633': '\u6613\u53bf',
        '130634': '\u66f2\u9633\u53bf',
        '130635': '\u8821\u53bf',
        '130636': '\u987a\u5e73\u53bf',
        '130637': '\u535a\u91ce\u53bf',
        '130638': '\u96c4\u53bf',
        '130681': '\u6dbf\u5dde\u5e02',
        '130682': '\u5b9a\u5dde\u5e02',
        '130683': '\u5b89\u56fd\u5e02',
        '130684': '\u9ad8\u7891\u5e97\u5e02',
        '130698': '\u9ad8\u5f00\u533a',
        '130699': '\u5176\u5b83\u533a',
    },
    '0,130000,130700': {
        '130702': '\u6865\u4e1c\u533a',
        '130703': '\u6865\u897f\u533a',
        '130705': '\u5ba3\u5316\u533a',
        '130706': '\u4e0b\u82b1\u56ed\u533a',
        '130721': '\u5ba3\u5316\u53bf',
        '130722': '\u5f20\u5317\u53bf',
        '130723': '\u5eb7\u4fdd\u53bf',
        '130724': '\u6cbd\u6e90\u53bf',
        '130725': '\u5c1a\u4e49\u53bf',
        '130726': '\u851a\u53bf',
        '130727': '\u9633\u539f\u53bf',
        '130728': '\u6000\u5b89\u53bf',
        '130729': '\u4e07\u5168\u53bf',
        '130730': '\u6000\u6765\u53bf',
        '130731': '\u6dbf\u9e7f\u53bf',
        '130732': '\u8d64\u57ce\u53bf',
        '130733': '\u5d07\u793c\u53bf',
        '130734': '\u5176\u5b83\u533a',
    },
    '0,130000,130800': {
        '130802': '\u53cc\u6865\u533a',
        '130803': '\u53cc\u6ee6\u533a',
        '130804': '\u9e70\u624b\u8425\u5b50\u77ff\u533a',
        '130821': '\u627f\u5fb7\u53bf',
        '130822': '\u5174\u9686\u53bf',
        '130823': '\u5e73\u6cc9\u53bf',
        '130824': '\u6ee6\u5e73\u53bf',
        '130825': '\u9686\u5316\u53bf',
        '130826': '\u4e30\u5b81\u6ee1\u65cf\u81ea\u6cbb\u53bf',
        '130827': '\u5bbd\u57ce\u6ee1\u65cf\u81ea\u6cbb\u53bf',
        '130828': '\u56f4\u573a\u6ee1\u65cf\u8499\u53e4\u65cf\u81ea\u6cbb\u53bf',
        '130829': '\u5176\u5b83\u533a',
    },
    '0,130000,130900': {
        '130902': '\u65b0\u534e\u533a',
        '130903': '\u8fd0\u6cb3\u533a',
        '130921': '\u6ca7\u53bf',
        '130922': '\u9752\u53bf',
        '130923': '\u4e1c\u5149\u53bf',
        '130924': '\u6d77\u5174\u53bf',
        '130925': '\u76d0\u5c71\u53bf',
        '130926': '\u8083\u5b81\u53bf',
        '130927': '\u5357\u76ae\u53bf',
        '130928': '\u5434\u6865\u53bf',
        '130929': '\u732e\u53bf',
        '130930': '\u5b5f\u6751\u56de\u65cf\u81ea\u6cbb\u53bf',
        '130981': '\u6cca\u5934\u5e02',
        '130982': '\u4efb\u4e18\u5e02',
        '130983': '\u9ec4\u9a85\u5e02',
        '130984': '\u6cb3\u95f4\u5e02',
        '130985': '\u5176\u5b83\u533a',
    },
    '0,130000,131000': {
        '131002': '\u5b89\u6b21\u533a',
        '131003': '\u5e7f\u9633\u533a',
        '131022': '\u56fa\u5b89\u53bf',
        '131023': '\u6c38\u6e05\u53bf',
        '131024': '\u9999\u6cb3\u53bf',
        '131025': '\u5927\u57ce\u53bf',
        '131026': '\u6587\u5b89\u53bf',
        '131028': '\u5927\u5382\u56de\u65cf\u81ea\u6cbb\u53bf',
        '131051': '\u5f00\u53d1\u533a',
        '131052': '\u71d5\u90ca\u7ecf\u6d4e\u6280\u672f\u5f00\u53d1\u533a',
        '131081': '\u9738\u5dde\u5e02',
        '131082': '\u4e09\u6cb3\u5e02',
        '131083': '\u5176\u5b83\u533a',
    },
    '0,130000,131100': {
        '131102': '\u6843\u57ce\u533a',
        '131121': '\u67a3\u5f3a\u53bf',
        '131122': '\u6b66\u9091\u53bf',
        '131123': '\u6b66\u5f3a\u53bf',
        '131124': '\u9976\u9633\u53bf',
        '131125': '\u5b89\u5e73\u53bf',
        '131126': '\u6545\u57ce\u53bf',
        '131127': '\u666f\u53bf',
        '131128': '\u961c\u57ce\u53bf',
        '131181': '\u5180\u5dde\u5e02',
        '131182': '\u6df1\u5dde\u5e02',
        '131183': '\u5176\u5b83\u533a',
    },
    '0,140000': {
        '140100': '\u592a\u539f\u5e02',
        '140200': '\u5927\u540c\u5e02',
        '140300': '\u9633\u6cc9\u5e02',
        '140400': '\u957f\u6cbb\u5e02',
        '140500': '\u664b\u57ce\u5e02',
        '140600': '\u6714\u5dde\u5e02',
        '140700': '\u664b\u4e2d\u5e02',
        '140800': '\u8fd0\u57ce\u5e02',
        '140900': '\u5ffb\u5dde\u5e02',
        '141000': '\u4e34\u6c7e\u5e02',
        '141100': '\u5415\u6881\u5e02',
    },
    '0,140000,140100': {
        '140105': '\u5c0f\u5e97\u533a',
        '140106': '\u8fce\u6cfd\u533a',
        '140107': '\u674f\u82b1\u5cad\u533a',
        '140108': '\u5c16\u8349\u576a\u533a',
        '140109': '\u4e07\u67cf\u6797\u533a',
        '140110': '\u664b\u6e90\u533a',
        '140121': '\u6e05\u5f90\u53bf',
        '140122': '\u9633\u66f2\u53bf',
        '140123': '\u5a04\u70e6\u53bf',
        '140181': '\u53e4\u4ea4\u5e02',
        '140182': '\u5176\u5b83\u533a',
    },
    '0,140000,140200': {
        '140202': '\u57ce\u533a',
        '140203': '\u77ff\u533a',
        '140211': '\u5357\u90ca\u533a',
        '140212': '\u65b0\u8363\u533a',
        '140221': '\u9633\u9ad8\u53bf',
        '140222': '\u5929\u9547\u53bf',
        '140223': '\u5e7f\u7075\u53bf',
        '140224': '\u7075\u4e18\u53bf',
        '140225': '\u6d51\u6e90\u53bf',
        '140226': '\u5de6\u4e91\u53bf',
        '140227': '\u5927\u540c\u53bf',
        '140228': '\u5176\u5b83\u533a',
    },
    '0,140000,140300': {
        '140302': '\u57ce\u533a',
        '140303': '\u77ff\u533a',
        '140311': '\u90ca\u533a',
        '140321': '\u5e73\u5b9a\u53bf',
        '140322': '\u76c2\u53bf',
        '140323': '\u5176\u5b83\u533a',
    },
    '0,140000,140400': {
        '140421': '\u957f\u6cbb\u53bf',
        '140423': '\u8944\u57a3\u53bf',
        '140424': '\u5c6f\u7559\u53bf',
        '140425': '\u5e73\u987a\u53bf',
        '140426': '\u9ece\u57ce\u53bf',
        '140427': '\u58f6\u5173\u53bf',
        '140428': '\u957f\u5b50\u53bf',
        '140429': '\u6b66\u4e61\u53bf',
        '140430': '\u6c81\u53bf',
        '140431': '\u6c81\u6e90\u53bf',
        '140481': '\u6f5e\u57ce\u5e02',
        '140482': '\u57ce\u533a',
        '140483': '\u90ca\u533a',
        '140484': '\u9ad8\u65b0\u533a',
        '140485': '\u5176\u5b83\u533a',
    },
    '0,140000,140500': {
        '140502': '\u57ce\u533a',
        '140521': '\u6c81\u6c34\u53bf',
        '140522': '\u9633\u57ce\u53bf',
        '140524': '\u9675\u5ddd\u53bf',
        '140525': '\u6cfd\u5dde\u53bf',
        '140581': '\u9ad8\u5e73\u5e02',
        '140582': '\u5176\u5b83\u533a',
    },
    '0,140000,140600': {
        '140602': '\u6714\u57ce\u533a',
        '140603': '\u5e73\u9c81\u533a',
        '140621': '\u5c71\u9634\u53bf',
        '140622': '\u5e94\u53bf',
        '140623': '\u53f3\u7389\u53bf',
        '140624': '\u6000\u4ec1\u53bf',
        '140625': '\u5176\u5b83\u533a',
    },
    '0,140000,140700': {
        '140702': '\u6986\u6b21\u533a',
        '140721': '\u6986\u793e\u53bf',
        '140722': '\u5de6\u6743\u53bf',
        '140723': '\u548c\u987a\u53bf',
        '140724': '\u6614\u9633\u53bf',
        '140725': '\u5bff\u9633\u53bf',
        '140726': '\u592a\u8c37\u53bf',
        '140727': '\u7941\u53bf',
        '140728': '\u5e73\u9065\u53bf',
        '140729': '\u7075\u77f3\u53bf',
        '140781': '\u4ecb\u4f11\u5e02',
        '140782': '\u5176\u5b83\u533a',
    },
    '0,140000,140800': {
        '140802': '\u76d0\u6e56\u533a',
        '140821': '\u4e34\u7317\u53bf',
        '140822': '\u4e07\u8363\u53bf',
        '140823': '\u95fb\u559c\u53bf',
        '140824': '\u7a37\u5c71\u53bf',
        '140825': '\u65b0\u7edb\u53bf',
        '140826': '\u7edb\u53bf',
        '140827': '\u57a3\u66f2\u53bf',
        '140828': '\u590f\u53bf',
        '140829': '\u5e73\u9646\u53bf',
        '140830': '\u82ae\u57ce\u53bf',
        '140881': '\u6c38\u6d4e\u5e02',
        '140882': '\u6cb3\u6d25\u5e02',
        '140883': '\u5176\u5b83\u533a',
    },
    '0,140000,140900': {
        '140902': '\u5ffb\u5e9c\u533a',
        '140921': '\u5b9a\u8944\u53bf',
        '140922': '\u4e94\u53f0\u53bf',
        '140923': '\u4ee3\u53bf',
        '140924': '\u7e41\u5cd9\u53bf',
        '140925': '\u5b81\u6b66\u53bf',
        '140926': '\u9759\u4e50\u53bf',
        '140927': '\u795e\u6c60\u53bf',
        '140928': '\u4e94\u5be8\u53bf',
        '140929': '\u5ca2\u5c9a\u53bf',
        '140930': '\u6cb3\u66f2\u53bf',
        '140931': '\u4fdd\u5fb7\u53bf',
        '140932': '\u504f\u5173\u53bf',
        '140981': '\u539f\u5e73\u5e02',
        '140982': '\u5176\u5b83\u533a',
    },
    '0,140000,141000': {
        '141002': '\u5c27\u90fd\u533a',
        '141021': '\u66f2\u6c83\u53bf',
        '141022': '\u7ffc\u57ce\u53bf',
        '141023': '\u8944\u6c7e\u53bf',
        '141024': '\u6d2a\u6d1e\u53bf',
        '141025': '\u53e4\u53bf',
        '141026': '\u5b89\u6cfd\u53bf',
        '141027': '\u6d6e\u5c71\u53bf',
        '141028': '\u5409\u53bf',
        '141029': '\u4e61\u5b81\u53bf',
        '141030': '\u5927\u5b81\u53bf',
        '141031': '\u96b0\u53bf',
        '141032': '\u6c38\u548c\u53bf',
        '141033': '\u84b2\u53bf',
        '141034': '\u6c7e\u897f\u53bf',
        '141081': '\u4faf\u9a6c\u5e02',
        '141082': '\u970d\u5dde\u5e02',
        '141083': '\u5176\u5b83\u533a',
    },
    '0,140000,141100': {
        '141102': '\u79bb\u77f3\u533a',
        '141121': '\u6587\u6c34\u53bf',
        '141122': '\u4ea4\u57ce\u53bf',
        '141123': '\u5174\u53bf',
        '141124': '\u4e34\u53bf',
        '141125': '\u67f3\u6797\u53bf',
        '141126': '\u77f3\u697c\u53bf',
        '141127': '\u5c9a\u53bf',
        '141128': '\u65b9\u5c71\u53bf',
        '141129': '\u4e2d\u9633\u53bf',
        '141130': '\u4ea4\u53e3\u53bf',
        '141181': '\u5b5d\u4e49\u5e02',
        '141182': '\u6c7e\u9633\u5e02',
        '141183': '\u5176\u5b83\u533a',
    },
    '0,150000': {
        '150100': '\u547c\u548c\u6d69\u7279\u5e02',
        '150200': '\u5305\u5934\u5e02',
        '150300': '\u4e4c\u6d77\u5e02',
        '150400': '\u8d64\u5cf0\u5e02',
        '150500': '\u901a\u8fbd\u5e02',
        '150600': '\u9102\u5c14\u591a\u65af\u5e02',
        '150700': '\u547c\u4f26\u8d1d\u5c14\u5e02',
        '150800': '\u5df4\u5f66\u6dd6\u5c14\u5e02',
        '150900': '\u4e4c\u5170\u5bdf\u5e03\u5e02',
        '152200': '\u5174\u5b89\u76df',
        '152500': '\u9521\u6797\u90ed\u52d2\u76df',
        '152900': '\u963f\u62c9\u5584\u76df',
    },
    '0,150000,150100': {
        '150102': '\u65b0\u57ce\u533a',
        '150103': '\u56de\u6c11\u533a',
        '150104': '\u7389\u6cc9\u533a',
        '150105': '\u8d5b\u7f55\u533a',
        '150121': '\u571f\u9ed8\u7279\u5de6\u65d7',
        '150122': '\u6258\u514b\u6258\u53bf',
        '150123': '\u548c\u6797\u683c\u5c14\u53bf',
        '150124': '\u6e05\u6c34\u6cb3\u53bf',
        '150125': '\u6b66\u5ddd\u53bf',
        '150126': '\u5176\u5b83\u533a',
    },
    '0,150000,150200': {
        '150202': '\u4e1c\u6cb3\u533a',
        '150203': '\u6606\u90fd\u4ed1\u533a',
        '150204': '\u9752\u5c71\u533a',
        '150205': '\u77f3\u62d0\u533a',
        '150206': '\u767d\u4e91\u77ff\u533a',
        '150207': '\u4e5d\u539f\u533a',
        '150221': '\u571f\u9ed8\u7279\u53f3\u65d7',
        '150222': '\u56fa\u9633\u53bf',
        '150223': '\u8fbe\u5c14\u7f55\u8302\u660e\u5b89\u8054\u5408\u65d7',
        '150224': '\u5176\u5b83\u533a',
    },
    '0,150000,150300': {
        '150302': '\u6d77\u52c3\u6e7e\u533a',
        '150303': '\u6d77\u5357\u533a',
        '150304': '\u4e4c\u8fbe\u533a',
        '150305': '\u5176\u5b83\u533a',
    },
    '0,150000,150400': {
        '150402': '\u7ea2\u5c71\u533a',
        '150403': '\u5143\u5b9d\u5c71\u533a',
        '150404': '\u677e\u5c71\u533a',
        '150421': '\u963f\u9c81\u79d1\u5c14\u6c81\u65d7',
        '150422': '\u5df4\u6797\u5de6\u65d7',
        '150423': '\u5df4\u6797\u53f3\u65d7',
        '150424': '\u6797\u897f\u53bf',
        '150425': '\u514b\u4ec0\u514b\u817e\u65d7',
        '150426': '\u7fc1\u725b\u7279\u65d7',
        '150428': '\u5580\u5587\u6c81\u65d7',
        '150429': '\u5b81\u57ce\u53bf',
        '150430': '\u6556\u6c49\u65d7',
        '150431': '\u5176\u5b83\u533a',
    },
    '0,150000,150500': {
        '150502': '\u79d1\u5c14\u6c81\u533a',
        '150521': '\u79d1\u5c14\u6c81\u5de6\u7ffc\u4e2d\u65d7',
        '150522': '\u79d1\u5c14\u6c81\u5de6\u7ffc\u540e\u65d7',
        '150523': '\u5f00\u9c81\u53bf',
        '150524': '\u5e93\u4f26\u65d7',
        '150525': '\u5948\u66fc\u65d7',
        '150526': '\u624e\u9c81\u7279\u65d7',
        '150581': '\u970d\u6797\u90ed\u52d2\u5e02',
        '150582': '\u5176\u5b83\u533a',
    },
    '0,150000,150600': {
        '150602': '\u4e1c\u80dc\u533a',
        '150621': '\u8fbe\u62c9\u7279\u65d7',
        '150622': '\u51c6\u683c\u5c14\u65d7',
        '150623': '\u9102\u6258\u514b\u524d\u65d7',
        '150624': '\u9102\u6258\u514b\u65d7',
        '150625': '\u676d\u9526\u65d7',
        '150626': '\u4e4c\u5ba1\u65d7',
        '150627': '\u4f0a\u91d1\u970d\u6d1b\u65d7',
        '150628': '\u5176\u5b83\u533a',
    },
    '0,150000,150700': {
        '150702': '\u6d77\u62c9\u5c14\u533a',
        '150721': '\u963f\u8363\u65d7',
        '150722': '\u83ab\u529b\u8fbe\u74e6\u8fbe\u65a1\u5c14\u65cf\u81ea\u6cbb\u65d7',
        '150723': '\u9102\u4f26\u6625\u81ea\u6cbb\u65d7',
        '150724': '\u9102\u6e29\u514b\u65cf\u81ea\u6cbb\u65d7',
        '150725': '\u9648\u5df4\u5c14\u864e\u65d7',
        '150726': '\u65b0\u5df4\u5c14\u864e\u5de6\u65d7',
        '150727': '\u65b0\u5df4\u5c14\u864e\u53f3\u65d7',
        '150781': '\u6ee1\u6d32\u91cc\u5e02',
        '150782': '\u7259\u514b\u77f3\u5e02',
        '150783': '\u624e\u5170\u5c6f\u5e02',
        '150784': '\u989d\u5c14\u53e4\u7eb3\u5e02',
        '150785': '\u6839\u6cb3\u5e02',
        '150786': '\u5176\u5b83\u533a',
    },
    '0,150000,150800': {
        '150802': '\u4e34\u6cb3\u533a',
        '150821': '\u4e94\u539f\u53bf',
        '150822': '\u78f4\u53e3\u53bf',
        '150823': '\u4e4c\u62c9\u7279\u524d\u65d7',
        '150824': '\u4e4c\u62c9\u7279\u4e2d\u65d7',
        '150825': '\u4e4c\u62c9\u7279\u540e\u65d7',
        '150826': '\u676d\u9526\u540e\u65d7',
        '150827': '\u5176\u5b83\u533a',
    },
    '0,150000,150900': {
        '150902': '\u96c6\u5b81\u533a',
        '150921': '\u5353\u8d44\u53bf',
        '150922': '\u5316\u5fb7\u53bf',
        '150923': '\u5546\u90fd\u53bf',
        '150924': '\u5174\u548c\u53bf',
        '150925': '\u51c9\u57ce\u53bf',
        '150926': '\u5bdf\u54c8\u5c14\u53f3\u7ffc\u524d\u65d7',
        '150927': '\u5bdf\u54c8\u5c14\u53f3\u7ffc\u4e2d\u65d7',
        '150928': '\u5bdf\u54c8\u5c14\u53f3\u7ffc\u540e\u65d7',
        '150929': '\u56db\u5b50\u738b\u65d7',
        '150981': '\u4e30\u9547\u5e02',
        '150982': '\u5176\u5b83\u533a',
    },
    '0,150000,152200': {
        '152201': '\u4e4c\u5170\u6d69\u7279\u5e02',
        '152202': '\u963f\u5c14\u5c71\u5e02',
        '152221': '\u79d1\u5c14\u6c81\u53f3\u7ffc\u524d\u65d7',
        '152222': '\u79d1\u5c14\u6c81\u53f3\u7ffc\u4e2d\u65d7',
        '152223': '\u624e\u8d49\u7279\u65d7',
        '152224': '\u7a81\u6cc9\u53bf',
        '152225': '\u5176\u5b83\u533a',
    },
    '0,150000,152500': {
        '152501': '\u4e8c\u8fde\u6d69\u7279\u5e02',
        '152502': '\u9521\u6797\u6d69\u7279\u5e02',
        '152522': '\u963f\u5df4\u560e\u65d7',
        '152523': '\u82cf\u5c3c\u7279\u5de6\u65d7',
        '152524': '\u82cf\u5c3c\u7279\u53f3\u65d7',
        '152525': '\u4e1c\u4e4c\u73e0\u7a46\u6c81\u65d7',
        '152526': '\u897f\u4e4c\u73e0\u7a46\u6c81\u65d7',
        '152527': '\u592a\u4ec6\u5bfa\u65d7',
        '152528': '\u9576\u9ec4\u65d7',
        '152529': '\u6b63\u9576\u767d\u65d7',
        '152530': '\u6b63\u84dd\u65d7',
        '152531': '\u591a\u4f26\u53bf',
        '152532': '\u5176\u5b83\u533a',
    },
    '0,150000,152900': {
        '152921': '\u963f\u62c9\u5584\u5de6\u65d7',
        '152922': '\u963f\u62c9\u5584\u53f3\u65d7',
        '152923': '\u989d\u6d4e\u7eb3\u65d7',
        '152924': '\u5176\u5b83\u533a',
    },
    '0,210000': {
        '210100': '\u6c88\u9633\u5e02',
        '210200': '\u5927\u8fde\u5e02',
        '210300': '\u978d\u5c71\u5e02',
        '210400': '\u629a\u987a\u5e02',
        '210500': '\u672c\u6eaa\u5e02',
        '210600': '\u4e39\u4e1c\u5e02',
        '210700': '\u9526\u5dde\u5e02',
        '210800': '\u8425\u53e3\u5e02',
        '210900': '\u961c\u65b0\u5e02',
        '211000': '\u8fbd\u9633\u5e02',
        '211100': '\u76d8\u9526\u5e02',
        '211200': '\u94c1\u5cad\u5e02',
        '211300': '\u671d\u9633\u5e02',
        '211400': '\u846b\u82a6\u5c9b\u5e02',
    },
    '0,210000,210100': {
        '210102': '\u548c\u5e73\u533a',
        '210103': '\u6c88\u6cb3\u533a',
        '210104': '\u5927\u4e1c\u533a',
        '210105': '\u7687\u59d1\u533a',
        '210106': '\u94c1\u897f\u533a',
        '210111': '\u82cf\u5bb6\u5c6f\u533a',
        '210112': '\u4e1c\u9675\u533a',
        '210113': '\u65b0\u57ce\u5b50\u533a',
        '210114': '\u4e8e\u6d2a\u533a',
        '210122': '\u8fbd\u4e2d\u53bf',
        '210123': '\u5eb7\u5e73\u53bf',
        '210124': '\u6cd5\u5e93\u53bf',
        '210181': '\u65b0\u6c11\u5e02',
        '210182': '\u6d51\u5357\u65b0\u533a',
        '210183': '\u5f20\u58eb\u5f00\u53d1\u533a',
        '210184': '\u6c88\u5317\u65b0\u533a',
        '210185': '\u5176\u5b83\u533a',
    },
    '0,210000,210200': {
        '210202': '\u4e2d\u5c71\u533a',
        '210203': '\u897f\u5c97\u533a',
        '210204': '\u6c99\u6cb3\u53e3\u533a',
        '210211': '\u7518\u4e95\u5b50\u533a',
        '210212': '\u65c5\u987a\u53e3\u533a',
        '210213': '\u91d1\u5dde\u533a',
        '210224': '\u957f\u6d77\u53bf',
        '210251': '\u5f00\u53d1\u533a',
        '210281': '\u74e6\u623f\u5e97\u5e02',
        '210282': '\u666e\u5170\u5e97\u5e02',
        '210283': '\u5e84\u6cb3\u5e02',
        '210297': '\u5cad\u524d\u533a',
        '210298': '\u5176\u5b83\u533a',
    },
    '0,210000,210300': {
        '210302': '\u94c1\u4e1c\u533a',
        '210303': '\u94c1\u897f\u533a',
        '210304': '\u7acb\u5c71\u533a',
        '210311': '\u5343\u5c71\u533a',
        '210321': '\u53f0\u5b89\u53bf',
        '210323': '\u5cab\u5ca9\u6ee1\u65cf\u81ea\u6cbb\u53bf',
        '210351': '\u9ad8\u65b0\u533a',
        '210381': '\u6d77\u57ce\u5e02',
        '210382': '\u5176\u5b83\u533a',
    },
    '0,210000,210400': {
        '210402': '\u65b0\u629a\u533a',
        '210403': '\u4e1c\u6d32\u533a',
        '210404': '\u671b\u82b1\u533a',
        '210411': '\u987a\u57ce\u533a',
        '210421': '\u629a\u987a\u53bf',
        '210422': '\u65b0\u5bbe\u6ee1\u65cf\u81ea\u6cbb\u53bf',
        '210423': '\u6e05\u539f\u6ee1\u65cf\u81ea\u6cbb\u53bf',
        '210424': '\u5176\u5b83\u533a',
    },
    '0,210000,210500': {
        '210502': '\u5e73\u5c71\u533a',
        '210503': '\u6eaa\u6e56\u533a',
        '210504': '\u660e\u5c71\u533a',
        '210505': '\u5357\u82ac\u533a',
        '210521': '\u672c\u6eaa\u6ee1\u65cf\u81ea\u6cbb\u53bf',
        '210522': '\u6853\u4ec1\u6ee1\u65cf\u81ea\u6cbb\u53bf',
        '210523': '\u5176\u5b83\u533a',
    },
    '0,210000,210600': {
        '210602': '\u5143\u5b9d\u533a',
        '210603': '\u632f\u5174\u533a',
        '210604': '\u632f\u5b89\u533a',
        '210624': '\u5bbd\u7538\u6ee1\u65cf\u81ea\u6cbb\u53bf',
        '210681': '\u4e1c\u6e2f\u5e02',
        '210682': '\u51e4\u57ce\u5e02',
        '210683': '\u5176\u5b83\u533a',
    },
    '0,210000,210700': {
        '210702': '\u53e4\u5854\u533a',
        '210703': '\u51cc\u6cb3\u533a',
        '210711': '\u592a\u548c\u533a',
        '210726': '\u9ed1\u5c71\u53bf',
        '210727': '\u4e49\u53bf',
        '210781': '\u51cc\u6d77\u5e02',
        '210782': '\u5317\u9547\u5e02',
        '210783': '\u5176\u5b83\u533a',
    },
    '0,210000,210800': {
        '210802': '\u7ad9\u524d\u533a',
        '210803': '\u897f\u5e02\u533a',
        '210804': '\u9c85\u9c7c\u5708\u533a',
        '210811': '\u8001\u8fb9\u533a',
        '210881': '\u76d6\u5dde\u5e02',
        '210882': '\u5927\u77f3\u6865\u5e02',
        '210883': '\u5176\u5b83\u533a',
    },
    '0,210000,210900': {
        '210902': '\u6d77\u5dde\u533a',
        '210903': '\u65b0\u90b1\u533a',
        '210904': '\u592a\u5e73\u533a',
        '210905': '\u6e05\u6cb3\u95e8\u533a',
        '210911': '\u7ec6\u6cb3\u533a',
        '210921': '\u961c\u65b0\u8499\u53e4\u65cf\u81ea\u6cbb\u53bf',
        '210922': '\u5f70\u6b66\u53bf',
        '210923': '\u5176\u5b83\u533a',
    },
    '0,210000,211000': {
        '211002': '\u767d\u5854\u533a',
        '211003': '\u6587\u5723\u533a',
        '211004': '\u5b8f\u4f1f\u533a',
        '211005': '\u5f13\u957f\u5cad\u533a',
        '211011': '\u592a\u5b50\u6cb3\u533a',
        '211021': '\u8fbd\u9633\u53bf',
        '211081': '\u706f\u5854\u5e02',
        '211082': '\u5176\u5b83\u533a',
    },
    '0,210000,211100': {
        '211102': '\u53cc\u53f0\u5b50\u533a',
        '211103': '\u5174\u9686\u53f0\u533a',
        '211121': '\u5927\u6d3c\u53bf',
        '211122': '\u76d8\u5c71\u53bf',
        '211123': '\u5176\u5b83\u533a',
    },
    '0,210000,211200': {
        '211202': '\u94f6\u5dde\u533a',
        '211204': '\u6e05\u6cb3\u533a',
        '211221': '\u94c1\u5cad\u53bf',
        '211223': '\u897f\u4e30\u53bf',
        '211224': '\u660c\u56fe\u53bf',
        '211281': '\u8c03\u5175\u5c71\u5e02',
        '211282': '\u5f00\u539f\u5e02',
        '211283': '\u5176\u5b83\u533a',
    },
    '0,210000,211300': {
        '211302': '\u53cc\u5854\u533a',
        '211303': '\u9f99\u57ce\u533a',
        '211321': '\u671d\u9633\u53bf',
        '211322': '\u5efa\u5e73\u53bf',
        '211324': '\u5580\u5587\u6c81\u5de6\u7ffc\u8499\u53e4\u65cf\u81ea\u6cbb\u53bf',
        '211381': '\u5317\u7968\u5e02',
        '211382': '\u51cc\u6e90\u5e02',
        '211383': '\u5176\u5b83\u533a',
    },
    '0,210000,211400': {
        '211402': '\u8fde\u5c71\u533a',
        '211403': '\u9f99\u6e2f\u533a',
        '211404': '\u5357\u7968\u533a',
        '211421': '\u7ee5\u4e2d\u53bf',
        '211422': '\u5efa\u660c\u53bf',
        '211481': '\u5174\u57ce\u5e02',
        '211482': '\u5176\u5b83\u533a',
    },
    '0,220000': {
        '220100': '\u957f\u6625\u5e02',
        '220200': '\u5409\u6797\u5e02',
        '220300': '\u56db\u5e73\u5e02',
        '220400': '\u8fbd\u6e90\u5e02',
        '220500': '\u901a\u5316\u5e02',
        '220600': '\u767d\u5c71\u5e02',
        '220700': '\u677e\u539f\u5e02',
        '220800': '\u767d\u57ce\u5e02',
        '222400': '\u5ef6\u8fb9\u671d\u9c9c\u65cf\u81ea\u6cbb\u5dde',
    },
    '0,220000,220100': {
        '220102': '\u5357\u5173\u533a',
        '220103': '\u5bbd\u57ce\u533a',
        '220104': '\u671d\u9633\u533a',
        '220105': '\u4e8c\u9053\u533a',
        '220106': '\u7eff\u56ed\u533a',
        '220112': '\u53cc\u9633\u533a',
        '220122': '\u519c\u5b89\u53bf',
        '220181': '\u4e5d\u53f0\u5e02',
        '220182': '\u6986\u6811\u5e02',
        '220183': '\u5fb7\u60e0\u5e02',
        '220184': '\u9ad8\u65b0\u6280\u672f\u4ea7\u4e1a\u5f00\u53d1\u533a',
        '220185': '\u6c7d\u8f66\u4ea7\u4e1a\u5f00\u53d1\u533a',
        '220186': '\u7ecf\u6d4e\u6280\u672f\u5f00\u53d1\u533a',
        '220187': '\u51c0\u6708\u65c5\u6e38\u5f00\u53d1\u533a',
        '220188': '\u5176\u5b83\u533a',
    },
    '0,220000,220200': {
        '220202': '\u660c\u9091\u533a',
        '220203': '\u9f99\u6f6d\u533a',
        '220204': '\u8239\u8425\u533a',
        '220211': '\u4e30\u6ee1\u533a',
        '220221': '\u6c38\u5409\u53bf',
        '220281': '\u86df\u6cb3\u5e02',
        '220282': '\u6866\u7538\u5e02',
        '220283': '\u8212\u5170\u5e02',
        '220284': '\u78d0\u77f3\u5e02',
        '220285': '\u5176\u5b83\u533a',
    },
    '0,220000,220300': {
        '220302': '\u94c1\u897f\u533a',
        '220303': '\u94c1\u4e1c\u533a',
        '220322': '\u68a8\u6811\u53bf',
        '220323': '\u4f0a\u901a\u6ee1\u65cf\u81ea\u6cbb\u53bf',
        '220381': '\u516c\u4e3b\u5cad\u5e02',
        '220382': '\u53cc\u8fbd\u5e02',
        '220383': '\u5176\u5b83\u533a',
    },
    '0,220000,220400': {
        '220402': '\u9f99\u5c71\u533a',
        '220403': '\u897f\u5b89\u533a',
        '220421': '\u4e1c\u4e30\u53bf',
        '220422': '\u4e1c\u8fbd\u53bf',
        '220423': '\u5176\u5b83\u533a',
    },
    '0,220000,220500': {
        '220502': '\u4e1c\u660c\u533a',
        '220503': '\u4e8c\u9053\u6c5f\u533a',
        '220521': '\u901a\u5316\u53bf',
        '220523': '\u8f89\u5357\u53bf',
        '220524': '\u67f3\u6cb3\u53bf',
        '220581': '\u6885\u6cb3\u53e3\u5e02',
        '220582': '\u96c6\u5b89\u5e02',
        '220583': '\u5176\u5b83\u533a',
    },
    '0,220000,220600': {
        '220602': '\u516b\u9053\u6c5f\u533a',
        '220621': '\u629a\u677e\u53bf',
        '220622': '\u9756\u5b87\u53bf',
        '220623': '\u957f\u767d\u671d\u9c9c\u65cf\u81ea\u6cbb\u53bf',
        '220625': '\u6c5f\u6e90\u5e02',
        '220681': '\u4e34\u6c5f\u5e02',
        '220682': '\u5176\u5b83\u533a',
    },
    '0,220000,220700': {
        '220702': '\u5b81\u6c5f\u533a',
        '220721': '\u524d\u90ed\u5c14\u7f57\u65af\u8499\u53e4\u65cf\u81ea\u6cbb\u53bf',
        '220722': '\u957f\u5cad\u53bf',
        '220723': '\u4e7e\u5b89\u53bf',
        '220724': '\u6276\u4f59\u53bf',
        '220725': '\u5176\u5b83\u533a',
    },
    '0,220000,220800': {
        '220802': '\u6d2e\u5317\u533a',
        '220821': '\u9547\u8d49\u53bf',
        '220822': '\u901a\u6986\u53bf',
        '220881': '\u6d2e\u5357\u5e02',
        '220882': '\u5927\u5b89\u5e02',
        '220883': '\u5176\u5b83\u533a',
    },
    '0,220000,222400': {
        '222401': '\u5ef6\u5409\u5e02',
        '222402': '\u56fe\u4eec\u5e02',
        '222403': '\u6566\u5316\u5e02',
        '222404': '\u73f2\u6625\u5e02',
        '222405': '\u9f99\u4e95\u5e02',
        '222406': '\u548c\u9f99\u5e02',
        '222424': '\u6c6a\u6e05\u53bf',
        '222426': '\u5b89\u56fe\u53bf',
        '222427': '\u5176\u5b83\u533a',
    },
    '0,230000': {
        '230100': '\u54c8\u5c14\u6ee8\u5e02',
        '230200': '\u9f50\u9f50\u54c8\u5c14\u5e02',
        '230300': '\u9e21\u897f\u5e02',
        '230400': '\u9e64\u5c97\u5e02',
        '230500': '\u53cc\u9e2d\u5c71\u5e02',
        '230600': '\u5927\u5e86\u5e02',
        '230700': '\u4f0a\u6625\u5e02',
        '230800': '\u4f73\u6728\u65af\u5e02',
        '230900': '\u4e03\u53f0\u6cb3\u5e02',
        '231000': '\u7261\u4e39\u6c5f\u5e02',
        '231100': '\u9ed1\u6cb3\u5e02',
        '231200': '\u7ee5\u5316\u5e02',
        '232700': '\u5927\u5174\u5b89\u5cad\u5730\u533a',
    },
    '0,230000,230100': {
        '230102': '\u9053\u91cc\u533a',
        '230103': '\u5357\u5c97\u533a',
        '230104': '\u9053\u5916\u533a',
        '230106': '\u9999\u574a\u533a',
        '230107': '\u52a8\u529b\u533a',
        '230108': '\u5e73\u623f\u533a',
        '230109': '\u677e\u5317\u533a',
        '230111': '\u547c\u5170\u533a',
        '230123': '\u4f9d\u5170\u53bf',
        '230124': '\u65b9\u6b63\u53bf',
        '230125': '\u5bbe\u53bf',
        '230126': '\u5df4\u5f66\u53bf',
        '230127': '\u6728\u5170\u53bf',
        '230128': '\u901a\u6cb3\u53bf',
        '230129': '\u5ef6\u5bff\u53bf',
        '230181': '\u963f\u57ce\u5e02',
        '230182': '\u53cc\u57ce\u5e02',
        '230183': '\u5c1a\u5fd7\u5e02',
        '230184': '\u4e94\u5e38\u5e02',
        '230185': '\u963f\u57ce\u5e02',
        '230186': '\u5176\u5b83\u533a',
    },
    '0,230000,230200': {
        '230202': '\u9f99\u6c99\u533a',
        '230203': '\u5efa\u534e\u533a',
        '230204': '\u94c1\u950b\u533a',
        '230205': '\u6602\u6602\u6eaa\u533a',
        '230206': '\u5bcc\u62c9\u5c14\u57fa\u533a',
        '230207': '\u78be\u5b50\u5c71\u533a',
        '230208': '\u6885\u91cc\u65af\u8fbe\u65a1\u5c14\u65cf\u533a',
        '230221': '\u9f99\u6c5f\u53bf',
        '230223': '\u4f9d\u5b89\u53bf',
        '230224': '\u6cf0\u6765\u53bf',
        '230225': '\u7518\u5357\u53bf',
        '230227': '\u5bcc\u88d5\u53bf',
        '230229': '\u514b\u5c71\u53bf',
        '230230': '\u514b\u4e1c\u53bf',
        '230231': '\u62dc\u6cc9\u53bf',
        '230281': '\u8bb7\u6cb3\u5e02',
        '230282': '\u5176\u5b83\u533a',
    },
    '0,230000,230300': {
        '230302': '\u9e21\u51a0\u533a',
        '230303': '\u6052\u5c71\u533a',
        '230304': '\u6ef4\u9053\u533a',
        '230305': '\u68a8\u6811\u533a',
        '230306': '\u57ce\u5b50\u6cb3\u533a',
        '230307': '\u9ebb\u5c71\u533a',
        '230321': '\u9e21\u4e1c\u53bf',
        '230381': '\u864e\u6797\u5e02',
        '230382': '\u5bc6\u5c71\u5e02',
        '230383': '\u5176\u5b83\u533a',
    },
    '0,230000,230400': {
        '230402': '\u5411\u9633\u533a',
        '230403': '\u5de5\u519c\u533a',
        '230404': '\u5357\u5c71\u533a',
        '230405': '\u5174\u5b89\u533a',
        '230406': '\u4e1c\u5c71\u533a',
        '230407': '\u5174\u5c71\u533a',
        '230421': '\u841d\u5317\u53bf',
        '230422': '\u7ee5\u6ee8\u53bf',
        '230423': '\u5176\u5b83\u533a',
    },
    '0,230000,230500': {
        '230502': '\u5c16\u5c71\u533a',
        '230503': '\u5cad\u4e1c\u533a',
        '230505': '\u56db\u65b9\u53f0\u533a',
        '230506': '\u5b9d\u5c71\u533a',
        '230521': '\u96c6\u8d24\u53bf',
        '230522': '\u53cb\u8c0a\u53bf',
        '230523': '\u5b9d\u6e05\u53bf',
        '230524': '\u9976\u6cb3\u53bf',
        '230525': '\u5176\u5b83\u533a',
    },
    '0,230000,230600': {
        '230602': '\u8428\u5c14\u56fe\u533a',
        '230603': '\u9f99\u51e4\u533a',
        '230604': '\u8ba9\u80e1\u8def\u533a',
        '230605': '\u7ea2\u5c97\u533a',
        '230606': '\u5927\u540c\u533a',
        '230621': '\u8087\u5dde\u53bf',
        '230622': '\u8087\u6e90\u53bf',
        '230623': '\u6797\u7538\u53bf',
        '230624': '\u675c\u5c14\u4f2f\u7279\u8499\u53e4\u65cf\u81ea\u6cbb\u53bf',
        '230625': '\u5176\u5b83\u533a',
    },
    '0,230000,230700': {
        '230702': '\u4f0a\u6625\u533a',
        '230703': '\u5357\u5c94\u533a',
        '230704': '\u53cb\u597d\u533a',
        '230705': '\u897f\u6797\u533a',
        '230706': '\u7fe0\u5ce6\u533a',
        '230707': '\u65b0\u9752\u533a',
        '230708': '\u7f8e\u6eaa\u533a',
        '230709': '\u91d1\u5c71\u5c6f\u533a',
        '230710': '\u4e94\u8425\u533a',
        '230711': '\u4e4c\u9a6c\u6cb3\u533a',
        '230712': '\u6c64\u65fa\u6cb3\u533a',
        '230713': '\u5e26\u5cad\u533a',
        '230714': '\u4e4c\u4f0a\u5cad\u533a',
        '230715': '\u7ea2\u661f\u533a',
        '230716': '\u4e0a\u7518\u5cad\u533a',
        '230722': '\u5609\u836b\u53bf',
        '230781': '\u94c1\u529b\u5e02',
        '230782': '\u5176\u5b83\u533a',
    },
    '0,230000,230800': {
        '230802': '\u6c38\u7ea2\u533a',
        '230803': '\u5411\u9633\u533a',
        '230804': '\u524d\u8fdb\u533a',
        '230805': '\u4e1c\u98ce\u533a',
        '230811': '\u90ca\u533a',
        '230822': '\u6866\u5357\u53bf',
        '230826': '\u6866\u5ddd\u53bf',
        '230828': '\u6c64\u539f\u53bf',
        '230833': '\u629a\u8fdc\u53bf',
        '230881': '\u540c\u6c5f\u5e02',
        '230882': '\u5bcc\u9526\u5e02',
        '230883': '\u5176\u5b83\u533a',
    },
    '0,230000,230900': {
        '230902': '\u65b0\u5174\u533a',
        '230903': '\u6843\u5c71\u533a',
        '230904': '\u8304\u5b50\u6cb3\u533a',
        '230921': '\u52c3\u5229\u53bf',
        '230922': '\u5176\u5b83\u533a',
    },
    '0,230000,231000': {
        '231002': '\u4e1c\u5b89\u533a',
        '231003': '\u9633\u660e\u533a',
        '231004': '\u7231\u6c11\u533a',
        '231005': '\u897f\u5b89\u533a',
        '231024': '\u4e1c\u5b81\u53bf',
        '231025': '\u6797\u53e3\u53bf',
        '231081': '\u7ee5\u82ac\u6cb3\u5e02',
        '231083': '\u6d77\u6797\u5e02',
        '231084': '\u5b81\u5b89\u5e02',
        '231085': '\u7a46\u68f1\u5e02',
        '231086': '\u5176\u5b83\u533a',
    },
    '0,230000,231100': {
        '231102': '\u7231\u8f89\u533a',
        '231121': '\u5ae9\u6c5f\u53bf',
        '231123': '\u900a\u514b\u53bf',
        '231124': '\u5b59\u5434\u53bf',
        '231181': '\u5317\u5b89\u5e02',
        '231182': '\u4e94\u5927\u8fde\u6c60\u5e02',
        '231183': '\u5176\u5b83\u533a',
    },
    '0,230000,231200': {
        '231202': '\u5317\u6797\u533a',
        '231221': '\u671b\u594e\u53bf',
        '231222': '\u5170\u897f\u53bf',
        '231223': '\u9752\u5188\u53bf',
        '231224': '\u5e86\u5b89\u53bf',
        '231225': '\u660e\u6c34\u53bf',
        '231226': '\u7ee5\u68f1\u53bf',
        '231281': '\u5b89\u8fbe\u5e02',
        '231282': '\u8087\u4e1c\u5e02',
        '231283': '\u6d77\u4f26\u5e02',
        '231284': '\u5176\u5b83\u533a',
    },
    '0,230000,232700': {
        '232721': '\u547c\u739b\u53bf',
        '232722': '\u5854\u6cb3\u53bf',
        '232723': '\u6f20\u6cb3\u53bf',
        '232724': '\u52a0\u683c\u8fbe\u5947\u533a',
        '232725': '\u5176\u5b83\u533a',
    },
    '0,310000': {
        '310100': '\u4e0a\u6d77\u5e02',
    },
    '0,310000,310100': {
        '310101': '\u9ec4\u6d66\u533a',
        '310103': '\u5362\u6e7e\u533a',
        '310104': '\u5f90\u6c47\u533a',
        '310105': '\u957f\u5b81\u533a',
        '310106': '\u9759\u5b89\u533a',
        '310107': '\u666e\u9640\u533a',
        '310108': '\u95f8\u5317\u533a',
        '310109': '\u8679\u53e3\u533a',
        '310110': '\u6768\u6d66\u533a',
        '310112': '\u95f5\u884c\u533a',
        '310113': '\u5b9d\u5c71\u533a',
        '310114': '\u5609\u5b9a\u533a',
        '310115': '\u6d66\u4e1c\u65b0\u533a',
        '310116': '\u91d1\u5c71\u533a',
        '310117': '\u677e\u6c5f\u533a',
        '310118': '\u9752\u6d66\u533a',
        '310119': '\u5357\u6c47\u533a',
        '310120': '\u5949\u8d24\u533a',
        '310152': '\u5ddd\u6c99\u533a',
        '310230': '\u5d07\u660e\u53bf',
        '310231': '\u5176\u5b83\u533a',
    },
    '0,320000': {
        '320100': '\u5357\u4eac\u5e02',
        '320200': '\u65e0\u9521\u5e02',
        '320300': '\u5f90\u5dde\u5e02',
        '320400': '\u5e38\u5dde\u5e02',
        '320500': '\u82cf\u5dde\u5e02',
        '320600': '\u5357\u901a\u5e02',
        '320700': '\u8fde\u4e91\u6e2f\u5e02',
        '320800': '\u6dee\u5b89\u5e02',
        '320900': '\u76d0\u57ce\u5e02',
        '321000': '\u626c\u5dde\u5e02',
        '321100': '\u9547\u6c5f\u5e02',
        '321200': '\u6cf0\u5dde\u5e02',
        '321300': '\u5bbf\u8fc1\u5e02',
    },
    '0,320000,320100': {
        '320102': '\u7384\u6b66\u533a',
        '320103': '\u767d\u4e0b\u533a',
        '320104': '\u79e6\u6dee\u533a',
        '320105': '\u5efa\u90ba\u533a',
        '320106': '\u9f13\u697c\u533a',
        '320107': '\u4e0b\u5173\u533a',
        '320111': '\u6d66\u53e3\u533a',
        '320113': '\u6816\u971e\u533a',
        '320114': '\u96e8\u82b1\u53f0\u533a',
        '320115': '\u6c5f\u5b81\u533a',
        '320116': '\u516d\u5408\u533a',
        '320124': '\u6ea7\u6c34\u53bf',
        '320125': '\u9ad8\u6df3\u53bf',
        '320126': '\u5176\u5b83\u533a',
    },
    '0,320000,320200': {
        '320202': '\u5d07\u5b89\u533a',
        '320203': '\u5357\u957f\u533a',
        '320204': '\u5317\u5858\u533a',
        '320205': '\u9521\u5c71\u533a',
        '320206': '\u60e0\u5c71\u533a',
        '320211': '\u6ee8\u6e56\u533a',
        '320281': '\u6c5f\u9634\u5e02',
        '320282': '\u5b9c\u5174\u5e02',
        '320296': '\u65b0\u533a',
        '320297': '\u5176\u5b83\u533a',
    },
    '0,320000,320300': {
        '320302': '\u9f13\u697c\u533a',
        '320303': '\u4e91\u9f99\u533a',
        '320304': '\u4e5d\u91cc\u533a',
        '320305': '\u8d3e\u6c6a\u533a',
        '320311': '\u6cc9\u5c71\u533a',
        '320321': '\u4e30\u53bf',
        '320322': '\u6c9b\u53bf',
        '320323': '\u94dc\u5c71\u53bf',
        '320324': '\u7762\u5b81\u53bf',
        '320381': '\u65b0\u6c82\u5e02',
        '320382': '\u90b3\u5dde\u5e02',
        '320383': '\u5176\u5b83\u533a',
    },
    '0,320000,320400': {
        '320402': '\u5929\u5b81\u533a',
        '320404': '\u949f\u697c\u533a',
        '320405': '\u621a\u5885\u5830\u533a',
        '320411': '\u65b0\u5317\u533a',
        '320412': '\u6b66\u8fdb\u533a',
        '320481': '\u6ea7\u9633\u5e02',
        '320482': '\u91d1\u575b\u5e02',
        '320483': '\u5176\u5b83\u533a',
    },
    '0,320000,320500': {
        '320502': '\u6ca7\u6d6a\u533a',
        '320503': '\u5e73\u6c5f\u533a',
        '320504': '\u91d1\u960a\u533a',
        '320505': '\u864e\u4e18\u533a',
        '320506': '\u5434\u4e2d\u533a',
        '320507': '\u76f8\u57ce\u533a',
        '320581': '\u5e38\u719f\u5e02',
        '320582': '\u5f20\u5bb6\u6e2f\u5e02',
        '320583': '\u6606\u5c71\u5e02',
        '320584': '\u5434\u6c5f\u5e02',
        '320585': '\u592a\u4ed3\u5e02',
        '320594': '\u65b0\u533a',
        '320595': '\u56ed\u533a',
        '320596': '\u5176\u5b83\u533a',
    },
    '0,320000,320600': {
        '320602': '\u5d07\u5ddd\u533a',
        '320611': '\u6e2f\u95f8\u533a',
        '320612': '\u901a\u5dde\u533a',
        '320621': '\u6d77\u5b89\u53bf',
        '320623': '\u5982\u4e1c\u53bf',
        '320681': '\u542f\u4e1c\u5e02',
        '320682': '\u5982\u768b\u5e02',
        '320683': '\u901a\u5dde\u5e02',
        '320684': '\u6d77\u95e8\u5e02',
        '320693': '\u5f00\u53d1\u533a',
        '320694': '\u5176\u5b83\u533a',
    },
    '0,320000,320700': {
        '320703': '\u8fde\u4e91\u533a',
        '320705': '\u65b0\u6d66\u533a',
        '320706': '\u6d77\u5dde\u533a',
        '320721': '\u8d63\u6986\u53bf',
        '320722': '\u4e1c\u6d77\u53bf',
        '320723': '\u704c\u4e91\u53bf',
        '320724': '\u704c\u5357\u53bf',
        '320725': '\u5176\u5b83\u533a',
    },
    '0,320000,320800': {
        '320802': '\u6e05\u6cb3\u533a',
        '320803': '\u695a\u5dde\u533a',
        '320804': '\u6dee\u9634\u533a',
        '320811': '\u6e05\u6d66\u533a',
        '320826': '\u6d9f\u6c34\u53bf',
        '320829': '\u6d2a\u6cfd\u53bf',
        '320830': '\u76f1\u7719\u53bf',
        '320831': '\u91d1\u6e56\u53bf',
        '320832': '\u5176\u5b83\u533a',
    },
    '0,320000,320900': {
        '320902': '\u4ead\u6e56\u533a',
        '320903': '\u76d0\u90fd\u533a',
        '320921': '\u54cd\u6c34\u53bf',
        '320922': '\u6ee8\u6d77\u53bf',
        '320923': '\u961c\u5b81\u53bf',
        '320924': '\u5c04\u9633\u53bf',
        '320925': '\u5efa\u6e56\u53bf',
        '320981': '\u4e1c\u53f0\u5e02',
        '320982': '\u5927\u4e30\u5e02',
        '320983': '\u5176\u5b83\u533a',
    },
    '0,320000,321000': {
        '321002': '\u5e7f\u9675\u533a',
        '321003': '\u9097\u6c5f\u533a',
        '321011': '\u7ef4\u626c\u533a',
        '321023': '\u5b9d\u5e94\u53bf',
        '321081': '\u4eea\u5f81\u5e02',
        '321084': '\u9ad8\u90ae\u5e02',
        '321088': '\u6c5f\u90fd\u5e02',
        '321092': '\u7ecf\u6d4e\u5f00\u53d1\u533a',
        '321093': '\u5176\u5b83\u533a',
    },
    '0,320000,321100': {
        '321102': '\u4eac\u53e3\u533a',
        '321111': '\u6da6\u5dde\u533a',
        '321112': '\u4e39\u5f92\u533a',
        '321181': '\u4e39\u9633\u5e02',
        '321182': '\u626c\u4e2d\u5e02',
        '321183': '\u53e5\u5bb9\u5e02',
        '321184': '\u5176\u5b83\u533a',
    },
    '0,320000,321200': {
        '321202': '\u6d77\u9675\u533a',
        '321203': '\u9ad8\u6e2f\u533a',
        '321281': '\u5174\u5316\u5e02',
        '321282': '\u9756\u6c5f\u5e02',
        '321283': '\u6cf0\u5174\u5e02',
        '321284': '\u59dc\u5830\u5e02',
        '321285': '\u5176\u5b83\u533a',
    },
    '0,320000,321300': {
        '321302': '\u5bbf\u57ce\u533a',
        '321311': '\u5bbf\u8c6b\u533a',
        '321322': '\u6cad\u9633\u53bf',
        '321323': '\u6cd7\u9633\u53bf',
        '321324': '\u6cd7\u6d2a\u53bf',
        '321325': '\u5176\u5b83\u533a',
    },
    '0,330000': {
        '330100': '\u676d\u5dde\u5e02',
        '330200': '\u5b81\u6ce2\u5e02',
        '330300': '\u6e29\u5dde\u5e02',
        '330400': '\u5609\u5174\u5e02',
        '330500': '\u6e56\u5dde\u5e02',
        '330600': '\u7ecd\u5174\u5e02',
        '330700': '\u91d1\u534e\u5e02',
        '330800': '\u8862\u5dde\u5e02',
        '330900': '\u821f\u5c71\u5e02',
        '331000': '\u53f0\u5dde\u5e02',
        '331100': '\u4e3d\u6c34\u5e02',
    },
    '0,330000,330100': {
        '330102': '\u4e0a\u57ce\u533a',
        '330103': '\u4e0b\u57ce\u533a',
        '330104': '\u6c5f\u5e72\u533a',
        '330105': '\u62f1\u5885\u533a',
        '330106': '\u897f\u6e56\u533a',
        '330108': '\u6ee8\u6c5f\u533a',
        '330109': '\u8427\u5c71\u533a',
        '330110': '\u4f59\u676d\u533a',
        '330122': '\u6850\u5e90\u53bf',
        '330127': '\u6df3\u5b89\u53bf',
        '330182': '\u5efa\u5fb7\u5e02',
        '330183': '\u5bcc\u9633\u5e02',
        '330185': '\u4e34\u5b89\u5e02',
        '330186': '\u5176\u5b83\u533a',
    },
    '0,330000,330200': {
        '330203': '\u6d77\u66d9\u533a',
        '330204': '\u6c5f\u4e1c\u533a',
        '330205': '\u6c5f\u5317\u533a',
        '330206': '\u5317\u4ed1\u533a',
        '330211': '\u9547\u6d77\u533a',
        '330212': '\u911e\u5dde\u533a',
        '330225': '\u8c61\u5c71\u53bf',
        '330226': '\u5b81\u6d77\u53bf',
        '330281': '\u4f59\u59da\u5e02',
        '330282': '\u6148\u6eaa\u5e02',
        '330283': '\u5949\u5316\u5e02',
        '330284': '\u5176\u5b83\u533a',
    },
    '0,330000,330300': {
        '330302': '\u9e7f\u57ce\u533a',
        '330303': '\u9f99\u6e7e\u533a',
        '330304': '\u74ef\u6d77\u533a',
        '330322': '\u6d1e\u5934\u53bf',
        '330324': '\u6c38\u5609\u53bf',
        '330326': '\u5e73\u9633\u53bf',
        '330327': '\u82cd\u5357\u53bf',
        '330328': '\u6587\u6210\u53bf',
        '330329': '\u6cf0\u987a\u53bf',
        '330381': '\u745e\u5b89\u5e02',
        '330382': '\u4e50\u6e05\u5e02',
        '330383': '\u5176\u5b83\u533a',
    },
    '0,330000,330400': {
        '330402': '\u5357\u6e56\u533a',
        '330411': '\u79c0\u6d32\u533a',
        '330421': '\u5609\u5584\u53bf',
        '330424': '\u6d77\u76d0\u53bf',
        '330481': '\u6d77\u5b81\u5e02',
        '330482': '\u5e73\u6e56\u5e02',
        '330483': '\u6850\u4e61\u5e02',
        '330484': '\u5176\u5b83\u533a',
    },
    '0,330000,330500': {
        '330502': '\u5434\u5174\u533a',
        '330503': '\u5357\u6d54\u533a',
        '330521': '\u5fb7\u6e05\u53bf',
        '330522': '\u957f\u5174\u53bf',
        '330523': '\u5b89\u5409\u53bf',
        '330524': '\u5176\u5b83\u533a',
    },
    '0,330000,330600': {
        '330602': '\u8d8a\u57ce\u533a',
        '330621': '\u7ecd\u5174\u53bf',
        '330624': '\u65b0\u660c\u53bf',
        '330681': '\u8bf8\u66a8\u5e02',
        '330682': '\u4e0a\u865e\u5e02',
        '330683': '\u5d4a\u5dde\u5e02',
        '330684': '\u5176\u5b83\u533a',
    },
    '0,330000,330700': {
        '330702': '\u5a7a\u57ce\u533a',
        '330703': '\u91d1\u4e1c\u533a',
        '330723': '\u6b66\u4e49\u53bf',
        '330726': '\u6d66\u6c5f\u53bf',
        '330727': '\u78d0\u5b89\u53bf',
        '330781': '\u5170\u6eaa\u5e02',
        '330782': '\u4e49\u4e4c\u5e02',
        '330783': '\u4e1c\u9633\u5e02',
        '330784': '\u6c38\u5eb7\u5e02',
        '330785': '\u5176\u5b83\u533a',
    },
    '0,330000,330800': {
        '330802': '\u67ef\u57ce\u533a',
        '330803': '\u8862\u6c5f\u533a',
        '330822': '\u5e38\u5c71\u53bf',
        '330824': '\u5f00\u5316\u53bf',
        '330825': '\u9f99\u6e38\u53bf',
        '330881': '\u6c5f\u5c71\u5e02',
        '330882': '\u5176\u5b83\u533a',
    },
    '0,330000,330900': {
        '330902': '\u5b9a\u6d77\u533a',
        '330903': '\u666e\u9640\u533a',
        '330921': '\u5cb1\u5c71\u53bf',
        '330922': '\u5d4a\u6cd7\u53bf',
        '330923': '\u5176\u5b83\u533a',
    },
    '0,330000,331000': {
        '331002': '\u6912\u6c5f\u533a',
        '331003': '\u9ec4\u5ca9\u533a',
        '331004': '\u8def\u6865\u533a',
        '331021': '\u7389\u73af\u53bf',
        '331022': '\u4e09\u95e8\u53bf',
        '331023': '\u5929\u53f0\u53bf',
        '331024': '\u4ed9\u5c45\u53bf',
        '331081': '\u6e29\u5cad\u5e02',
        '331082': '\u4e34\u6d77\u5e02',
        '331083': '\u5176\u5b83\u533a',
    },
    '0,330000,331100': {
        '331102': '\u83b2\u90fd\u533a',
        '331121': '\u9752\u7530\u53bf',
        '331122': '\u7f19\u4e91\u53bf',
        '331123': '\u9042\u660c\u53bf',
        '331124': '\u677e\u9633\u53bf',
        '331125': '\u4e91\u548c\u53bf',
        '331126': '\u5e86\u5143\u53bf',
        '331127': '\u666f\u5b81\u7572\u65cf\u81ea\u6cbb\u53bf',
        '331181': '\u9f99\u6cc9\u5e02',
        '331182': '\u5176\u5b83\u533a',
    },
    '0,340000': {
        '340100': '\u5408\u80a5\u5e02',
        '340200': '\u829c\u6e56\u5e02',
        '340300': '\u868c\u57e0\u5e02',
        '340400': '\u6dee\u5357\u5e02',
        '340500': '\u9a6c\u978d\u5c71\u5e02',
        '340600': '\u6dee\u5317\u5e02',
        '340700': '\u94dc\u9675\u5e02',
        '340800': '\u5b89\u5e86\u5e02',
        '341000': '\u9ec4\u5c71\u5e02',
        '341100': '\u6ec1\u5dde\u5e02',
        '341200': '\u961c\u9633\u5e02',
        '341300': '\u5bbf\u5dde\u5e02',
        '341500': '\u516d\u5b89\u5e02',
        '341600': '\u4eb3\u5dde\u5e02',
        '341700': '\u6c60\u5dde\u5e02',
        '341800': '\u5ba3\u57ce\u5e02',
    },
    '0,340000,340100': {
        '340102': '\u7476\u6d77\u533a',
        '340103': '\u5e90\u9633\u533a',
        '340104': '\u8700\u5c71\u533a',
        '340111': '\u5305\u6cb3\u533a',
        '340121': '\u957f\u4e30\u53bf',
        '340122': '\u80a5\u4e1c\u53bf',
        '340123': '\u80a5\u897f\u53bf',
        '340151': '\u9ad8\u65b0\u533a',
        '340191': '\u4e2d\u533a',
        '340192': '\u5176\u5b83\u533a',
        '341400': '\u5de2\u6e56\u5e02',
        '341402': '\u5c45\u5de2\u533a',
        '341421': '\u5e90\u6c5f\u53bf',
    },
    '0,340000,340200': {
        '340202': '\u955c\u6e56\u533a',
        '340203': '\u5f0b\u6c5f\u533a',
        '340207': '\u9e20\u6c5f\u533a',
        '340208': '\u4e09\u5c71\u533a',
        '340221': '\u829c\u6e56\u53bf',
        '340222': '\u7e41\u660c\u53bf',
        '340223': '\u5357\u9675\u53bf',
        '340224': '\u5176\u5b83\u533a',
        '341422': '\u65e0\u4e3a\u53bf',
    },
    '0,340000,340300': {
        '340302': '\u9f99\u5b50\u6e56\u533a',
        '340303': '\u868c\u5c71\u533a',
        '340304': '\u79b9\u4f1a\u533a',
        '340311': '\u6dee\u4e0a\u533a',
        '340321': '\u6000\u8fdc\u53bf',
        '340322': '\u4e94\u6cb3\u53bf',
        '340323': '\u56fa\u9547\u53bf',
        '340324': '\u5176\u5b83\u533a',
    },
    '0,340000,340400': {
        '340402': '\u5927\u901a\u533a',
        '340403': '\u7530\u5bb6\u5eb5\u533a',
        '340404': '\u8c22\u5bb6\u96c6\u533a',
        '340405': '\u516b\u516c\u5c71\u533a',
        '340406': '\u6f58\u96c6\u533a',
        '340421': '\u51e4\u53f0\u53bf',
        '340422': '\u5176\u5b83\u533a',
    },
    '0,340000,340500': {
        '340502': '\u91d1\u5bb6\u5e84\u533a',
        '340503': '\u82b1\u5c71\u533a',
        '340504': '\u96e8\u5c71\u533a',
        '340521': '\u5f53\u6d82\u53bf',
        '340522': '\u5176\u5b83\u533a',
        '341423': '\u542b\u5c71\u53bf',
        '341424': '\u548c\u53bf',
    },
    '0,340000,340600': {
        '340602': '\u675c\u96c6\u533a',
        '340603': '\u76f8\u5c71\u533a',
        '340604': '\u70c8\u5c71\u533a',
        '340621': '\u6fc9\u6eaa\u53bf',
        '340622': '\u5176\u5b83\u533a',
    },
    '0,340000,340700': {
        '340702': '\u94dc\u5b98\u5c71\u533a',
        '340703': '\u72ee\u5b50\u5c71\u533a',
        '340711': '\u90ca\u533a',
        '340721': '\u94dc\u9675\u53bf',
        '340722': '\u5176\u5b83\u533a',
    },
    '0,340000,340800': {
        '340802': '\u8fce\u6c5f\u533a',
        '340803': '\u5927\u89c2\u533a',
        '340811': '\u5b9c\u79c0\u533a',
        '340822': '\u6000\u5b81\u53bf',
        '340823': '\u679e\u9633\u53bf',
        '340824': '\u6f5c\u5c71\u53bf',
        '340825': '\u592a\u6e56\u53bf',
        '340826': '\u5bbf\u677e\u53bf',
        '340827': '\u671b\u6c5f\u53bf',
        '340828': '\u5cb3\u897f\u53bf',
        '340881': '\u6850\u57ce\u5e02',
        '340882': '\u5176\u5b83\u533a',
    },
    '0,340000,341000': {
        '341002': '\u5c6f\u6eaa\u533a',
        '341003': '\u9ec4\u5c71\u533a',
        '341004': '\u5fbd\u5dde\u533a',
        '341021': '\u6b59\u53bf',
        '341022': '\u4f11\u5b81\u53bf',
        '341023': '\u9edf\u53bf',
        '341024': '\u7941\u95e8\u53bf',
        '341025': '\u5176\u5b83\u533a',
    },
    '0,340000,341100': {
        '341102': '\u7405\u740a\u533a',
        '341103': '\u5357\u8c2f\u533a',
        '341122': '\u6765\u5b89\u53bf',
        '341124': '\u5168\u6912\u53bf',
        '341125': '\u5b9a\u8fdc\u53bf',
        '341126': '\u51e4\u9633\u53bf',
        '341181': '\u5929\u957f\u5e02',
        '341182': '\u660e\u5149\u5e02',
        '341183': '\u5176\u5b83\u533a',
    },
    '0,340000,341200': {
        '341202': '\u988d\u5dde\u533a',
        '341203': '\u988d\u4e1c\u533a',
        '341204': '\u988d\u6cc9\u533a',
        '341221': '\u4e34\u6cc9\u53bf',
        '341222': '\u592a\u548c\u53bf',
        '341225': '\u961c\u5357\u53bf',
        '341226': '\u988d\u4e0a\u53bf',
        '341282': '\u754c\u9996\u5e02',
        '341283': '\u5176\u5b83\u533a',
    },
    '0,340000,341300': {
        '341302': '\u57c7\u6865\u533a',
        '341321': '\u7800\u5c71\u53bf',
        '341322': '\u8427\u53bf',
        '341323': '\u7075\u74a7\u53bf',
        '341324': '\u6cd7\u53bf',
        '341325': '\u5176\u5b83\u533a',
    },
    '0,340000,341500': {
        '341502': '\u91d1\u5b89\u533a',
        '341503': '\u88d5\u5b89\u533a',
        '341521': '\u5bff\u53bf',
        '341522': '\u970d\u90b1\u53bf',
        '341523': '\u8212\u57ce\u53bf',
        '341524': '\u91d1\u5be8\u53bf',
        '341525': '\u970d\u5c71\u53bf',
        '341526': '\u5176\u5b83\u533a',
    },
    '0,340000,341600': {
        '341602': '\u8c2f\u57ce\u533a',
        '341621': '\u6da1\u9633\u53bf',
        '341622': '\u8499\u57ce\u53bf',
        '341623': '\u5229\u8f9b\u53bf',
        '341624': '\u5176\u5b83\u533a',
    },
    '0,340000,341700': {
        '341702': '\u8d35\u6c60\u533a',
        '341721': '\u4e1c\u81f3\u53bf',
        '341722': '\u77f3\u53f0\u53bf',
        '341723': '\u9752\u9633\u53bf',
        '341724': '\u5176\u5b83\u533a',
    },
    '0,340000,341800': {
        '341802': '\u5ba3\u5dde\u533a',
        '341821': '\u90ce\u6eaa\u53bf',
        '341822': '\u5e7f\u5fb7\u53bf',
        '341823': '\u6cfe\u53bf',
        '341824': '\u7ee9\u6eaa\u53bf',
        '341825': '\u65cc\u5fb7\u53bf',
        '341881': '\u5b81\u56fd\u5e02',
        '341882': '\u5176\u5b83\u533a',
    },
    '0,350000': {
        '350100': '\u798f\u5dde\u5e02',
        '350200': '\u53a6\u95e8\u5e02',
        '350300': '\u8386\u7530\u5e02',
        '350400': '\u4e09\u660e\u5e02',
        '350500': '\u6cc9\u5dde\u5e02',
        '350600': '\u6f33\u5dde\u5e02',
        '350700': '\u5357\u5e73\u5e02',
        '350800': '\u9f99\u5ca9\u5e02',
        '350900': '\u5b81\u5fb7\u5e02',
    },
    '0,350000,350100': {
        '350102': '\u9f13\u697c\u533a',
        '350103': '\u53f0\u6c5f\u533a',
        '350104': '\u4ed3\u5c71\u533a',
        '350105': '\u9a6c\u5c3e\u533a',
        '350111': '\u664b\u5b89\u533a',
        '350121': '\u95fd\u4faf\u53bf',
        '350122': '\u8fde\u6c5f\u53bf',
        '350123': '\u7f57\u6e90\u53bf',
        '350124': '\u95fd\u6e05\u53bf',
        '350125': '\u6c38\u6cf0\u53bf',
        '350128': '\u5e73\u6f6d\u53bf',
        '350181': '\u798f\u6e05\u5e02',
        '350182': '\u957f\u4e50\u5e02',
        '350183': '\u5176\u5b83\u533a',
    },
    '0,350000,350200': {
        '350203': '\u601d\u660e\u533a',
        '350205': '\u6d77\u6ca7\u533a',
        '350206': '\u6e56\u91cc\u533a',
        '350211': '\u96c6\u7f8e\u533a',
        '350212': '\u540c\u5b89\u533a',
        '350213': '\u7fd4\u5b89\u533a',
        '350214': '\u5176\u5b83\u533a',
    },
    '0,350000,350300': {
        '350302': '\u57ce\u53a2\u533a',
        '350303': '\u6db5\u6c5f\u533a',
        '350304': '\u8354\u57ce\u533a',
        '350305': '\u79c0\u5c7f\u533a',
        '350322': '\u4ed9\u6e38\u53bf',
        '350323': '\u5176\u5b83\u533a',
    },
    '0,350000,350400': {
        '350402': '\u6885\u5217\u533a',
        '350403': '\u4e09\u5143\u533a',
        '350421': '\u660e\u6eaa\u53bf',
        '350423': '\u6e05\u6d41\u53bf',
        '350424': '\u5b81\u5316\u53bf',
        '350425': '\u5927\u7530\u53bf',
        '350426': '\u5c24\u6eaa\u53bf',
        '350427': '\u6c99\u53bf',
        '350428': '\u5c06\u4e50\u53bf',
        '350429': '\u6cf0\u5b81\u53bf',
        '350430': '\u5efa\u5b81\u53bf',
        '350481': '\u6c38\u5b89\u5e02',
        '350482': '\u5176\u5b83\u533a',
    },
    '0,350000,350500': {
        '350502': '\u9ca4\u57ce\u533a',
        '350503': '\u4e30\u6cfd\u533a',
        '350504': '\u6d1b\u6c5f\u533a',
        '350505': '\u6cc9\u6e2f\u533a',
        '350521': '\u60e0\u5b89\u53bf',
        '350524': '\u5b89\u6eaa\u53bf',
        '350525': '\u6c38\u6625\u53bf',
        '350526': '\u5fb7\u5316\u53bf',
        '350527': '\u91d1\u95e8\u53bf',
        '350581': '\u77f3\u72ee\u5e02',
        '350582': '\u664b\u6c5f\u5e02',
        '350583': '\u5357\u5b89\u5e02',
        '350584': '\u5176\u5b83\u533a',
    },
    '0,350000,350600': {
        '350602': '\u8297\u57ce\u533a',
        '350603': '\u9f99\u6587\u533a',
        '350622': '\u4e91\u9704\u53bf',
        '350623': '\u6f33\u6d66\u53bf',
        '350624': '\u8bcf\u5b89\u53bf',
        '350625': '\u957f\u6cf0\u53bf',
        '350626': '\u4e1c\u5c71\u53bf',
        '350627': '\u5357\u9756\u53bf',
        '350628': '\u5e73\u548c\u53bf',
        '350629': '\u534e\u5b89\u53bf',
        '350681': '\u9f99\u6d77\u5e02',
        '350682': '\u5176\u5b83\u533a',
    },
    '0,350000,350700': {
        '350702': '\u5ef6\u5e73\u533a',
        '350721': '\u987a\u660c\u53bf',
        '350722': '\u6d66\u57ce\u53bf',
        '350723': '\u5149\u6cfd\u53bf',
        '350724': '\u677e\u6eaa\u53bf',
        '350725': '\u653f\u548c\u53bf',
        '350781': '\u90b5\u6b66\u5e02',
        '350782': '\u6b66\u5937\u5c71\u5e02',
        '350783': '\u5efa\u74ef\u5e02',
        '350784': '\u5efa\u9633\u5e02',
        '350785': '\u5176\u5b83\u533a',
    },
    '0,350000,350800': {
        '350802': '\u65b0\u7f57\u533a',
        '350821': '\u957f\u6c40\u53bf',
        '350822': '\u6c38\u5b9a\u53bf',
        '350823': '\u4e0a\u676d\u53bf',
        '350824': '\u6b66\u5e73\u53bf',
        '350825': '\u8fde\u57ce\u53bf',
        '350881': '\u6f33\u5e73\u5e02',
        '350882': '\u5176\u5b83\u533a',
    },
    '0,350000,350900': {
        '350902': '\u8549\u57ce\u533a',
        '350921': '\u971e\u6d66\u53bf',
        '350922': '\u53e4\u7530\u53bf',
        '350923': '\u5c4f\u5357\u53bf',
        '350924': '\u5bff\u5b81\u53bf',
        '350925': '\u5468\u5b81\u53bf',
        '350926': '\u67d8\u8363\u53bf',
        '350981': '\u798f\u5b89\u5e02',
        '350982': '\u798f\u9f0e\u5e02',
        '350983': '\u5176\u5b83\u533a',
    },
    '0,360000': {
        '360100': '\u5357\u660c\u5e02',
        '360200': '\u666f\u5fb7\u9547\u5e02',
        '360300': '\u840d\u4e61\u5e02',
        '360400': '\u4e5d\u6c5f\u5e02',
        '360500': '\u65b0\u4f59\u5e02',
        '360600': '\u9e70\u6f6d\u5e02',
        '360700': '\u8d63\u5dde\u5e02',
        '360800': '\u5409\u5b89\u5e02',
        '360900': '\u5b9c\u6625\u5e02',
        '361000': '\u629a\u5dde\u5e02',
        '361100': '\u4e0a\u9976\u5e02',
    },
    '0,360000,360100': {
        '360102': '\u4e1c\u6e56\u533a',
        '360103': '\u897f\u6e56\u533a',
        '360104': '\u9752\u4e91\u8c31\u533a',
        '360105': '\u6e7e\u91cc\u533a',
        '360111': '\u9752\u5c71\u6e56\u533a',
        '360121': '\u5357\u660c\u53bf',
        '360122': '\u65b0\u5efa\u53bf',
        '360123': '\u5b89\u4e49\u53bf',
        '360124': '\u8fdb\u8d24\u53bf',
        '360125': '\u7ea2\u8c37\u6ee9\u65b0\u533a',
        '360126': '\u7ecf\u6d4e\u6280\u672f\u5f00\u53d1\u533a',
        '360127': '\u660c\u5317\u533a',
        '360128': '\u5176\u5b83\u533a',
    },
    '0,360000,360200': {
        '360202': '\u660c\u6c5f\u533a',
        '360203': '\u73e0\u5c71\u533a',
        '360222': '\u6d6e\u6881\u53bf',
        '360281': '\u4e50\u5e73\u5e02',
        '360282': '\u5176\u5b83\u533a',
    },
    '0,360000,360300': {
        '360302': '\u5b89\u6e90\u533a',
        '360313': '\u6e58\u4e1c\u533a',
        '360321': '\u83b2\u82b1\u53bf',
        '360322': '\u4e0a\u6817\u53bf',
        '360323': '\u82a6\u6eaa\u53bf',
        '360324': '\u5176\u5b83\u533a',
    },
    '0,360000,360400': {
        '360402': '\u5e90\u5c71\u533a',
        '360403': '\u6d54\u9633\u533a',
        '360421': '\u4e5d\u6c5f\u53bf',
        '360423': '\u6b66\u5b81\u53bf',
        '360424': '\u4fee\u6c34\u53bf',
        '360425': '\u6c38\u4fee\u53bf',
        '360426': '\u5fb7\u5b89\u53bf',
        '360427': '\u661f\u5b50\u53bf',
        '360428': '\u90fd\u660c\u53bf',
        '360429': '\u6e56\u53e3\u53bf',
        '360430': '\u5f6d\u6cfd\u53bf',
        '360481': '\u745e\u660c\u5e02',
        '360482': '\u5176\u5b83\u533a',
    },
    '0,360000,360500': {
        '360502': '\u6e1d\u6c34\u533a',
        '360521': '\u5206\u5b9c\u53bf',
        '360522': '\u5176\u5b83\u533a',
    },
    '0,360000,360600': {
        '360602': '\u6708\u6e56\u533a',
        '360622': '\u4f59\u6c5f\u53bf',
        '360681': '\u8d35\u6eaa\u5e02',
        '360682': '\u5176\u5b83\u533a',
    },
    '0,360000,360700': {
        '360702': '\u7ae0\u8d21\u533a',
        '360721': '\u8d63\u53bf',
        '360722': '\u4fe1\u4e30\u53bf',
        '360723': '\u5927\u4f59\u53bf',
        '360724': '\u4e0a\u72b9\u53bf',
        '360725': '\u5d07\u4e49\u53bf',
        '360726': '\u5b89\u8fdc\u53bf',
        '360727': '\u9f99\u5357\u53bf',
        '360728': '\u5b9a\u5357\u53bf',
        '360729': '\u5168\u5357\u53bf',
        '360730': '\u5b81\u90fd\u53bf',
        '360731': '\u4e8e\u90fd\u53bf',
        '360732': '\u5174\u56fd\u53bf',
        '360733': '\u4f1a\u660c\u53bf',
        '360734': '\u5bfb\u4e4c\u53bf',
        '360735': '\u77f3\u57ce\u53bf',
        '360751': '\u9ec4\u91d1\u533a',
        '360781': '\u745e\u91d1\u5e02',
        '360782': '\u5357\u5eb7\u5e02',
        '360783': '\u5176\u5b83\u533a',
    },
    '0,360000,360800': {
        '360802': '\u5409\u5dde\u533a',
        '360803': '\u9752\u539f\u533a',
        '360821': '\u5409\u5b89\u53bf',
        '360822': '\u5409\u6c34\u53bf',
        '360823': '\u5ce1\u6c5f\u53bf',
        '360824': '\u65b0\u5e72\u53bf',
        '360825': '\u6c38\u4e30\u53bf',
        '360826': '\u6cf0\u548c\u53bf',
        '360827': '\u9042\u5ddd\u53bf',
        '360828': '\u4e07\u5b89\u53bf',
        '360829': '\u5b89\u798f\u53bf',
        '360830': '\u6c38\u65b0\u53bf',
        '360881': '\u4e95\u5188\u5c71\u5e02',
        '360882': '\u5176\u5b83\u533a',
    },
    '0,360000,360900': {
        '360902': '\u8881\u5dde\u533a',
        '360921': '\u5949\u65b0\u53bf',
        '360922': '\u4e07\u8f7d\u53bf',
        '360923': '\u4e0a\u9ad8\u53bf',
        '360924': '\u5b9c\u4e30\u53bf',
        '360925': '\u9756\u5b89\u53bf',
        '360926': '\u94dc\u9f13\u53bf',
        '360981': '\u4e30\u57ce\u5e02',
        '360982': '\u6a1f\u6811\u5e02',
        '360983': '\u9ad8\u5b89\u5e02',
        '360984': '\u5176\u5b83\u533a',
    },
    '0,360000,361000': {
        '361002': '\u4e34\u5ddd\u533a',
        '361021': '\u5357\u57ce\u53bf',
        '361022': '\u9ece\u5ddd\u53bf',
        '361023': '\u5357\u4e30\u53bf',
        '361024': '\u5d07\u4ec1\u53bf',
        '361025': '\u4e50\u5b89\u53bf',
        '361026': '\u5b9c\u9ec4\u53bf',
        '361027': '\u91d1\u6eaa\u53bf',
        '361028': '\u8d44\u6eaa\u53bf',
        '361029': '\u4e1c\u4e61\u53bf',
        '361030': '\u5e7f\u660c\u53bf',
        '361031': '\u5176\u5b83\u533a',
    },
    '0,360000,361100': {
        '361102': '\u4fe1\u5dde\u533a',
        '361121': '\u4e0a\u9976\u53bf',
        '361122': '\u5e7f\u4e30\u53bf',
        '361123': '\u7389\u5c71\u53bf',
        '361124': '\u94c5\u5c71\u53bf',
        '361125': '\u6a2a\u5cf0\u53bf',
        '361126': '\u5f0b\u9633\u53bf',
        '361127': '\u4f59\u5e72\u53bf',
        '361128': '\u9131\u9633\u53bf',
        '361129': '\u4e07\u5e74\u53bf',
        '361130': '\u5a7a\u6e90\u53bf',
        '361181': '\u5fb7\u5174\u5e02',
        '361182': '\u5176\u5b83\u533a',
    },
    '0,370000': {
        '370100': '\u6d4e\u5357\u5e02',
        '370200': '\u9752\u5c9b\u5e02',
        '370300': '\u6dc4\u535a\u5e02',
        '370400': '\u67a3\u5e84\u5e02',
        '370500': '\u4e1c\u8425\u5e02',
        '370600': '\u70df\u53f0\u5e02',
        '370700': '\u6f4d\u574a\u5e02',
        '370800': '\u6d4e\u5b81\u5e02',
        '370900': '\u6cf0\u5b89\u5e02',
        '371000': '\u5a01\u6d77\u5e02',
        '371100': '\u65e5\u7167\u5e02',
        '371200': '\u83b1\u829c\u5e02',
        '371300': '\u4e34\u6c82\u5e02',
        '371400': '\u5fb7\u5dde\u5e02',
        '371500': '\u804a\u57ce\u5e02',
        '371600': '\u6ee8\u5dde\u5e02',
        '371700': '\u83cf\u6cfd\u5e02',
    },
    '0,370000,370100': {
        '370102': '\u5386\u4e0b\u533a',
        '370103': '\u5e02\u4e2d\u533a',
        '370104': '\u69d0\u836b\u533a',
        '370105': '\u5929\u6865\u533a',
        '370112': '\u5386\u57ce\u533a',
        '370113': '\u957f\u6e05\u533a',
        '370124': '\u5e73\u9634\u53bf',
        '370125': '\u6d4e\u9633\u53bf',
        '370126': '\u5546\u6cb3\u53bf',
        '370181': '\u7ae0\u4e18\u5e02',
        '370182': '\u5176\u5b83\u533a',
    },
    '0,370000,370200': {
        '370202': '\u5e02\u5357\u533a',
        '370203': '\u5e02\u5317\u533a',
        '370205': '\u56db\u65b9\u533a',
        '370211': '\u9ec4\u5c9b\u533a',
        '370212': '\u5d02\u5c71\u533a',
        '370213': '\u674e\u6ca7\u533a',
        '370214': '\u57ce\u9633\u533a',
        '370251': '\u5f00\u53d1\u533a',
        '370281': '\u80f6\u5dde\u5e02',
        '370282': '\u5373\u58a8\u5e02',
        '370283': '\u5e73\u5ea6\u5e02',
        '370284': '\u80f6\u5357\u5e02',
        '370285': '\u83b1\u897f\u5e02',
        '370286': '\u5176\u5b83\u533a',
    },
    '0,370000,370300': {
        '370302': '\u6dc4\u5ddd\u533a',
        '370303': '\u5f20\u5e97\u533a',
        '370304': '\u535a\u5c71\u533a',
        '370305': '\u4e34\u6dc4\u533a',
        '370306': '\u5468\u6751\u533a',
        '370321': '\u6853\u53f0\u53bf',
        '370322': '\u9ad8\u9752\u53bf',
        '370323': '\u6c82\u6e90\u53bf',
        '370324': '\u5176\u5b83\u533a',
    },
    '0,370000,370400': {
        '370402': '\u5e02\u4e2d\u533a',
        '370403': '\u859b\u57ce\u533a',
        '370404': '\u5cc4\u57ce\u533a',
        '370405': '\u53f0\u513f\u5e84\u533a',
        '370406': '\u5c71\u4ead\u533a',
        '370481': '\u6ed5\u5dde\u5e02',
        '370482': '\u5176\u5b83\u533a',
    },
    '0,370000,370500': {
        '370502': '\u4e1c\u8425\u533a',
        '370503': '\u6cb3\u53e3\u533a',
        '370521': '\u57a6\u5229\u53bf',
        '370522': '\u5229\u6d25\u53bf',
        '370523': '\u5e7f\u9976\u53bf',
        '370589': '\u897f\u57ce\u533a',
        '370590': '\u4e1c\u57ce\u533a',
        '370591': '\u5176\u5b83\u533a',
    },
    '0,370000,370600': {
        '370602': '\u829d\u7f58\u533a',
        '370611': '\u798f\u5c71\u533a',
        '370612': '\u725f\u5e73\u533a',
        '370613': '\u83b1\u5c71\u533a',
        '370634': '\u957f\u5c9b\u53bf',
        '370681': '\u9f99\u53e3\u5e02',
        '370682': '\u83b1\u9633\u5e02',
        '370683': '\u83b1\u5dde\u5e02',
        '370684': '\u84ec\u83b1\u5e02',
        '370685': '\u62db\u8fdc\u5e02',
        '370686': '\u6816\u971e\u5e02',
        '370687': '\u6d77\u9633\u5e02',
        '370688': '\u5176\u5b83\u533a',
    },
    '0,370000,370700': {
        '370702': '\u6f4d\u57ce\u533a',
        '370703': '\u5bd2\u4ead\u533a',
        '370704': '\u574a\u5b50\u533a',
        '370705': '\u594e\u6587\u533a',
        '370724': '\u4e34\u6710\u53bf',
        '370725': '\u660c\u4e50\u53bf',
        '370751': '\u5f00\u53d1\u533a',
        '370781': '\u9752\u5dde\u5e02',
        '370782': '\u8bf8\u57ce\u5e02',
        '370783': '\u5bff\u5149\u5e02',
        '370784': '\u5b89\u4e18\u5e02',
        '370785': '\u9ad8\u5bc6\u5e02',
        '370786': '\u660c\u9091\u5e02',
        '370787': '\u5176\u5b83\u533a',
    },
    '0,370000,370800': {
        '370802': '\u5e02\u4e2d\u533a',
        '370811': '\u4efb\u57ce\u533a',
        '370826': '\u5fae\u5c71\u53bf',
        '370827': '\u9c7c\u53f0\u53bf',
        '370828': '\u91d1\u4e61\u53bf',
        '370829': '\u5609\u7965\u53bf',
        '370830': '\u6c76\u4e0a\u53bf',
        '370831': '\u6cd7\u6c34\u53bf',
        '370832': '\u6881\u5c71\u53bf',
        '370881': '\u66f2\u961c\u5e02',
        '370882': '\u5156\u5dde\u5e02',
        '370883': '\u90b9\u57ce\u5e02',
        '370884': '\u5176\u5b83\u533a',
    },
    '0,370000,370900': {
        '370902': '\u6cf0\u5c71\u533a',
        '370903': '\u5cb1\u5cb3\u533a',
        '370921': '\u5b81\u9633\u53bf',
        '370923': '\u4e1c\u5e73\u53bf',
        '370982': '\u65b0\u6cf0\u5e02',
        '370983': '\u80a5\u57ce\u5e02',
        '370984': '\u5176\u5b83\u533a',
    },
    '0,370000,371000': {
        '371002': '\u73af\u7fe0\u533a',
        '371081': '\u6587\u767b\u5e02',
        '371082': '\u8363\u6210\u5e02',
        '371083': '\u4e73\u5c71\u5e02',
        '371084': '\u5176\u5b83\u533a',
    },
    '0,370000,371100': {
        '371102': '\u4e1c\u6e2f\u533a',
        '371103': '\u5c9a\u5c71\u533a',
        '371121': '\u4e94\u83b2\u53bf',
        '371122': '\u8392\u53bf',
        '371123': '\u5176\u5b83\u533a',
    },
    '0,370000,371200': {
        '371202': '\u83b1\u57ce\u533a',
        '371203': '\u94a2\u57ce\u533a',
        '371204': '\u5176\u5b83\u533a',
    },
    '0,370000,371300': {
        '371302': '\u5170\u5c71\u533a',
        '371311': '\u7f57\u5e84\u533a',
        '371312': '\u6cb3\u4e1c\u533a',
        '371321': '\u6c82\u5357\u53bf',
        '371322': '\u90ef\u57ce\u53bf',
        '371323': '\u6c82\u6c34\u53bf',
        '371324': '\u82cd\u5c71\u53bf',
        '371325': '\u8d39\u53bf',
        '371326': '\u5e73\u9091\u53bf',
        '371327': '\u8392\u5357\u53bf',
        '371328': '\u8499\u9634\u53bf',
        '371329': '\u4e34\u6cad\u53bf',
        '371330': '\u5176\u5b83\u533a',
    },
    '0,370000,371400': {
        '371402': '\u5fb7\u57ce\u533a',
        '371421': '\u9675\u53bf',
        '371422': '\u5b81\u6d25\u53bf',
        '371423': '\u5e86\u4e91\u53bf',
        '371424': '\u4e34\u9091\u53bf',
        '371425': '\u9f50\u6cb3\u53bf',
        '371426': '\u5e73\u539f\u53bf',
        '371427': '\u590f\u6d25\u53bf',
        '371428': '\u6b66\u57ce\u53bf',
        '371451': '\u5f00\u53d1\u533a',
        '371481': '\u4e50\u9675\u5e02',
        '371482': '\u79b9\u57ce\u5e02',
        '371483': '\u5176\u5b83\u533a',
    },
    '0,370000,371500': {
        '371502': '\u4e1c\u660c\u5e9c\u533a',
        '371521': '\u9633\u8c37\u53bf',
        '371522': '\u8398\u53bf',
        '371523': '\u830c\u5e73\u53bf',
        '371524': '\u4e1c\u963f\u53bf',
        '371525': '\u51a0\u53bf',
        '371526': '\u9ad8\u5510\u53bf',
        '371581': '\u4e34\u6e05\u5e02',
        '371582': '\u5176\u5b83\u533a',
    },
    '0,370000,371600': {
        '371602': '\u6ee8\u57ce\u533a',
        '371621': '\u60e0\u6c11\u53bf',
        '371622': '\u9633\u4fe1\u53bf',
        '371623': '\u65e0\u68e3\u53bf',
        '371624': '\u6cbe\u5316\u53bf',
        '371625': '\u535a\u5174\u53bf',
        '371626': '\u90b9\u5e73\u53bf',
        '371627': '\u5176\u5b83\u533a',
    },
    '0,370000,371700': {
        '371702': '\u7261\u4e39\u533a',
        '371721': '\u66f9\u53bf',
        '371722': '\u5355\u53bf',
        '371723': '\u6210\u6b66\u53bf',
        '371724': '\u5de8\u91ce\u53bf',
        '371725': '\u90d3\u57ce\u53bf',
        '371726': '\u9104\u57ce\u53bf',
        '371727': '\u5b9a\u9676\u53bf',
        '371728': '\u4e1c\u660e\u53bf',
        '371729': '\u5176\u5b83\u533a',
    },
    '0,410000': {
        '410100': '\u90d1\u5dde\u5e02',
        '410200': '\u5f00\u5c01\u5e02',
        '410300': '\u6d1b\u9633\u5e02',
        '410400': '\u5e73\u9876\u5c71\u5e02',
        '410500': '\u5b89\u9633\u5e02',
        '410600': '\u9e64\u58c1\u5e02',
        '410700': '\u65b0\u4e61\u5e02',
        '410800': '\u7126\u4f5c\u5e02',
        '410881': '\u6d4e\u6e90\u5e02',
        '410900': '\u6fee\u9633\u5e02',
        '411000': '\u8bb8\u660c\u5e02',
        '411100': '\u6f2f\u6cb3\u5e02',
        '411200': '\u4e09\u95e8\u5ce1\u5e02',
        '411300': '\u5357\u9633\u5e02',
        '411400': '\u5546\u4e18\u5e02',
        '411500': '\u4fe1\u9633\u5e02',
        '411600': '\u5468\u53e3\u5e02',
        '411700': '\u9a7b\u9a6c\u5e97\u5e02',
    },
    '0,410000,410100': {
        '410102': '\u4e2d\u539f\u533a',
        '410103': '\u4e8c\u4e03\u533a',
        '410104': '\u7ba1\u57ce\u56de\u65cf\u533a',
        '410105': '\u91d1\u6c34\u533a',
        '410106': '\u4e0a\u8857\u533a',
        '410108': '\u60e0\u6d4e\u533a',
        '410122': '\u4e2d\u725f\u53bf',
        '410181': '\u5de9\u4e49\u5e02',
        '410182': '\u8365\u9633\u5e02',
        '410183': '\u65b0\u5bc6\u5e02',
        '410184': '\u65b0\u90d1\u5e02',
        '410185': '\u767b\u5c01\u5e02',
        '410186': '\u90d1\u4e1c\u65b0\u533a',
        '410187': '\u9ad8\u65b0\u533a',
        '410188': '\u5176\u5b83\u533a',
    },
    '0,410000,410200': {
        '410202': '\u9f99\u4ead\u533a',
        '410203': '\u987a\u6cb3\u56de\u65cf\u533a',
        '410204': '\u9f13\u697c\u533a',
        '410205': '\u79b9\u738b\u53f0\u533a',
        '410211': '\u91d1\u660e\u533a',
        '410221': '\u675e\u53bf',
        '410222': '\u901a\u8bb8\u53bf',
        '410223': '\u5c09\u6c0f\u53bf',
        '410224': '\u5f00\u5c01\u53bf',
        '410225': '\u5170\u8003\u53bf',
        '410226': '\u5176\u5b83\u533a',
    },
    '0,410000,410300': {
        '410302': '\u8001\u57ce\u533a',
        '410303': '\u897f\u5de5\u533a',
        '410304': '\u5edb\u6cb3\u56de\u65cf\u533a',
        '410305': '\u6da7\u897f\u533a',
        '410306': '\u5409\u5229\u533a',
        '410307': '\u6d1b\u9f99\u533a',
        '410322': '\u5b5f\u6d25\u53bf',
        '410323': '\u65b0\u5b89\u53bf',
        '410324': '\u683e\u5ddd\u53bf',
        '410325': '\u5d69\u53bf',
        '410326': '\u6c5d\u9633\u53bf',
        '410327': '\u5b9c\u9633\u53bf',
        '410328': '\u6d1b\u5b81\u53bf',
        '410329': '\u4f0a\u5ddd\u53bf',
        '410381': '\u5043\u5e08\u5e02',
        '471004': '\u9ad8\u65b0\u533a',
        '471005': '\u5176\u5b83\u533a',
    },
    '0,410000,410400': {
        '410402': '\u65b0\u534e\u533a',
        '410403': '\u536b\u4e1c\u533a',
        '410404': '\u77f3\u9f99\u533a',
        '410411': '\u6e5b\u6cb3\u533a',
        '410421': '\u5b9d\u4e30\u53bf',
        '410422': '\u53f6\u53bf',
        '410423': '\u9c81\u5c71\u53bf',
        '410425': '\u90cf\u53bf',
        '410481': '\u821e\u94a2\u5e02',
        '410482': '\u6c5d\u5dde\u5e02',
        '410483': '\u5176\u5b83\u533a',
    },
    '0,410000,410500': {
        '410502': '\u6587\u5cf0\u533a',
        '410503': '\u5317\u5173\u533a',
        '410505': '\u6bb7\u90fd\u533a',
        '410506': '\u9f99\u5b89\u533a',
        '410522': '\u5b89\u9633\u53bf',
        '410523': '\u6c64\u9634\u53bf',
        '410526': '\u6ed1\u53bf',
        '410527': '\u5185\u9ec4\u53bf',
        '410581': '\u6797\u5dde\u5e02',
        '410582': '\u5176\u5b83\u533a',
    },
    '0,410000,410600': {
        '410602': '\u9e64\u5c71\u533a',
        '410603': '\u5c71\u57ce\u533a',
        '410611': '\u6dc7\u6ee8\u533a',
        '410621': '\u6d5a\u53bf',
        '410622': '\u6dc7\u53bf',
        '410623': '\u5176\u5b83\u533a',
    },
    '0,410000,410700': {
        '410702': '\u7ea2\u65d7\u533a',
        '410703': '\u536b\u6ee8\u533a',
        '410704': '\u51e4\u6cc9\u533a',
        '410711': '\u7267\u91ce\u533a',
        '410721': '\u65b0\u4e61\u53bf',
        '410724': '\u83b7\u5609\u53bf',
        '410725': '\u539f\u9633\u53bf',
        '410726': '\u5ef6\u6d25\u53bf',
        '410727': '\u5c01\u4e18\u53bf',
        '410728': '\u957f\u57a3\u53bf',
        '410781': '\u536b\u8f89\u5e02',
        '410782': '\u8f89\u53bf\u5e02',
        '410783': '\u5176\u5b83\u533a',
    },
    '0,410000,410800': {
        '410802': '\u89e3\u653e\u533a',
        '410803': '\u4e2d\u7ad9\u533a',
        '410804': '\u9a6c\u6751\u533a',
        '410811': '\u5c71\u9633\u533a',
        '410821': '\u4fee\u6b66\u53bf',
        '410822': '\u535a\u7231\u53bf',
        '410823': '\u6b66\u965f\u53bf',
        '410825': '\u6e29\u53bf',
        '410882': '\u6c81\u9633\u5e02',
        '410883': '\u5b5f\u5dde\u5e02',
        '410884': '\u5176\u5b83\u533a',
    },
    '0,410000,410881': [],
    '0,410000,410900': {
        '410902': '\u534e\u9f99\u533a',
        '410922': '\u6e05\u4e30\u53bf',
        '410923': '\u5357\u4e50\u53bf',
        '410926': '\u8303\u53bf',
        '410927': '\u53f0\u524d\u53bf',
        '410928': '\u6fee\u9633\u53bf',
        '410929': '\u5176\u5b83\u533a',
    },
    '0,410000,411000': {
        '411002': '\u9b4f\u90fd\u533a',
        '411023': '\u8bb8\u660c\u53bf',
        '411024': '\u9122\u9675\u53bf',
        '411025': '\u8944\u57ce\u53bf',
        '411081': '\u79b9\u5dde\u5e02',
        '411082': '\u957f\u845b\u5e02',
        '411083': '\u5176\u5b83\u533a',
    },
    '0,410000,411100': {
        '411102': '\u6e90\u6c47\u533a',
        '411103': '\u90fe\u57ce\u533a',
        '411104': '\u53ec\u9675\u533a',
        '411121': '\u821e\u9633\u53bf',
        '411122': '\u4e34\u988d\u53bf',
        '411123': '\u5176\u5b83\u533a',
    },
    '0,410000,411200': {
        '411202': '\u6e56\u6ee8\u533a',
        '411221': '\u6e11\u6c60\u53bf',
        '411222': '\u9655\u53bf',
        '411224': '\u5362\u6c0f\u53bf',
        '411281': '\u4e49\u9a6c\u5e02',
        '411282': '\u7075\u5b9d\u5e02',
        '411283': '\u5176\u5b83\u533a',
    },
    '0,410000,411300': {
        '411302': '\u5b9b\u57ce\u533a',
        '411303': '\u5367\u9f99\u533a',
        '411321': '\u5357\u53ec\u53bf',
        '411322': '\u65b9\u57ce\u53bf',
        '411323': '\u897f\u5ce1\u53bf',
        '411324': '\u9547\u5e73\u53bf',
        '411325': '\u5185\u4e61\u53bf',
        '411326': '\u6dc5\u5ddd\u53bf',
        '411327': '\u793e\u65d7\u53bf',
        '411328': '\u5510\u6cb3\u53bf',
        '411329': '\u65b0\u91ce\u53bf',
        '411330': '\u6850\u67cf\u53bf',
        '411381': '\u9093\u5dde\u5e02',
        '411382': '\u5176\u5b83\u533a',
    },
    '0,410000,411400': {
        '411402': '\u6881\u56ed\u533a',
        '411403': '\u7762\u9633\u533a',
        '411421': '\u6c11\u6743\u53bf',
        '411422': '\u7762\u53bf',
        '411423': '\u5b81\u9675\u53bf',
        '411424': '\u67d8\u57ce\u53bf',
        '411425': '\u865e\u57ce\u53bf',
        '411426': '\u590f\u9091\u53bf',
        '411481': '\u6c38\u57ce\u5e02',
        '411482': '\u5176\u5b83\u533a',
    },
    '0,410000,411500': {
        '411502': '\u6d49\u6cb3\u533a',
        '411503': '\u5e73\u6865\u533a',
        '411521': '\u7f57\u5c71\u53bf',
        '411522': '\u5149\u5c71\u53bf',
        '411523': '\u65b0\u53bf',
        '411524': '\u5546\u57ce\u53bf',
        '411525': '\u56fa\u59cb\u53bf',
        '411526': '\u6f62\u5ddd\u53bf',
        '411527': '\u6dee\u6ee8\u53bf',
        '411528': '\u606f\u53bf',
        '411529': '\u5176\u5b83\u533a',
    },
    '0,410000,411600': {
        '411602': '\u5ddd\u6c47\u533a',
        '411621': '\u6276\u6c9f\u53bf',
        '411622': '\u897f\u534e\u53bf',
        '411623': '\u5546\u6c34\u53bf',
        '411624': '\u6c88\u4e18\u53bf',
        '411625': '\u90f8\u57ce\u53bf',
        '411626': '\u6dee\u9633\u53bf',
        '411627': '\u592a\u5eb7\u53bf',
        '411628': '\u9e7f\u9091\u53bf',
        '411681': '\u9879\u57ce\u5e02',
        '411682': '\u5176\u5b83\u533a',
    },
    '0,410000,411700': {
        '411702': '\u9a7f\u57ce\u533a',
        '411721': '\u897f\u5e73\u53bf',
        '411722': '\u4e0a\u8521\u53bf',
        '411723': '\u5e73\u8206\u53bf',
        '411724': '\u6b63\u9633\u53bf',
        '411725': '\u786e\u5c71\u53bf',
        '411726': '\u6ccc\u9633\u53bf',
        '411727': '\u6c5d\u5357\u53bf',
        '411728': '\u9042\u5e73\u53bf',
        '411729': '\u65b0\u8521\u53bf',
        '411730': '\u5176\u5b83\u533a',
    },
    '0,420000': {
        '420100': '\u6b66\u6c49\u5e02',
        '420200': '\u9ec4\u77f3\u5e02',
        '420300': '\u5341\u5830\u5e02',
        '420500': '\u5b9c\u660c\u5e02',
        '420600': '\u8944\u9633\u5e02',
        '420700': '\u9102\u5dde\u5e02',
        '420800': '\u8346\u95e8\u5e02',
        '420900': '\u5b5d\u611f\u5e02',
        '421000': '\u8346\u5dde\u5e02',
        '421100': '\u9ec4\u5188\u5e02',
        '421200': '\u54b8\u5b81\u5e02',
        '421300': '\u968f\u5dde\u5e02',
        '422800': '\u6069\u65bd\u571f\u5bb6\u65cf\u82d7\u65cf\u81ea\u6cbb\u5dde',
        '429004': '\u4ed9\u6843\u5e02',
        '429005': '\u6f5c\u6c5f\u5e02',
        '429006': '\u5929\u95e8\u5e02',
        '429021': '\u795e\u519c\u67b6\u6797\u533a',
    },
    '0,420000,420100': {
        '420102': '\u6c5f\u5cb8\u533a',
        '420103': '\u6c5f\u6c49\u533a',
        '420104': '\u785a\u53e3\u533a',
        '420105': '\u6c49\u9633\u533a',
        '420106': '\u6b66\u660c\u533a',
        '420107': '\u9752\u5c71\u533a',
        '420111': '\u6d2a\u5c71\u533a',
        '420112': '\u4e1c\u897f\u6e56\u533a',
        '420113': '\u6c49\u5357\u533a',
        '420114': '\u8521\u7538\u533a',
        '420115': '\u6c5f\u590f\u533a',
        '420116': '\u9ec4\u9642\u533a',
        '420117': '\u65b0\u6d32\u533a',
        '420118': '\u5176\u5b83\u533a',
    },
    '0,420000,420200': {
        '420202': '\u9ec4\u77f3\u6e2f\u533a',
        '420203': '\u897f\u585e\u5c71\u533a',
        '420204': '\u4e0b\u9646\u533a',
        '420205': '\u94c1\u5c71\u533a',
        '420222': '\u9633\u65b0\u53bf',
        '420281': '\u5927\u51b6\u5e02',
        '420282': '\u5176\u5b83\u533a',
    },
    '0,420000,420300': {
        '420302': '\u8305\u7bad\u533a',
        '420303': '\u5f20\u6e7e\u533a',
        '420321': '\u90e7\u53bf',
        '420322': '\u90e7\u897f\u53bf',
        '420323': '\u7af9\u5c71\u53bf',
        '420324': '\u7af9\u6eaa\u53bf',
        '420325': '\u623f\u53bf',
        '420381': '\u4e39\u6c5f\u53e3\u5e02',
        '420382': '\u57ce\u533a',
        '420383': '\u5176\u5b83\u533a',
    },
    '0,420000,420500': {
        '420502': '\u897f\u9675\u533a',
        '420503': '\u4f0d\u5bb6\u5c97\u533a',
        '420504': '\u70b9\u519b\u533a',
        '420505': '\u7307\u4ead\u533a',
        '420506': '\u5937\u9675\u533a',
        '420525': '\u8fdc\u5b89\u53bf',
        '420526': '\u5174\u5c71\u53bf',
        '420527': '\u79ed\u5f52\u53bf',
        '420528': '\u957f\u9633\u571f\u5bb6\u65cf\u81ea\u6cbb\u53bf',
        '420529': '\u4e94\u5cf0\u571f\u5bb6\u65cf\u81ea\u6cbb\u53bf',
        '420551': '\u845b\u6d32\u575d\u533a',
        '420552': '\u5f00\u53d1\u533a',
        '420581': '\u5b9c\u90fd\u5e02',
        '420582': '\u5f53\u9633\u5e02',
        '420583': '\u679d\u6c5f\u5e02',
        '420584': '\u5176\u5b83\u533a',
    },
    '0,420000,420600': {
        '420602': '\u8944\u57ce\u533a',
        '420606': '\u6a0a\u57ce\u533a',
        '420607': '\u8944\u5dde\u533a',
        '420624': '\u5357\u6f33\u53bf',
        '420625': '\u8c37\u57ce\u53bf',
        '420626': '\u4fdd\u5eb7\u53bf',
        '420682': '\u8001\u6cb3\u53e3\u5e02',
        '420683': '\u67a3\u9633\u5e02',
        '420684': '\u5b9c\u57ce\u5e02',
        '420685': '\u5176\u5b83\u533a',
    },
    '0,420000,420700': {
        '420702': '\u6881\u5b50\u6e56\u533a',
        '420703': '\u534e\u5bb9\u533a',
        '420704': '\u9102\u57ce\u533a',
        '420705': '\u5176\u5b83\u533a',
    },
    '0,420000,420800': {
        '420802': '\u4e1c\u5b9d\u533a',
        '420804': '\u6387\u5200\u533a',
        '420821': '\u4eac\u5c71\u53bf',
        '420822': '\u6c99\u6d0b\u53bf',
        '420881': '\u949f\u7965\u5e02',
        '420882': '\u5176\u5b83\u533a',
    },
    '0,420000,420900': {
        '420902': '\u5b5d\u5357\u533a',
        '420921': '\u5b5d\u660c\u53bf',
        '420922': '\u5927\u609f\u53bf',
        '420923': '\u4e91\u68a6\u53bf',
        '420981': '\u5e94\u57ce\u5e02',
        '420982': '\u5b89\u9646\u5e02',
        '420984': '\u6c49\u5ddd\u5e02',
        '420985': '\u5176\u5b83\u533a',
    },
    '0,420000,421000': {
        '421002': '\u6c99\u5e02\u533a',
        '421003': '\u8346\u5dde\u533a',
        '421022': '\u516c\u5b89\u53bf',
        '421023': '\u76d1\u5229\u53bf',
        '421024': '\u6c5f\u9675\u53bf',
        '421081': '\u77f3\u9996\u5e02',
        '421083': '\u6d2a\u6e56\u5e02',
        '421087': '\u677e\u6ecb\u5e02',
        '421088': '\u5176\u5b83\u533a',
    },
    '0,420000,421100': {
        '421102': '\u9ec4\u5dde\u533a',
        '421121': '\u56e2\u98ce\u53bf',
        '421122': '\u7ea2\u5b89\u53bf',
        '421123': '\u7f57\u7530\u53bf',
        '421124': '\u82f1\u5c71\u53bf',
        '421125': '\u6d60\u6c34\u53bf',
        '421126': '\u8572\u6625\u53bf',
        '421127': '\u9ec4\u6885\u53bf',
        '421181': '\u9ebb\u57ce\u5e02',
        '421182': '\u6b66\u7a74\u5e02',
        '421183': '\u5176\u5b83\u533a',
    },
    '0,420000,421200': {
        '421202': '\u54b8\u5b89\u533a',
        '421221': '\u5609\u9c7c\u53bf',
        '421222': '\u901a\u57ce\u53bf',
        '421223': '\u5d07\u9633\u53bf',
        '421224': '\u901a\u5c71\u53bf',
        '421281': '\u8d64\u58c1\u5e02',
        '421282': '\u6e29\u6cc9\u57ce\u533a',
        '421283': '\u5176\u5b83\u533a',
    },
    '0,420000,421300': {
        '421302': '\u66fe\u90fd\u533a',
        '421321': '\u968f\u53bf',
        '421381': '\u5e7f\u6c34\u5e02',
        '421382': '\u5176\u5b83\u533a',
    },
    '0,420000,422800': {
        '422801': '\u6069\u65bd\u5e02',
        '422802': '\u5229\u5ddd\u5e02',
        '422822': '\u5efa\u59cb\u53bf',
        '422823': '\u5df4\u4e1c\u53bf',
        '422825': '\u5ba3\u6069\u53bf',
        '422826': '\u54b8\u4e30\u53bf',
        '422827': '\u6765\u51e4\u53bf',
        '422828': '\u9e64\u5cf0\u53bf',
        '422829': '\u5176\u5b83\u533a',
    },
    '0,420000,429004': [],
    '0,420000,429005': [],
    '0,420000,429006': [],
    '0,420000,429021': [],
    '0,430000': {
        '430100': '\u957f\u6c99\u5e02',
        '430200': '\u682a\u6d32\u5e02',
        '430300': '\u6e58\u6f6d\u5e02',
        '430400': '\u8861\u9633\u5e02',
        '430500': '\u90b5\u9633\u5e02',
        '430600': '\u5cb3\u9633\u5e02',
        '430700': '\u5e38\u5fb7\u5e02',
        '430800': '\u5f20\u5bb6\u754c\u5e02',
        '430900': '\u76ca\u9633\u5e02',
        '431000': '\u90f4\u5dde\u5e02',
        '431100': '\u6c38\u5dde\u5e02',
        '431200': '\u6000\u5316\u5e02',
        '431300': '\u5a04\u5e95\u5e02',
        '433100': '\u6e58\u897f\u571f\u5bb6\u65cf\u82d7\u65cf\u81ea\u6cbb\u5dde',
    },
    '0,430000,430100': {
        '430102': '\u8299\u84c9\u533a',
        '430103': '\u5929\u5fc3\u533a',
        '430104': '\u5cb3\u9e93\u533a',
        '430105': '\u5f00\u798f\u533a',
        '430111': '\u96e8\u82b1\u533a',
        '430121': '\u957f\u6c99\u53bf',
        '430122': '\u671b\u57ce\u53bf',
        '430124': '\u5b81\u4e61\u53bf',
        '430181': '\u6d4f\u9633\u5e02',
        '430182': '\u5176\u5b83\u533a',
    },
    '0,430000,430200': {
        '430202': '\u8377\u5858\u533a',
        '430203': '\u82a6\u6dde\u533a',
        '430204': '\u77f3\u5cf0\u533a',
        '430211': '\u5929\u5143\u533a',
        '430221': '\u682a\u6d32\u53bf',
        '430223': '\u6538\u53bf',
        '430224': '\u8336\u9675\u53bf',
        '430225': '\u708e\u9675\u53bf',
        '430281': '\u91b4\u9675\u5e02',
        '430282': '\u5176\u5b83\u533a',
    },
    '0,430000,430300': {
        '430302': '\u96e8\u6e56\u533a',
        '430304': '\u5cb3\u5858\u533a',
        '430321': '\u6e58\u6f6d\u53bf',
        '430381': '\u6e58\u4e61\u5e02',
        '430382': '\u97f6\u5c71\u5e02',
        '430383': '\u5176\u5b83\u533a',
    },
    '0,430000,430400': {
        '430405': '\u73e0\u6656\u533a',
        '430406': '\u96c1\u5cf0\u533a',
        '430407': '\u77f3\u9f13\u533a',
        '430408': '\u84b8\u6e58\u533a',
        '430412': '\u5357\u5cb3\u533a',
        '430421': '\u8861\u9633\u53bf',
        '430422': '\u8861\u5357\u53bf',
        '430423': '\u8861\u5c71\u53bf',
        '430424': '\u8861\u4e1c\u53bf',
        '430426': '\u7941\u4e1c\u53bf',
        '430481': '\u8012\u9633\u5e02',
        '430482': '\u5e38\u5b81\u5e02',
        '430483': '\u5176\u5b83\u533a',
    },
    '0,430000,430500': {
        '430502': '\u53cc\u6e05\u533a',
        '430503': '\u5927\u7965\u533a',
        '430511': '\u5317\u5854\u533a',
        '430521': '\u90b5\u4e1c\u53bf',
        '430522': '\u65b0\u90b5\u53bf',
        '430523': '\u90b5\u9633\u53bf',
        '430524': '\u9686\u56de\u53bf',
        '430525': '\u6d1e\u53e3\u53bf',
        '430527': '\u7ee5\u5b81\u53bf',
        '430528': '\u65b0\u5b81\u53bf',
        '430529': '\u57ce\u6b65\u82d7\u65cf\u81ea\u6cbb\u53bf',
        '430581': '\u6b66\u5188\u5e02',
        '430582': '\u5176\u5b83\u533a',
    },
    '0,430000,430600': {
        '430602': '\u5cb3\u9633\u697c\u533a',
        '430603': '\u4e91\u6eaa\u533a',
        '430611': '\u541b\u5c71\u533a',
        '430621': '\u5cb3\u9633\u53bf',
        '430623': '\u534e\u5bb9\u53bf',
        '430624': '\u6e58\u9634\u53bf',
        '430626': '\u5e73\u6c5f\u53bf',
        '430681': '\u6c68\u7f57\u5e02',
        '430682': '\u4e34\u6e58\u5e02',
        '430683': '\u5176\u5b83\u533a',
    },
    '0,430000,430700': {
        '430702': '\u6b66\u9675\u533a',
        '430703': '\u9f0e\u57ce\u533a',
        '430721': '\u5b89\u4e61\u53bf',
        '430722': '\u6c49\u5bff\u53bf',
        '430723': '\u6fa7\u53bf',
        '430724': '\u4e34\u6fa7\u53bf',
        '430725': '\u6843\u6e90\u53bf',
        '430726': '\u77f3\u95e8\u53bf',
        '430781': '\u6d25\u5e02\u5e02',
        '430782': '\u5176\u5b83\u533a',
    },
    '0,430000,430800': {
        '430802': '\u6c38\u5b9a\u533a',
        '430811': '\u6b66\u9675\u6e90\u533a',
        '430821': '\u6148\u5229\u53bf',
        '430822': '\u6851\u690d\u53bf',
        '430823': '\u5176\u5b83\u533a',
    },
    '0,430000,430900': {
        '430902': '\u8d44\u9633\u533a',
        '430903': '\u8d6b\u5c71\u533a',
        '430921': '\u5357\u53bf',
        '430922': '\u6843\u6c5f\u53bf',
        '430923': '\u5b89\u5316\u53bf',
        '430981': '\u6c85\u6c5f\u5e02',
        '430982': '\u5176\u5b83\u533a',
    },
    '0,430000,431000': {
        '431002': '\u5317\u6e56\u533a',
        '431003': '\u82cf\u4ed9\u533a',
        '431021': '\u6842\u9633\u53bf',
        '431022': '\u5b9c\u7ae0\u53bf',
        '431023': '\u6c38\u5174\u53bf',
        '431024': '\u5609\u79be\u53bf',
        '431025': '\u4e34\u6b66\u53bf',
        '431026': '\u6c5d\u57ce\u53bf',
        '431027': '\u6842\u4e1c\u53bf',
        '431028': '\u5b89\u4ec1\u53bf',
        '431081': '\u8d44\u5174\u5e02',
        '431082': '\u5176\u5b83\u533a',
    },
    '0,430000,431100': {
        '431102': '\u96f6\u9675\u533a',
        '431103': '\u51b7\u6c34\u6ee9\u533a',
        '431121': '\u7941\u9633\u53bf',
        '431122': '\u4e1c\u5b89\u53bf',
        '431123': '\u53cc\u724c\u53bf',
        '431124': '\u9053\u53bf',
        '431125': '\u6c5f\u6c38\u53bf',
        '431126': '\u5b81\u8fdc\u53bf',
        '431127': '\u84dd\u5c71\u53bf',
        '431128': '\u65b0\u7530\u53bf',
        '431129': '\u6c5f\u534e\u7476\u65cf\u81ea\u6cbb\u53bf',
        '431130': '\u5176\u5b83\u533a',
    },
    '0,430000,431200': {
        '431202': '\u9e64\u57ce\u533a',
        '431221': '\u4e2d\u65b9\u53bf',
        '431222': '\u6c85\u9675\u53bf',
        '431223': '\u8fb0\u6eaa\u53bf',
        '431224': '\u6e86\u6d66\u53bf',
        '431225': '\u4f1a\u540c\u53bf',
        '431226': '\u9ebb\u9633\u82d7\u65cf\u81ea\u6cbb\u53bf',
        '431227': '\u65b0\u6643\u4f97\u65cf\u81ea\u6cbb\u53bf',
        '431228': '\u82b7\u6c5f\u4f97\u65cf\u81ea\u6cbb\u53bf',
        '431229': '\u9756\u5dde\u82d7\u65cf\u4f97\u65cf\u81ea\u6cbb\u53bf',
        '431230': '\u901a\u9053\u4f97\u65cf\u81ea\u6cbb\u53bf',
        '431281': '\u6d2a\u6c5f\u5e02',
        '431282': '\u5176\u5b83\u533a',
    },
    '0,430000,431300': {
        '431302': '\u5a04\u661f\u533a',
        '431321': '\u53cc\u5cf0\u53bf',
        '431322': '\u65b0\u5316\u53bf',
        '431381': '\u51b7\u6c34\u6c5f\u5e02',
        '431382': '\u6d9f\u6e90\u5e02',
        '431383': '\u5176\u5b83\u533a',
    },
    '0,430000,433100': {
        '433101': '\u5409\u9996\u5e02',
        '433122': '\u6cf8\u6eaa\u53bf',
        '433123': '\u51e4\u51f0\u53bf',
        '433124': '\u82b1\u57a3\u53bf',
        '433125': '\u4fdd\u9756\u53bf',
        '433126': '\u53e4\u4e08\u53bf',
        '433127': '\u6c38\u987a\u53bf',
        '433130': '\u9f99\u5c71\u53bf',
        '433131': '\u5176\u5b83\u533a',
    },
    '0,440000': {
        '440100': '\u5e7f\u5dde\u5e02',
        '440200': '\u97f6\u5173\u5e02',
        '440300': '\u6df1\u5733\u5e02',
        '440400': '\u73e0\u6d77\u5e02',
        '440500': '\u6c55\u5934\u5e02',
        '440600': '\u4f5b\u5c71\u5e02',
        '440700': '\u6c5f\u95e8\u5e02',
        '440800': '\u6e5b\u6c5f\u5e02',
        '440900': '\u8302\u540d\u5e02',
        '441200': '\u8087\u5e86\u5e02',
        '441300': '\u60e0\u5dde\u5e02',
        '441400': '\u6885\u5dde\u5e02',
        '441500': '\u6c55\u5c3e\u5e02',
        '441600': '\u6cb3\u6e90\u5e02',
        '441700': '\u9633\u6c5f\u5e02',
        '441800': '\u6e05\u8fdc\u5e02',
        '441900': '\u4e1c\u839e\u5e02',
        '442000': '\u4e2d\u5c71\u5e02',
        '445100': '\u6f6e\u5dde\u5e02',
        '445200': '\u63ed\u9633\u5e02',
        '445300': '\u4e91\u6d6e\u5e02',
    },
    '0,440000,440100': {
        '440103': '\u8354\u6e7e\u533a',
        '440104': '\u8d8a\u79c0\u533a',
        '440105': '\u6d77\u73e0\u533a',
        '440106': '\u5929\u6cb3\u533a',
        '440111': '\u767d\u4e91\u533a',
        '440112': '\u9ec4\u57d4\u533a',
        '440113': '\u756a\u79ba\u533a',
        '440114': '\u82b1\u90fd\u533a',
        '440115': '\u5357\u6c99\u533a',
        '440116': '\u841d\u5c97\u533a',
        '440183': '\u589e\u57ce\u5e02',
        '440184': '\u4ece\u5316\u5e02',
        '440188': '\u4e1c\u5c71\u533a',
        '440189': '\u5176\u5b83\u533a',
    },
    '0,440000,440200': {
        '440203': '\u6b66\u6c5f\u533a',
        '440204': '\u6d48\u6c5f\u533a',
        '440205': '\u66f2\u6c5f\u533a',
        '440222': '\u59cb\u5174\u53bf',
        '440224': '\u4ec1\u5316\u53bf',
        '440229': '\u7fc1\u6e90\u53bf',
        '440232': '\u4e73\u6e90\u7476\u65cf\u81ea\u6cbb\u53bf',
        '440233': '\u65b0\u4e30\u53bf',
        '440281': '\u4e50\u660c\u5e02',
        '440282': '\u5357\u96c4\u5e02',
        '440283': '\u5176\u5b83\u533a',
    },
    '0,440000,440300': {
        '440303': '\u7f57\u6e56\u533a',
        '440304': '\u798f\u7530\u533a',
        '440305': '\u5357\u5c71\u533a',
        '440306': '\u5b9d\u5b89\u533a',
        '440307': '\u9f99\u5c97\u533a',
        '440308': '\u76d0\u7530\u533a',
        '440309': '\u5176\u5b83\u533a',
        '1032697': '\u5149\u660e\u65b0\u533a',
        '1032698': '\u576a\u5c71\u65b0\u533a',
        '1032699': '\u5927\u9e4f\u65b0\u533a',
        '1032700': '\u9f99\u534e\u65b0\u533a',
    },
    '0,440000,440400': {
        '440402': '\u9999\u6d32\u533a',
        '440403': '\u6597\u95e8\u533a',
        '440404': '\u91d1\u6e7e\u533a',
        '440486': '\u91d1\u5510\u533a',
        '440487': '\u5357\u6e7e\u533a',
        '440488': '\u5176\u5b83\u533a',
    },
    '0,440000,440500': {
        '440507': '\u9f99\u6e56\u533a',
        '440511': '\u91d1\u5e73\u533a',
        '440512': '\u6fe0\u6c5f\u533a',
        '440513': '\u6f6e\u9633\u533a',
        '440514': '\u6f6e\u5357\u533a',
        '440515': '\u6f84\u6d77\u533a',
        '440523': '\u5357\u6fb3\u53bf',
        '440524': '\u5176\u5b83\u533a',
    },
    '0,440000,440600': {
        '440604': '\u7985\u57ce\u533a',
        '440605': '\u5357\u6d77\u533a',
        '440606': '\u987a\u5fb7\u533a',
        '440607': '\u4e09\u6c34\u533a',
        '440608': '\u9ad8\u660e\u533a',
        '440609': '\u5176\u5b83\u533a',
    },
    '0,440000,440700': {
        '440703': '\u84ec\u6c5f\u533a',
        '440704': '\u6c5f\u6d77\u533a',
        '440705': '\u65b0\u4f1a\u533a',
        '440781': '\u53f0\u5c71\u5e02',
        '440783': '\u5f00\u5e73\u5e02',
        '440784': '\u9e64\u5c71\u5e02',
        '440785': '\u6069\u5e73\u5e02',
        '440786': '\u5176\u5b83\u533a',
    },
    '0,440000,440800': {
        '440802': '\u8d64\u574e\u533a',
        '440803': '\u971e\u5c71\u533a',
        '440804': '\u5761\u5934\u533a',
        '440811': '\u9ebb\u7ae0\u533a',
        '440823': '\u9042\u6eaa\u53bf',
        '440825': '\u5f90\u95fb\u53bf',
        '440881': '\u5ec9\u6c5f\u5e02',
        '440882': '\u96f7\u5dde\u5e02',
        '440883': '\u5434\u5ddd\u5e02',
        '440884': '\u5176\u5b83\u533a',
    },
    '0,440000,440900': {
        '440902': '\u8302\u5357\u533a',
        '440903': '\u8302\u6e2f\u533a',
        '440923': '\u7535\u767d\u53bf',
        '440981': '\u9ad8\u5dde\u5e02',
        '440982': '\u5316\u5dde\u5e02',
        '440983': '\u4fe1\u5b9c\u5e02',
        '440984': '\u5176\u5b83\u533a',
    },
    '0,440000,441200': {
        '441202': '\u7aef\u5dde\u533a',
        '441203': '\u9f0e\u6e56\u533a',
        '441223': '\u5e7f\u5b81\u53bf',
        '441224': '\u6000\u96c6\u53bf',
        '441225': '\u5c01\u5f00\u53bf',
        '441226': '\u5fb7\u5e86\u53bf',
        '441283': '\u9ad8\u8981\u5e02',
        '441284': '\u56db\u4f1a\u5e02',
        '441285': '\u5176\u5b83\u533a',
    },
    '0,440000,441300': {
        '441302': '\u60e0\u57ce\u533a',
        '441303': '\u60e0\u9633\u533a',
        '441322': '\u535a\u7f57\u53bf',
        '441323': '\u60e0\u4e1c\u53bf',
        '441324': '\u9f99\u95e8\u53bf',
        '441325': '\u5176\u5b83\u533a',
    },
    '0,440000,441400': {
        '441402': '\u6885\u6c5f\u533a',
        '441421': '\u6885\u53bf',
        '441422': '\u5927\u57d4\u53bf',
        '441423': '\u4e30\u987a\u53bf',
        '441424': '\u4e94\u534e\u53bf',
        '441426': '\u5e73\u8fdc\u53bf',
        '441427': '\u8549\u5cad\u53bf',
        '441481': '\u5174\u5b81\u5e02',
        '441482': '\u5176\u5b83\u533a',
    },
    '0,440000,441500': {
        '441502': '\u57ce\u533a',
        '441521': '\u6d77\u4e30\u53bf',
        '441523': '\u9646\u6cb3\u53bf',
        '441581': '\u9646\u4e30\u5e02',
        '441582': '\u5176\u5b83\u533a',
    },
    '0,440000,441600': {
        '441602': '\u6e90\u57ce\u533a',
        '441621': '\u7d2b\u91d1\u53bf',
        '441622': '\u9f99\u5ddd\u53bf',
        '441623': '\u8fde\u5e73\u53bf',
        '441624': '\u548c\u5e73\u53bf',
        '441625': '\u4e1c\u6e90\u53bf',
        '441626': '\u5176\u5b83\u533a',
    },
    '0,440000,441700': {
        '441702': '\u6c5f\u57ce\u533a',
        '441721': '\u9633\u897f\u53bf',
        '441723': '\u9633\u4e1c\u53bf',
        '441781': '\u9633\u6625\u5e02',
        '441782': '\u5176\u5b83\u533a',
    },
    '0,440000,441800': {
        '441802': '\u6e05\u57ce\u533a',
        '441821': '\u4f5b\u5188\u53bf',
        '441823': '\u9633\u5c71\u53bf',
        '441825': '\u8fde\u5c71\u58ee\u65cf\u7476\u65cf\u81ea\u6cbb\u53bf',
        '441826': '\u8fde\u5357\u7476\u65cf\u81ea\u6cbb\u53bf',
        '441827': '\u6e05\u65b0\u53bf',
        '441881': '\u82f1\u5fb7\u5e02',
        '441882': '\u8fde\u5dde\u5e02',
        '441883': '\u5176\u5b83\u533a',
    },
    '0,440000,441900': [],
    '0,440000,442000': [],
    '0,440000,445100': {
        '445102': '\u6e58\u6865\u533a',
        '445121': '\u6f6e\u5b89\u53bf',
        '445122': '\u9976\u5e73\u53bf',
        '445185': '\u67ab\u6eaa\u533a',
        '445186': '\u5176\u5b83\u533a',
    },
    '0,440000,445200': {
        '445202': '\u6995\u57ce\u533a',
        '445221': '\u63ed\u4e1c\u53bf',
        '445222': '\u63ed\u897f\u53bf',
        '445224': '\u60e0\u6765\u53bf',
        '445281': '\u666e\u5b81\u5e02',
        '445284': '\u4e1c\u5c71\u533a',
        '445285': '\u5176\u5b83\u533a',
    },
    '0,440000,445300': {
        '445302': '\u4e91\u57ce\u533a',
        '445321': '\u65b0\u5174\u53bf',
        '445322': '\u90c1\u5357\u53bf',
        '445323': '\u4e91\u5b89\u53bf',
        '445381': '\u7f57\u5b9a\u5e02',
        '445382': '\u5176\u5b83\u533a',
    },
    '0,450000': {
        '450100': '\u5357\u5b81\u5e02',
        '450200': '\u67f3\u5dde\u5e02',
        '450300': '\u6842\u6797\u5e02',
        '450400': '\u68a7\u5dde\u5e02',
        '450500': '\u5317\u6d77\u5e02',
        '450600': '\u9632\u57ce\u6e2f\u5e02',
        '450700': '\u94a6\u5dde\u5e02',
        '450800': '\u8d35\u6e2f\u5e02',
        '450900': '\u7389\u6797\u5e02',
        '451000': '\u767e\u8272\u5e02',
        '451100': '\u8d3a\u5dde\u5e02',
        '451200': '\u6cb3\u6c60\u5e02',
        '451300': '\u6765\u5bbe\u5e02',
        '451400': '\u5d07\u5de6\u5e02',
    },
    '0,450000,450100': {
        '450102': '\u5174\u5b81\u533a',
        '450103': '\u9752\u79c0\u533a',
        '450105': '\u6c5f\u5357\u533a',
        '450107': '\u897f\u4e61\u5858\u533a',
        '450108': '\u826f\u5e86\u533a',
        '450109': '\u9095\u5b81\u533a',
        '450122': '\u6b66\u9e23\u53bf',
        '450123': '\u9686\u5b89\u53bf',
        '450124': '\u9a6c\u5c71\u53bf',
        '450125': '\u4e0a\u6797\u53bf',
        '450126': '\u5bbe\u9633\u53bf',
        '450127': '\u6a2a\u53bf',
        '450128': '\u5176\u5b83\u533a',
    },
    '0,450000,450200': {
        '450202': '\u57ce\u4e2d\u533a',
        '450203': '\u9c7c\u5cf0\u533a',
        '450204': '\u67f3\u5357\u533a',
        '450205': '\u67f3\u5317\u533a',
        '450221': '\u67f3\u6c5f\u53bf',
        '450222': '\u67f3\u57ce\u53bf',
        '450223': '\u9e7f\u5be8\u53bf',
        '450224': '\u878d\u5b89\u53bf',
        '450225': '\u878d\u6c34\u82d7\u65cf\u81ea\u6cbb\u53bf',
        '450226': '\u4e09\u6c5f\u4f97\u65cf\u81ea\u6cbb\u53bf',
        '450227': '\u5176\u5b83\u533a',
    },
    '0,450000,450300': {
        '450302': '\u79c0\u5cf0\u533a',
        '450303': '\u53e0\u5f69\u533a',
        '450304': '\u8c61\u5c71\u533a',
        '450305': '\u4e03\u661f\u533a',
        '450311': '\u96c1\u5c71\u533a',
        '450321': '\u9633\u6714\u53bf',
        '450322': '\u4e34\u6842\u53bf',
        '450323': '\u7075\u5ddd\u53bf',
        '450324': '\u5168\u5dde\u53bf',
        '450325': '\u5174\u5b89\u53bf',
        '450326': '\u6c38\u798f\u53bf',
        '450327': '\u704c\u9633\u53bf',
        '450328': '\u9f99\u80dc\u5404\u65cf\u81ea\u6cbb\u53bf',
        '450329': '\u8d44\u6e90\u53bf',
        '450330': '\u5e73\u4e50\u53bf',
        '450331': '\u8354\u6d66\u53bf',
        '450332': '\u606d\u57ce\u7476\u65cf\u81ea\u6cbb\u53bf',
        '450333': '\u5176\u5b83\u533a',
    },
    '0,450000,450400': {
        '450403': '\u4e07\u79c0\u533a',
        '450404': '\u8776\u5c71\u533a',
        '450405': '\u957f\u6d32\u533a',
        '450421': '\u82cd\u68a7\u53bf',
        '450422': '\u85e4\u53bf',
        '450423': '\u8499\u5c71\u53bf',
        '450481': '\u5c91\u6eaa\u5e02',
        '450482': '\u5176\u5b83\u533a',
    },
    '0,450000,450500': {
        '450502': '\u6d77\u57ce\u533a',
        '450503': '\u94f6\u6d77\u533a',
        '450512': '\u94c1\u5c71\u6e2f\u533a',
        '450521': '\u5408\u6d66\u53bf',
        '450522': '\u5176\u5b83\u533a',
    },
    '0,450000,450600': {
        '450602': '\u6e2f\u53e3\u533a',
        '450603': '\u9632\u57ce\u533a',
        '450621': '\u4e0a\u601d\u53bf',
        '450681': '\u4e1c\u5174\u5e02',
        '450682': '\u5176\u5b83\u533a',
    },
    '0,450000,450700': {
        '450702': '\u94a6\u5357\u533a',
        '450703': '\u94a6\u5317\u533a',
        '450721': '\u7075\u5c71\u53bf',
        '450722': '\u6d66\u5317\u53bf',
        '450723': '\u5176\u5b83\u533a',
    },
    '0,450000,450800': {
        '450802': '\u6e2f\u5317\u533a',
        '450803': '\u6e2f\u5357\u533a',
        '450804': '\u8983\u5858\u533a',
        '450821': '\u5e73\u5357\u53bf',
        '450881': '\u6842\u5e73\u5e02',
        '450882': '\u5176\u5b83\u533a',
    },
    '0,450000,450900': {
        '450902': '\u7389\u5dde\u533a',
        '450921': '\u5bb9\u53bf',
        '450922': '\u9646\u5ddd\u53bf',
        '450923': '\u535a\u767d\u53bf',
        '450924': '\u5174\u4e1a\u53bf',
        '450981': '\u5317\u6d41\u5e02',
        '450982': '\u5176\u5b83\u533a',
    },
    '0,450000,451000': {
        '451002': '\u53f3\u6c5f\u533a',
        '451021': '\u7530\u9633\u53bf',
        '451022': '\u7530\u4e1c\u53bf',
        '451023': '\u5e73\u679c\u53bf',
        '451024': '\u5fb7\u4fdd\u53bf',
        '451025': '\u9756\u897f\u53bf',
        '451026': '\u90a3\u5761\u53bf',
        '451027': '\u51cc\u4e91\u53bf',
        '451028': '\u4e50\u4e1a\u53bf',
        '451029': '\u7530\u6797\u53bf',
        '451030': '\u897f\u6797\u53bf',
        '451031': '\u9686\u6797\u5404\u65cf\u81ea\u6cbb\u53bf',
        '451032': '\u5176\u5b83\u533a',
    },
    '0,450000,451100': {
        '451102': '\u516b\u6b65\u533a',
        '451121': '\u662d\u5e73\u53bf',
        '451122': '\u949f\u5c71\u53bf',
        '451123': '\u5bcc\u5ddd\u7476\u65cf\u81ea\u6cbb\u53bf',
        '451124': '\u5176\u5b83\u533a',
    },
    '0,450000,451200': {
        '451202': '\u91d1\u57ce\u6c5f\u533a',
        '451221': '\u5357\u4e39\u53bf',
        '451222': '\u5929\u5ce8\u53bf',
        '451223': '\u51e4\u5c71\u53bf',
        '451224': '\u4e1c\u5170\u53bf',
        '451225': '\u7f57\u57ce\u4eeb\u4f6c\u65cf\u81ea\u6cbb\u53bf',
        '451226': '\u73af\u6c5f\u6bdb\u5357\u65cf\u81ea\u6cbb\u53bf',
        '451227': '\u5df4\u9a6c\u7476\u65cf\u81ea\u6cbb\u53bf',
        '451228': '\u90fd\u5b89\u7476\u65cf\u81ea\u6cbb\u53bf',
        '451229': '\u5927\u5316\u7476\u65cf\u81ea\u6cbb\u53bf',
        '451281': '\u5b9c\u5dde\u5e02',
        '451282': '\u5176\u5b83\u533a',
    },
    '0,450000,451300': {
        '451302': '\u5174\u5bbe\u533a',
        '451321': '\u5ffb\u57ce\u53bf',
        '451322': '\u8c61\u5dde\u53bf',
        '451323': '\u6b66\u5ba3\u53bf',
        '451324': '\u91d1\u79c0\u7476\u65cf\u81ea\u6cbb\u53bf',
        '451381': '\u5408\u5c71\u5e02',
        '451382': '\u5176\u5b83\u533a',
    },
    '0,450000,451400': {
        '451402': '\u6c5f\u6d32\u533a',
        '451421': '\u6276\u7ee5\u53bf',
        '451422': '\u5b81\u660e\u53bf',
        '451423': '\u9f99\u5dde\u53bf',
        '451424': '\u5927\u65b0\u53bf',
        '451425': '\u5929\u7b49\u53bf',
        '451481': '\u51ed\u7965\u5e02',
        '451482': '\u5176\u5b83\u533a',
    },
    '0,460000': {
        '460100': '\u6d77\u53e3\u5e02',
        '460200': '\u4e09\u4e9a\u5e02',
        '469001': '\u4e94\u6307\u5c71\u5e02',
        '469002': '\u743c\u6d77\u5e02',
        '469003': '\u510b\u5dde\u5e02',
        '469005': '\u6587\u660c\u5e02',
        '469006': '\u4e07\u5b81\u5e02',
        '469007': '\u4e1c\u65b9\u5e02',
        '469025': '\u5b9a\u5b89\u53bf',
        '469026': '\u5c6f\u660c\u53bf',
        '469027': '\u6f84\u8fc8\u53bf',
        '469028': '\u4e34\u9ad8\u53bf',
        '469030': '\u767d\u6c99\u9ece\u65cf\u81ea\u6cbb\u53bf',
        '469031': '\u660c\u6c5f\u9ece\u65cf\u81ea\u6cbb\u53bf',
        '469033': '\u4e50\u4e1c\u9ece\u65cf\u81ea\u6cbb\u53bf',
        '469034': '\u9675\u6c34\u9ece\u65cf\u81ea\u6cbb\u53bf',
        '469035': '\u4fdd\u4ead\u9ece\u65cf\u82d7\u65cf\u81ea\u6cbb\u53bf',
        '469036': '\u743c\u4e2d\u9ece\u65cf\u82d7\u65cf\u81ea\u6cbb\u53bf',
        '469037': '\u897f\u6c99\u7fa4\u5c9b',
        '469038': '\u5357\u6c99\u7fa4\u5c9b',
        '469039': '\u4e2d\u6c99\u7fa4\u5c9b\u7684\u5c9b\u7901\u53ca\u5176\u6d77\u57df',
    },
    '0,460000,460100': {
        '460105': '\u79c0\u82f1\u533a',
        '460106': '\u9f99\u534e\u533a',
        '460107': '\u743c\u5c71\u533a',
        '460108': '\u7f8e\u5170\u533a',
        '460109': '\u5176\u5b83\u533a',
    },
    '0,460000,460200': [],
    '0,460000,469001': [],
    '0,460000,469002': [],
    '0,460000,469003': [],
    '0,460000,469005': [],
    '0,460000,469006': [],
    '0,460000,469007': [],
    '0,460000,469025': [],
    '0,460000,469026': [],
    '0,460000,469027': [],
    '0,460000,469028': [],
    '0,460000,469030': [],
    '0,460000,469031': [],
    '0,460000,469033': [],
    '0,460000,469034': [],
    '0,460000,469035': [],
    '0,460000,469036': [],
    '0,460000,469037': [],
    '0,460000,469038': [],
    '0,460000,469039': [],
    '0,500000': {
        '500100': '\u91cd\u5e86\u5e02',
    },
    '0,500000,500100': {
        '500101': '\u4e07\u5dde\u533a',
        '500102': '\u6daa\u9675\u533a',
        '500103': '\u6e1d\u4e2d\u533a',
        '500104': '\u5927\u6e21\u53e3\u533a',
        '500105': '\u6c5f\u5317\u533a',
        '500106': '\u6c99\u576a\u575d\u533a',
        '500107': '\u4e5d\u9f99\u5761\u533a',
        '500108': '\u5357\u5cb8\u533a',
        '500109': '\u5317\u789a\u533a',
        '500110': '\u4e07\u76db\u533a',
        '500111': '\u53cc\u6865\u533a',
        '500112': '\u6e1d\u5317\u533a',
        '500113': '\u5df4\u5357\u533a',
        '500114': '\u9ed4\u6c5f\u533a',
        '500115': '\u957f\u5bff\u533a',
        '500222': '\u7da6\u6c5f\u53bf',
        '500223': '\u6f7c\u5357\u53bf',
        '500224': '\u94dc\u6881\u53bf',
        '500225': '\u5927\u8db3\u53bf',
        '500226': '\u8363\u660c\u53bf',
        '500227': '\u74a7\u5c71\u53bf',
        '500228': '\u6881\u5e73\u53bf',
        '500229': '\u57ce\u53e3\u53bf',
        '500230': '\u4e30\u90fd\u53bf',
        '500231': '\u57ab\u6c5f\u53bf',
        '500232': '\u6b66\u9686\u53bf',
        '500233': '\u5fe0\u53bf',
        '500234': '\u5f00\u53bf',
        '500235': '\u4e91\u9633\u53bf',
        '500236': '\u5949\u8282\u53bf',
        '500237': '\u5deb\u5c71\u53bf',
        '500238': '\u5deb\u6eaa\u53bf',
        '500240': '\u77f3\u67f1\u571f\u5bb6\u65cf\u81ea\u6cbb\u53bf',
        '500241': '\u79c0\u5c71\u571f\u5bb6\u65cf\u82d7\u65cf\u81ea\u6cbb\u53bf',
        '500242': '\u9149\u9633\u571f\u5bb6\u65cf\u82d7\u65cf\u81ea\u6cbb\u53bf',
        '500243': '\u5f6d\u6c34\u82d7\u65cf\u571f\u5bb6\u65cf\u81ea\u6cbb\u53bf',
        '500381': '\u6c5f\u6d25\u533a',
        '500382': '\u5408\u5ddd\u533a',
        '500383': '\u6c38\u5ddd\u533a',
        '500384': '\u5357\u5ddd\u533a',
        '500385': '\u5176\u5b83\u533a',
    },
    '0,510000': {
        '510100': '\u6210\u90fd\u5e02',
        '510300': '\u81ea\u8d21\u5e02',
        '510400': '\u6500\u679d\u82b1\u5e02',
        '510500': '\u6cf8\u5dde\u5e02',
        '510600': '\u5fb7\u9633\u5e02',
        '510700': '\u7ef5\u9633\u5e02',
        '510800': '\u5e7f\u5143\u5e02',
        '510900': '\u9042\u5b81\u5e02',
        '511000': '\u5185\u6c5f\u5e02',
        '511100': '\u4e50\u5c71\u5e02',
        '511300': '\u5357\u5145\u5e02',
        '511400': '\u7709\u5c71\u5e02',
        '511500': '\u5b9c\u5bbe\u5e02',
        '511600': '\u5e7f\u5b89\u5e02',
        '511700': '\u8fbe\u5dde\u5e02',
        '511800': '\u96c5\u5b89\u5e02',
        '511900': '\u5df4\u4e2d\u5e02',
        '512000': '\u8d44\u9633\u5e02',
        '513200': '\u963f\u575d\u85cf\u65cf\u7f8c\u65cf\u81ea\u6cbb\u5dde',
        '513300': '\u7518\u5b5c\u85cf\u65cf\u81ea\u6cbb\u5dde',
        '513400': '\u51c9\u5c71\u5f5d\u65cf\u81ea\u6cbb\u5dde',
    },
    '0,510000,510100': {
        '510104': '\u9526\u6c5f\u533a',
        '510105': '\u9752\u7f8a\u533a',
        '510106': '\u91d1\u725b\u533a',
        '510107': '\u6b66\u4faf\u533a',
        '510108': '\u6210\u534e\u533a',
        '510112': '\u9f99\u6cc9\u9a7f\u533a',
        '510113': '\u9752\u767d\u6c5f\u533a',
        '510114': '\u65b0\u90fd\u533a',
        '510115': '\u6e29\u6c5f\u533a',
        '510121': '\u91d1\u5802\u53bf',
        '510122': '\u53cc\u6d41\u53bf',
        '510124': '\u90eb\u53bf',
        '510129': '\u5927\u9091\u53bf',
        '510131': '\u84b2\u6c5f\u53bf',
        '510132': '\u65b0\u6d25\u53bf',
        '510181': '\u90fd\u6c5f\u5830\u5e02',
        '510182': '\u5f6d\u5dde\u5e02',
        '510183': '\u909b\u5d03\u5e02',
        '510184': '\u5d07\u5dde\u5e02',
        '510185': '\u5176\u5b83\u533a',
    },
    '0,510000,510300': {
        '510302': '\u81ea\u6d41\u4e95\u533a',
        '510303': '\u8d21\u4e95\u533a',
        '510304': '\u5927\u5b89\u533a',
        '510311': '\u6cbf\u6ee9\u533a',
        '510321': '\u8363\u53bf',
        '510322': '\u5bcc\u987a\u53bf',
        '510323': '\u5176\u5b83\u533a',
    },
    '0,510000,510400': {
        '510402': '\u4e1c\u533a',
        '510403': '\u897f\u533a',
        '510411': '\u4ec1\u548c\u533a',
        '510421': '\u7c73\u6613\u53bf',
        '510422': '\u76d0\u8fb9\u53bf',
        '510423': '\u5176\u5b83\u533a',
    },
    '0,510000,510500': {
        '510502': '\u6c5f\u9633\u533a',
        '510503': '\u7eb3\u6eaa\u533a',
        '510504': '\u9f99\u9a6c\u6f6d\u533a',
        '510521': '\u6cf8\u53bf',
        '510522': '\u5408\u6c5f\u53bf',
        '510524': '\u53d9\u6c38\u53bf',
        '510525': '\u53e4\u853a\u53bf',
        '510526': '\u5176\u5b83\u533a',
    },
    '0,510000,510600': {
        '510603': '\u65cc\u9633\u533a',
        '510623': '\u4e2d\u6c5f\u53bf',
        '510626': '\u7f57\u6c5f\u53bf',
        '510681': '\u5e7f\u6c49\u5e02',
        '510682': '\u4ec0\u90a1\u5e02',
        '510683': '\u7ef5\u7af9\u5e02',
        '510684': '\u5176\u5b83\u533a',
    },
    '0,510000,510700': {
        '510703': '\u6daa\u57ce\u533a',
        '510704': '\u6e38\u4ed9\u533a',
        '510722': '\u4e09\u53f0\u53bf',
        '510723': '\u76d0\u4ead\u53bf',
        '510724': '\u5b89\u53bf',
        '510725': '\u6893\u6f7c\u53bf',
        '510726': '\u5317\u5ddd\u7f8c\u65cf\u81ea\u6cbb\u53bf',
        '510727': '\u5e73\u6b66\u53bf',
        '510751': '\u9ad8\u65b0\u533a',
        '510781': '\u6c5f\u6cb9\u5e02',
        '510782': '\u5176\u5b83\u533a',
    },
    '0,510000,510800': {
        '510802': '\u5229\u5dde\u533a',
        '510811': '\u5143\u575d\u533a',
        '510812': '\u671d\u5929\u533a',
        '510821': '\u65fa\u82cd\u53bf',
        '510822': '\u9752\u5ddd\u53bf',
        '510823': '\u5251\u9601\u53bf',
        '510824': '\u82cd\u6eaa\u53bf',
        '510825': '\u5176\u5b83\u533a',
    },
    '0,510000,510900': {
        '510903': '\u8239\u5c71\u533a',
        '510904': '\u5b89\u5c45\u533a',
        '510921': '\u84ec\u6eaa\u53bf',
        '510922': '\u5c04\u6d2a\u53bf',
        '510923': '\u5927\u82f1\u53bf',
        '510924': '\u5176\u5b83\u533a',
    },
    '0,510000,511000': {
        '511002': '\u5e02\u4e2d\u533a',
        '511011': '\u4e1c\u5174\u533a',
        '511024': '\u5a01\u8fdc\u53bf',
        '511025': '\u8d44\u4e2d\u53bf',
        '511028': '\u9686\u660c\u53bf',
        '511029': '\u5176\u5b83\u533a',
    },
    '0,510000,511100': {
        '511102': '\u5e02\u4e2d\u533a',
        '511111': '\u6c99\u6e7e\u533a',
        '511112': '\u4e94\u901a\u6865\u533a',
        '511113': '\u91d1\u53e3\u6cb3\u533a',
        '511123': '\u728d\u4e3a\u53bf',
        '511124': '\u4e95\u7814\u53bf',
        '511126': '\u5939\u6c5f\u53bf',
        '511129': '\u6c90\u5ddd\u53bf',
        '511132': '\u5ce8\u8fb9\u5f5d\u65cf\u81ea\u6cbb\u53bf',
        '511133': '\u9a6c\u8fb9\u5f5d\u65cf\u81ea\u6cbb\u53bf',
        '511181': '\u5ce8\u7709\u5c71\u5e02',
        '511182': '\u5176\u5b83\u533a',
    },
    '0,510000,511300': {
        '511302': '\u987a\u5e86\u533a',
        '511303': '\u9ad8\u576a\u533a',
        '511304': '\u5609\u9675\u533a',
        '511321': '\u5357\u90e8\u53bf',
        '511322': '\u8425\u5c71\u53bf',
        '511323': '\u84ec\u5b89\u53bf',
        '511324': '\u4eea\u9647\u53bf',
        '511325': '\u897f\u5145\u53bf',
        '511381': '\u9606\u4e2d\u5e02',
        '511382': '\u5176\u5b83\u533a',
    },
    '0,510000,511400': {
        '511402': '\u4e1c\u5761\u533a',
        '511421': '\u4ec1\u5bff\u53bf',
        '511422': '\u5f6d\u5c71\u53bf',
        '511423': '\u6d2a\u96c5\u53bf',
        '511424': '\u4e39\u68f1\u53bf',
        '511425': '\u9752\u795e\u53bf',
        '511426': '\u5176\u5b83\u533a',
    },
    '0,510000,511500': {
        '511502': '\u7fe0\u5c4f\u533a',
        '511521': '\u5b9c\u5bbe\u53bf',
        '511522': '\u5357\u6eaa\u53bf',
        '511523': '\u6c5f\u5b89\u53bf',
        '511524': '\u957f\u5b81\u53bf',
        '511525': '\u9ad8\u53bf',
        '511526': '\u73d9\u53bf',
        '511527': '\u7b60\u8fde\u53bf',
        '511528': '\u5174\u6587\u53bf',
        '511529': '\u5c4f\u5c71\u53bf',
        '511530': '\u5176\u5b83\u533a',
    },
    '0,510000,511600': {
        '511602': '\u5e7f\u5b89\u533a',
        '511621': '\u5cb3\u6c60\u53bf',
        '511622': '\u6b66\u80dc\u53bf',
        '511623': '\u90bb\u6c34\u53bf',
        '511681': '\u534e\u84e5\u5e02',
        '511682': '\u5e02\u8f96\u533a',
        '511683': '\u5176\u5b83\u533a',
    },
    '0,510000,511700': {
        '511702': '\u901a\u5ddd\u533a',
        '511721': '\u8fbe\u53bf',
        '511722': '\u5ba3\u6c49\u53bf',
        '511723': '\u5f00\u6c5f\u53bf',
        '511724': '\u5927\u7af9\u53bf',
        '511725': '\u6e20\u53bf',
        '511781': '\u4e07\u6e90\u5e02',
        '511782': '\u5176\u5b83\u533a',
    },
    '0,510000,511800': {
        '511802': '\u96e8\u57ce\u533a',
        '511821': '\u540d\u5c71\u53bf',
        '511822': '\u8365\u7ecf\u53bf',
        '511823': '\u6c49\u6e90\u53bf',
        '511824': '\u77f3\u68c9\u53bf',
        '511825': '\u5929\u5168\u53bf',
        '511826': '\u82a6\u5c71\u53bf',
        '511827': '\u5b9d\u5174\u53bf',
        '511828': '\u5176\u5b83\u533a',
    },
    '0,510000,511900': {
        '511902': '\u5df4\u5dde\u533a',
        '511921': '\u901a\u6c5f\u53bf',
        '511922': '\u5357\u6c5f\u53bf',
        '511923': '\u5e73\u660c\u53bf',
        '511924': '\u5176\u5b83\u533a',
    },
    '0,510000,512000': {
        '512002': '\u96c1\u6c5f\u533a',
        '512021': '\u5b89\u5cb3\u53bf',
        '512022': '\u4e50\u81f3\u53bf',
        '512081': '\u7b80\u9633\u5e02',
        '512082': '\u5176\u5b83\u533a',
    },
    '0,510000,513200': {
        '513221': '\u6c76\u5ddd\u53bf',
        '513222': '\u7406\u53bf',
        '513223': '\u8302\u53bf',
        '513224': '\u677e\u6f58\u53bf',
        '513225': '\u4e5d\u5be8\u6c9f\u53bf',
        '513226': '\u91d1\u5ddd\u53bf',
        '513227': '\u5c0f\u91d1\u53bf',
        '513228': '\u9ed1\u6c34\u53bf',
        '513229': '\u9a6c\u5c14\u5eb7\u53bf',
        '513230': '\u58e4\u5858\u53bf',
        '513231': '\u963f\u575d\u53bf',
        '513232': '\u82e5\u5c14\u76d6\u53bf',
        '513233': '\u7ea2\u539f\u53bf',
        '513234': '\u5176\u5b83\u533a',
    },
    '0,510000,513300': {
        '513321': '\u5eb7\u5b9a\u53bf',
        '513322': '\u6cf8\u5b9a\u53bf',
        '513323': '\u4e39\u5df4\u53bf',
        '513324': '\u4e5d\u9f99\u53bf',
        '513325': '\u96c5\u6c5f\u53bf',
        '513326': '\u9053\u5b5a\u53bf',
        '513327': '\u7089\u970d\u53bf',
        '513328': '\u7518\u5b5c\u53bf',
        '513329': '\u65b0\u9f99\u53bf',
        '513330': '\u5fb7\u683c\u53bf',
        '513331': '\u767d\u7389\u53bf',
        '513332': '\u77f3\u6e20\u53bf',
        '513333': '\u8272\u8fbe\u53bf',
        '513334': '\u7406\u5858\u53bf',
        '513335': '\u5df4\u5858\u53bf',
        '513336': '\u4e61\u57ce\u53bf',
        '513337': '\u7a3b\u57ce\u53bf',
        '513338': '\u5f97\u8363\u53bf',
        '513339': '\u5176\u5b83\u533a',
    },
    '0,510000,513400': {
        '513401': '\u897f\u660c\u5e02',
        '513422': '\u6728\u91cc\u85cf\u65cf\u81ea\u6cbb\u53bf',
        '513423': '\u76d0\u6e90\u53bf',
        '513424': '\u5fb7\u660c\u53bf',
        '513425': '\u4f1a\u7406\u53bf',
        '513426': '\u4f1a\u4e1c\u53bf',
        '513427': '\u5b81\u5357\u53bf',
        '513428': '\u666e\u683c\u53bf',
        '513429': '\u5e03\u62d6\u53bf',
        '513430': '\u91d1\u9633\u53bf',
        '513431': '\u662d\u89c9\u53bf',
        '513432': '\u559c\u5fb7\u53bf',
        '513433': '\u5195\u5b81\u53bf',
        '513434': '\u8d8a\u897f\u53bf',
        '513435': '\u7518\u6d1b\u53bf',
        '513436': '\u7f8e\u59d1\u53bf',
        '513437': '\u96f7\u6ce2\u53bf',
        '513438': '\u5176\u5b83\u533a',
    },
    '0,520000': {
        '520100': '\u8d35\u9633\u5e02',
        '520200': '\u516d\u76d8\u6c34\u5e02',
        '520300': '\u9075\u4e49\u5e02',
        '520400': '\u5b89\u987a\u5e02',
        '522200': '\u94dc\u4ec1\u5730\u533a',
        '522300': '\u9ed4\u897f\u5357\u5e03\u4f9d\u65cf\u82d7\u65cf\u81ea\u6cbb\u5dde',
        '522400': '\u6bd5\u8282\u5730\u533a',
        '522600': '\u9ed4\u4e1c\u5357\u82d7\u65cf\u4f97\u65cf\u81ea\u6cbb\u5dde',
        '522700': '\u9ed4\u5357\u5e03\u4f9d\u65cf\u82d7\u65cf\u81ea\u6cbb\u5dde',
    },
    '0,520000,520100': {
        '520102': '\u5357\u660e\u533a',
        '520103': '\u4e91\u5ca9\u533a',
        '520111': '\u82b1\u6eaa\u533a',
        '520112': '\u4e4c\u5f53\u533a',
        '520113': '\u767d\u4e91\u533a',
        '520114': '\u5c0f\u6cb3\u533a',
        '520121': '\u5f00\u9633\u53bf',
        '520122': '\u606f\u70fd\u53bf',
        '520123': '\u4fee\u6587\u53bf',
        '520151': '\u91d1\u9633\u5f00\u53d1\u533a',
        '520181': '\u6e05\u9547\u5e02',
        '520182': '\u5176\u5b83\u533a',
    },
    '0,520000,520200': {
        '520201': '\u949f\u5c71\u533a',
        '520203': '\u516d\u679d\u7279\u533a',
        '520221': '\u6c34\u57ce\u53bf',
        '520222': '\u76d8\u53bf',
        '520223': '\u5176\u5b83\u533a',
    },
    '0,520000,520300': {
        '520302': '\u7ea2\u82b1\u5c97\u533a',
        '520303': '\u6c47\u5ddd\u533a',
        '520321': '\u9075\u4e49\u53bf',
        '520322': '\u6850\u6893\u53bf',
        '520323': '\u7ee5\u9633\u53bf',
        '520324': '\u6b63\u5b89\u53bf',
        '520325': '\u9053\u771f\u4ee1\u4f6c\u65cf\u82d7\u65cf\u81ea\u6cbb\u53bf',
        '520326': '\u52a1\u5ddd\u4ee1\u4f6c\u65cf\u82d7\u65cf\u81ea\u6cbb\u53bf',
        '520327': '\u51e4\u5188\u53bf',
        '520328': '\u6e44\u6f6d\u53bf',
        '520329': '\u4f59\u5e86\u53bf',
        '520330': '\u4e60\u6c34\u53bf',
        '520381': '\u8d64\u6c34\u5e02',
        '520382': '\u4ec1\u6000\u5e02',
        '520383': '\u5176\u5b83\u533a',
    },
    '0,520000,520400': {
        '520402': '\u897f\u79c0\u533a',
        '520421': '\u5e73\u575d\u53bf',
        '520422': '\u666e\u5b9a\u53bf',
        '520423': '\u9547\u5b81\u5e03\u4f9d\u65cf\u82d7\u65cf\u81ea\u6cbb\u53bf',
        '520424': '\u5173\u5cad\u5e03\u4f9d\u65cf\u82d7\u65cf\u81ea\u6cbb\u53bf',
        '520425': '\u7d2b\u4e91\u82d7\u65cf\u5e03\u4f9d\u65cf\u81ea\u6cbb\u53bf',
        '520426': '\u5176\u5b83\u533a',
    },
    '0,520000,522200': {
        '522201': '\u94dc\u4ec1\u5e02',
        '522222': '\u6c5f\u53e3\u53bf',
        '522223': '\u7389\u5c4f\u4f97\u65cf\u81ea\u6cbb\u53bf',
        '522224': '\u77f3\u9621\u53bf',
        '522225': '\u601d\u5357\u53bf',
        '522226': '\u5370\u6c5f\u571f\u5bb6\u65cf\u82d7\u65cf\u81ea\u6cbb\u53bf',
        '522227': '\u5fb7\u6c5f\u53bf',
        '522228': '\u6cbf\u6cb3\u571f\u5bb6\u65cf\u81ea\u6cbb\u53bf',
        '522229': '\u677e\u6843\u82d7\u65cf\u81ea\u6cbb\u53bf',
        '522230': '\u4e07\u5c71\u7279\u533a',
        '522231': '\u5176\u5b83\u533a',
    },
    '0,520000,522300': {
        '522301': '\u5174\u4e49\u5e02',
        '522322': '\u5174\u4ec1\u53bf',
        '522323': '\u666e\u5b89\u53bf',
        '522324': '\u6674\u9686\u53bf',
        '522325': '\u8d1e\u4e30\u53bf',
        '522326': '\u671b\u8c1f\u53bf',
        '522327': '\u518c\u4ea8\u53bf',
        '522328': '\u5b89\u9f99\u53bf',
        '522329': '\u5176\u5b83\u533a',
    },
    '0,520000,522400': {
        '522401': '\u6bd5\u8282\u5e02',
        '522422': '\u5927\u65b9\u53bf',
        '522423': '\u9ed4\u897f\u53bf',
        '522424': '\u91d1\u6c99\u53bf',
        '522425': '\u7ec7\u91d1\u53bf',
        '522426': '\u7eb3\u96cd\u53bf',
        '522427': '\u5a01\u5b81\u5f5d\u65cf\u56de\u65cf\u82d7\u65cf\u81ea\u6cbb\u53bf',
        '522428': '\u8d6b\u7ae0\u53bf',
        '522429': '\u5176\u5b83\u533a',
    },
    '0,520000,522600': {
        '522601': '\u51ef\u91cc\u5e02',
        '522622': '\u9ec4\u5e73\u53bf',
        '522623': '\u65bd\u79c9\u53bf',
        '522624': '\u4e09\u7a57\u53bf',
        '522625': '\u9547\u8fdc\u53bf',
        '522626': '\u5c91\u5de9\u53bf',
        '522627': '\u5929\u67f1\u53bf',
        '522628': '\u9526\u5c4f\u53bf',
        '522629': '\u5251\u6cb3\u53bf',
        '522630': '\u53f0\u6c5f\u53bf',
        '522631': '\u9ece\u5e73\u53bf',
        '522632': '\u6995\u6c5f\u53bf',
        '522633': '\u4ece\u6c5f\u53bf',
        '522634': '\u96f7\u5c71\u53bf',
        '522635': '\u9ebb\u6c5f\u53bf',
        '522636': '\u4e39\u5be8\u53bf',
        '522637': '\u5176\u5b83\u533a',
    },
    '0,520000,522700': {
        '522701': '\u90fd\u5300\u5e02',
        '522702': '\u798f\u6cc9\u5e02',
        '522722': '\u8354\u6ce2\u53bf',
        '522723': '\u8d35\u5b9a\u53bf',
        '522725': '\u74ee\u5b89\u53bf',
        '522726': '\u72ec\u5c71\u53bf',
        '522727': '\u5e73\u5858\u53bf',
        '522728': '\u7f57\u7538\u53bf',
        '522729': '\u957f\u987a\u53bf',
        '522730': '\u9f99\u91cc\u53bf',
        '522731': '\u60e0\u6c34\u53bf',
        '522732': '\u4e09\u90fd\u6c34\u65cf\u81ea\u6cbb\u53bf',
        '522733': '\u5176\u5b83\u533a',
    },
    '0,530000': {
        '530100': '\u6606\u660e\u5e02',
        '530300': '\u66f2\u9756\u5e02',
        '530400': '\u7389\u6eaa\u5e02',
        '530500': '\u4fdd\u5c71\u5e02',
        '530600': '\u662d\u901a\u5e02',
        '530700': '\u4e3d\u6c5f\u5e02',
        '530800': '\u666e\u6d31\u5e02',
        '530900': '\u4e34\u6ca7\u5e02',
        '532300': '\u695a\u96c4\u5f5d\u65cf\u81ea\u6cbb\u5dde',
        '532500': '\u7ea2\u6cb3\u54c8\u5c3c\u65cf\u5f5d\u65cf\u81ea\u6cbb\u5dde',
        '532600': '\u6587\u5c71\u58ee\u65cf\u82d7\u65cf\u81ea\u6cbb\u5dde',
        '532800': '\u897f\u53cc\u7248\u7eb3\u50a3\u65cf\u81ea\u6cbb\u5dde',
        '532900': '\u5927\u7406\u767d\u65cf\u81ea\u6cbb\u5dde',
        '533100': '\u5fb7\u5b8f\u50a3\u65cf\u666f\u9887\u65cf\u81ea\u6cbb\u5dde',
        '533300': '\u6012\u6c5f\u5088\u50f3\u65cf\u81ea\u6cbb\u5dde',
        '533400': '\u8fea\u5e86\u85cf\u65cf\u81ea\u6cbb\u5dde',
    },
    '0,530000,530100': {
        '530102': '\u4e94\u534e\u533a',
        '530103': '\u76d8\u9f99\u533a',
        '530111': '\u5b98\u6e21\u533a',
        '530112': '\u897f\u5c71\u533a',
        '530113': '\u4e1c\u5ddd\u533a',
        '530121': '\u5448\u8d21\u53bf',
        '530122': '\u664b\u5b81\u53bf',
        '530124': '\u5bcc\u6c11\u53bf',
        '530125': '\u5b9c\u826f\u53bf',
        '530126': '\u77f3\u6797\u5f5d\u65cf\u81ea\u6cbb\u53bf',
        '530127': '\u5d69\u660e\u53bf',
        '530128': '\u7984\u529d\u5f5d\u65cf\u82d7\u65cf\u81ea\u6cbb\u53bf',
        '530129': '\u5bfb\u7538\u56de\u65cf\u5f5d\u65cf\u81ea\u6cbb\u53bf',
        '530181': '\u5b89\u5b81\u5e02',
        '530182': '\u5176\u5b83\u533a',
    },
    '0,530000,530300': {
        '530302': '\u9e92\u9e9f\u533a',
        '530321': '\u9a6c\u9f99\u53bf',
        '530322': '\u9646\u826f\u53bf',
        '530323': '\u5e08\u5b97\u53bf',
        '530324': '\u7f57\u5e73\u53bf',
        '530325': '\u5bcc\u6e90\u53bf',
        '530326': '\u4f1a\u6cfd\u53bf',
        '530328': '\u6cbe\u76ca\u53bf',
        '530381': '\u5ba3\u5a01\u5e02',
        '530382': '\u5176\u5b83\u533a',
    },
    '0,530000,530400': {
        '530402': '\u7ea2\u5854\u533a',
        '530421': '\u6c5f\u5ddd\u53bf',
        '530422': '\u6f84\u6c5f\u53bf',
        '530423': '\u901a\u6d77\u53bf',
        '530424': '\u534e\u5b81\u53bf',
        '530425': '\u6613\u95e8\u53bf',
        '530426': '\u5ce8\u5c71\u5f5d\u65cf\u81ea\u6cbb\u53bf',
        '530427': '\u65b0\u5e73\u5f5d\u65cf\u50a3\u65cf\u81ea\u6cbb\u53bf',
        '530428': '\u5143\u6c5f\u54c8\u5c3c\u65cf\u5f5d\u65cf\u50a3\u65cf\u81ea\u6cbb\u53bf',
        '530429': '\u5176\u5b83\u533a',
    },
    '0,530000,530500': {
        '530502': '\u9686\u9633\u533a',
        '530521': '\u65bd\u7538\u53bf',
        '530522': '\u817e\u51b2\u53bf',
        '530523': '\u9f99\u9675\u53bf',
        '530524': '\u660c\u5b81\u53bf',
        '530525': '\u5176\u5b83\u533a',
    },
    '0,530000,530600': {
        '530602': '\u662d\u9633\u533a',
        '530621': '\u9c81\u7538\u53bf',
        '530622': '\u5de7\u5bb6\u53bf',
        '530623': '\u76d0\u6d25\u53bf',
        '530624': '\u5927\u5173\u53bf',
        '530625': '\u6c38\u5584\u53bf',
        '530626': '\u7ee5\u6c5f\u53bf',
        '530627': '\u9547\u96c4\u53bf',
        '530628': '\u5f5d\u826f\u53bf',
        '530629': '\u5a01\u4fe1\u53bf',
        '530630': '\u6c34\u5bcc\u53bf',
        '530631': '\u5176\u5b83\u533a',
    },
    '0,530000,530700': {
        '530702': '\u53e4\u57ce\u533a',
        '530721': '\u7389\u9f99\u7eb3\u897f\u65cf\u81ea\u6cbb\u53bf',
        '530722': '\u6c38\u80dc\u53bf',
        '530723': '\u534e\u576a\u53bf',
        '530724': '\u5b81\u8497\u5f5d\u65cf\u81ea\u6cbb\u53bf',
        '530725': '\u5176\u5b83\u533a',
    },
    '0,530000,530800': {
        '530802': '\u601d\u8305\u533a',
        '530821': '\u5b81\u6d31\u54c8\u5c3c\u65cf\u5f5d\u65cf\u81ea\u6cbb\u53bf',
        '530822': '\u58a8\u6c5f\u54c8\u5c3c\u65cf\u81ea\u6cbb\u53bf',
        '530823': '\u666f\u4e1c\u5f5d\u65cf\u81ea\u6cbb\u53bf',
        '530824': '\u666f\u8c37\u50a3\u65cf\u5f5d\u65cf\u81ea\u6cbb\u53bf',
        '530825': '\u9547\u6c85\u5f5d\u65cf\u54c8\u5c3c\u65cf\u62c9\u795c\u65cf\u81ea\u6cbb\u53bf',
        '530826': '\u6c5f\u57ce\u54c8\u5c3c\u65cf\u5f5d\u65cf\u81ea\u6cbb\u53bf',
        '530827': '\u5b5f\u8fde\u50a3\u65cf\u62c9\u795c\u65cf\u4f64\u65cf\u81ea\u6cbb\u53bf',
        '530828': '\u6f9c\u6ca7\u62c9\u795c\u65cf\u81ea\u6cbb\u53bf',
        '530829': '\u897f\u76df\u4f64\u65cf\u81ea\u6cbb\u53bf',
        '530830': '\u5176\u5b83\u533a',
    },
    '0,530000,530900': {
        '530902': '\u4e34\u7fd4\u533a',
        '530921': '\u51e4\u5e86\u53bf',
        '530922': '\u4e91\u53bf',
        '530923': '\u6c38\u5fb7\u53bf',
        '530924': '\u9547\u5eb7\u53bf',
        '530925': '\u53cc\u6c5f\u62c9\u795c\u65cf\u4f64\u65cf\u5e03\u6717\u65cf\u50a3\u65cf\u81ea\u6cbb\u53bf',
        '530926': '\u803f\u9a6c\u50a3\u65cf\u4f64\u65cf\u81ea\u6cbb\u53bf',
        '530927': '\u6ca7\u6e90\u4f64\u65cf\u81ea\u6cbb\u53bf',
        '530928': '\u5176\u5b83\u533a',
    },
    '0,530000,532300': {
        '532301': '\u695a\u96c4\u5e02',
        '532322': '\u53cc\u67cf\u53bf',
        '532323': '\u725f\u5b9a\u53bf',
        '532324': '\u5357\u534e\u53bf',
        '532325': '\u59da\u5b89\u53bf',
        '532326': '\u5927\u59da\u53bf',
        '532327': '\u6c38\u4ec1\u53bf',
        '532328': '\u5143\u8c0b\u53bf',
        '532329': '\u6b66\u5b9a\u53bf',
        '532331': '\u7984\u4e30\u53bf',
        '532332': '\u5176\u5b83\u533a',
    },
    '0,530000,532500': {
        '532501': '\u4e2a\u65e7\u5e02',
        '532502': '\u5f00\u8fdc\u5e02',
        '532522': '\u8499\u81ea\u53bf',
        '532523': '\u5c4f\u8fb9\u82d7\u65cf\u81ea\u6cbb\u53bf',
        '532524': '\u5efa\u6c34\u53bf',
        '532525': '\u77f3\u5c4f\u53bf',
        '532526': '\u5f25\u52d2\u53bf',
        '532527': '\u6cf8\u897f\u53bf',
        '532528': '\u5143\u9633\u53bf',
        '532529': '\u7ea2\u6cb3\u53bf',
        '532530': '\u91d1\u5e73\u82d7\u65cf\u7476\u65cf\u50a3\u65cf\u81ea\u6cbb\u53bf',
        '532531': '\u7eff\u6625\u53bf',
        '532532': '\u6cb3\u53e3\u7476\u65cf\u81ea\u6cbb\u53bf',
        '532533': '\u5176\u5b83\u533a',
    },
    '0,530000,532600': {
        '532621': '\u6587\u5c71\u53bf',
        '532622': '\u781a\u5c71\u53bf',
        '532623': '\u897f\u7574\u53bf',
        '532624': '\u9ebb\u6817\u5761\u53bf',
        '532625': '\u9a6c\u5173\u53bf',
        '532626': '\u4e18\u5317\u53bf',
        '532627': '\u5e7f\u5357\u53bf',
        '532628': '\u5bcc\u5b81\u53bf',
        '532629': '\u5176\u5b83\u533a',
    },
    '0,530000,532800': {
        '532801': '\u666f\u6d2a\u5e02',
        '532822': '\u52d0\u6d77\u53bf',
        '532823': '\u52d0\u814a\u53bf',
        '532824': '\u5176\u5b83\u533a',
    },
    '0,530000,532900': {
        '532901': '\u5927\u7406\u5e02',
        '532922': '\u6f3e\u6fde\u5f5d\u65cf\u81ea\u6cbb\u53bf',
        '532923': '\u7965\u4e91\u53bf',
        '532924': '\u5bbe\u5ddd\u53bf',
        '532925': '\u5f25\u6e21\u53bf',
        '532926': '\u5357\u6da7\u5f5d\u65cf\u81ea\u6cbb\u53bf',
        '532927': '\u5dcd\u5c71\u5f5d\u65cf\u56de\u65cf\u81ea\u6cbb\u53bf',
        '532928': '\u6c38\u5e73\u53bf',
        '532929': '\u4e91\u9f99\u53bf',
        '532930': '\u6d31\u6e90\u53bf',
        '532931': '\u5251\u5ddd\u53bf',
        '532932': '\u9e64\u5e86\u53bf',
        '532933': '\u5176\u5b83\u533a',
    },
    '0,530000,533100': {
        '533102': '\u745e\u4e3d\u5e02',
        '533103': '\u6f5e\u897f\u5e02',
        '533122': '\u6881\u6cb3\u53bf',
        '533123': '\u76c8\u6c5f\u53bf',
        '533124': '\u9647\u5ddd\u53bf',
        '533125': '\u5176\u5b83\u533a',
    },
    '0,530000,533300': {
        '533321': '\u6cf8\u6c34\u53bf',
        '533323': '\u798f\u8d21\u53bf',
        '533324': '\u8d21\u5c71\u72ec\u9f99\u65cf\u6012\u65cf\u81ea\u6cbb\u53bf',
        '533325': '\u5170\u576a\u767d\u65cf\u666e\u7c73\u65cf\u81ea\u6cbb\u53bf',
        '533326': '\u5176\u5b83\u533a',
    },
    '0,530000,533400': {
        '533421': '\u9999\u683c\u91cc\u62c9\u53bf',
        '533422': '\u5fb7\u94a6\u53bf',
        '533423': '\u7ef4\u897f\u5088\u50f3\u65cf\u81ea\u6cbb\u53bf',
        '533424': '\u5176\u5b83\u533a',
    },
    '0,540000': {
        '540100': '\u62c9\u8428\u5e02',
        '542100': '\u660c\u90fd\u5730\u533a',
        '542200': '\u5c71\u5357\u5730\u533a',
        '542300': '\u65e5\u5580\u5219\u5730\u533a',
        '542400': '\u90a3\u66f2\u5730\u533a',
        '542500': '\u963f\u91cc\u5730\u533a',
        '542600': '\u6797\u829d\u5730\u533a',
    },
    '0,540000,540100': {
        '540102': '\u57ce\u5173\u533a',
        '540121': '\u6797\u5468\u53bf',
        '540122': '\u5f53\u96c4\u53bf',
        '540123': '\u5c3c\u6728\u53bf',
        '540124': '\u66f2\u6c34\u53bf',
        '540125': '\u5806\u9f99\u5fb7\u5e86\u53bf',
        '540126': '\u8fbe\u5b5c\u53bf',
        '540127': '\u58a8\u7af9\u5de5\u5361\u53bf',
        '540128': '\u5176\u5b83\u533a',
    },
    '0,540000,542100': {
        '542121': '\u660c\u90fd\u53bf',
        '542122': '\u6c5f\u8fbe\u53bf',
        '542123': '\u8d21\u89c9\u53bf',
        '542124': '\u7c7b\u4e4c\u9f50\u53bf',
        '542125': '\u4e01\u9752\u53bf',
        '542126': '\u5bdf\u96c5\u53bf',
        '542127': '\u516b\u5bbf\u53bf',
        '542128': '\u5de6\u8d21\u53bf',
        '542129': '\u8292\u5eb7\u53bf',
        '542132': '\u6d1b\u9686\u53bf',
        '542133': '\u8fb9\u575d\u53bf',
        '542134': '\u5176\u5b83\u533a',
    },
    '0,540000,542200': {
        '542221': '\u4e43\u4e1c\u53bf',
        '542222': '\u624e\u56ca\u53bf',
        '542223': '\u8d21\u560e\u53bf',
        '542224': '\u6851\u65e5\u53bf',
        '542225': '\u743c\u7ed3\u53bf',
        '542226': '\u66f2\u677e\u53bf',
        '542227': '\u63aa\u7f8e\u53bf',
        '542228': '\u6d1b\u624e\u53bf',
        '542229': '\u52a0\u67e5\u53bf',
        '542231': '\u9686\u5b50\u53bf',
        '542232': '\u9519\u90a3\u53bf',
        '542233': '\u6d6a\u5361\u5b50\u53bf',
        '542234': '\u5176\u5b83\u533a',
    },
    '0,540000,542300': {
        '542301': '\u65e5\u5580\u5219\u5e02',
        '542322': '\u5357\u6728\u6797\u53bf',
        '542323': '\u6c5f\u5b5c\u53bf',
        '542324': '\u5b9a\u65e5\u53bf',
        '542325': '\u8428\u8fe6\u53bf',
        '542326': '\u62c9\u5b5c\u53bf',
        '542327': '\u6602\u4ec1\u53bf',
        '542328': '\u8c22\u901a\u95e8\u53bf',
        '542329': '\u767d\u6717\u53bf',
        '542330': '\u4ec1\u5e03\u53bf',
        '542331': '\u5eb7\u9a6c\u53bf',
        '542332': '\u5b9a\u7ed3\u53bf',
        '542333': '\u4ef2\u5df4\u53bf',
        '542334': '\u4e9a\u4e1c\u53bf',
        '542335': '\u5409\u9686\u53bf',
        '542336': '\u8042\u62c9\u6728\u53bf',
        '542337': '\u8428\u560e\u53bf',
        '542338': '\u5c97\u5df4\u53bf',
        '542339': '\u5176\u5b83\u533a',
    },
    '0,540000,542400': {
        '542421': '\u90a3\u66f2\u53bf',
        '542422': '\u5609\u9ece\u53bf',
        '542423': '\u6bd4\u5982\u53bf',
        '542424': '\u8042\u8363\u53bf',
        '542425': '\u5b89\u591a\u53bf',
        '542426': '\u7533\u624e\u53bf',
        '542427': '\u7d22\u53bf',
        '542428': '\u73ed\u6208\u53bf',
        '542429': '\u5df4\u9752\u53bf',
        '542430': '\u5c3c\u739b\u53bf',
        '542431': '\u5176\u5b83\u533a',
    },
    '0,540000,542500': {
        '542521': '\u666e\u5170\u53bf',
        '542522': '\u672d\u8fbe\u53bf',
        '542523': '\u5676\u5c14\u53bf',
        '542524': '\u65e5\u571f\u53bf',
        '542525': '\u9769\u5409\u53bf',
        '542526': '\u6539\u5219\u53bf',
        '542527': '\u63aa\u52e4\u53bf',
        '542528': '\u5176\u5b83\u533a',
    },
    '0,540000,542600': {
        '542621': '\u6797\u829d\u53bf',
        '542622': '\u5de5\u5e03\u6c5f\u8fbe\u53bf',
        '542623': '\u7c73\u6797\u53bf',
        '542624': '\u58a8\u8131\u53bf',
        '542625': '\u6ce2\u5bc6\u53bf',
        '542626': '\u5bdf\u9685\u53bf',
        '542627': '\u6717\u53bf',
        '542628': '\u5176\u5b83\u533a',
    },
    '0,610000': {
        '610100': '\u897f\u5b89\u5e02',
        '610200': '\u94dc\u5ddd\u5e02',
        '610300': '\u5b9d\u9e21\u5e02',
        '610400': '\u54b8\u9633\u5e02',
        '610500': '\u6e2d\u5357\u5e02',
        '610600': '\u5ef6\u5b89\u5e02',
        '610700': '\u6c49\u4e2d\u5e02',
        '610800': '\u6986\u6797\u5e02',
        '610900': '\u5b89\u5eb7\u5e02',
        '611000': '\u5546\u6d1b\u5e02',
    },
    '0,610000,610100': {
        '610102': '\u65b0\u57ce\u533a',
        '610103': '\u7891\u6797\u533a',
        '610104': '\u83b2\u6e56\u533a',
        '610111': '\u705e\u6865\u533a',
        '610112': '\u672a\u592e\u533a',
        '610113': '\u96c1\u5854\u533a',
        '610114': '\u960e\u826f\u533a',
        '610115': '\u4e34\u6f7c\u533a',
        '610116': '\u957f\u5b89\u533a',
        '610122': '\u84dd\u7530\u53bf',
        '610124': '\u5468\u81f3\u53bf',
        '610125': '\u6237\u53bf',
        '610126': '\u9ad8\u9675\u53bf',
        '610127': '\u5176\u5b83\u533a',
    },
    '0,610000,610200': {
        '610202': '\u738b\u76ca\u533a',
        '610203': '\u5370\u53f0\u533a',
        '610204': '\u8000\u5dde\u533a',
        '610222': '\u5b9c\u541b\u53bf',
        '610223': '\u5176\u5b83\u533a',
    },
    '0,610000,610300': {
        '610302': '\u6e2d\u6ee8\u533a',
        '610303': '\u91d1\u53f0\u533a',
        '610304': '\u9648\u4ed3\u533a',
        '610322': '\u51e4\u7fd4\u53bf',
        '610323': '\u5c90\u5c71\u53bf',
        '610324': '\u6276\u98ce\u53bf',
        '610326': '\u7709\u53bf',
        '610327': '\u9647\u53bf',
        '610328': '\u5343\u9633\u53bf',
        '610329': '\u9e9f\u6e38\u53bf',
        '610330': '\u51e4\u53bf',
        '610331': '\u592a\u767d\u53bf',
        '610332': '\u5176\u5b83\u533a',
    },
    '0,610000,610400': {
        '610402': '\u79e6\u90fd\u533a',
        '610403': '\u6768\u9675\u533a',
        '610404': '\u6e2d\u57ce\u533a',
        '610422': '\u4e09\u539f\u53bf',
        '610423': '\u6cfe\u9633\u53bf',
        '610424': '\u4e7e\u53bf',
        '610425': '\u793c\u6cc9\u53bf',
        '610426': '\u6c38\u5bff\u53bf',
        '610427': '\u5f6c\u53bf',
        '610428': '\u957f\u6b66\u53bf',
        '610429': '\u65ec\u9091\u53bf',
        '610430': '\u6df3\u5316\u53bf',
        '610431': '\u6b66\u529f\u53bf',
        '610481': '\u5174\u5e73\u5e02',
        '610482': '\u5176\u5b83\u533a',
    },
    '0,610000,610500': {
        '610502': '\u4e34\u6e2d\u533a',
        '610521': '\u534e\u53bf',
        '610522': '\u6f7c\u5173\u53bf',
        '610523': '\u5927\u8354\u53bf',
        '610524': '\u5408\u9633\u53bf',
        '610525': '\u6f84\u57ce\u53bf',
        '610526': '\u84b2\u57ce\u53bf',
        '610527': '\u767d\u6c34\u53bf',
        '610528': '\u5bcc\u5e73\u53bf',
        '610581': '\u97e9\u57ce\u5e02',
        '610582': '\u534e\u9634\u5e02',
        '610583': '\u5176\u5b83\u533a',
    },
    '0,610000,610600': {
        '610602': '\u5b9d\u5854\u533a',
        '610621': '\u5ef6\u957f\u53bf',
        '610622': '\u5ef6\u5ddd\u53bf',
        '610623': '\u5b50\u957f\u53bf',
        '610624': '\u5b89\u585e\u53bf',
        '610625': '\u5fd7\u4e39\u53bf',
        '610626': '\u5434\u8d77\u53bf',
        '610627': '\u7518\u6cc9\u53bf',
        '610628': '\u5bcc\u53bf',
        '610629': '\u6d1b\u5ddd\u53bf',
        '610630': '\u5b9c\u5ddd\u53bf',
        '610631': '\u9ec4\u9f99\u53bf',
        '610632': '\u9ec4\u9675\u53bf',
        '610633': '\u5176\u5b83\u533a',
    },
    '0,610000,610700': {
        '610702': '\u6c49\u53f0\u533a',
        '610721': '\u5357\u90d1\u53bf',
        '610722': '\u57ce\u56fa\u53bf',
        '610723': '\u6d0b\u53bf',
        '610724': '\u897f\u4e61\u53bf',
        '610725': '\u52c9\u53bf',
        '610726': '\u5b81\u5f3a\u53bf',
        '610727': '\u7565\u9633\u53bf',
        '610728': '\u9547\u5df4\u53bf',
        '610729': '\u7559\u575d\u53bf',
        '610730': '\u4f5b\u576a\u53bf',
        '610731': '\u5176\u5b83\u533a',
    },
    '0,610000,610800': {
        '610802': '\u6986\u9633\u533a',
        '610821': '\u795e\u6728\u53bf',
        '610822': '\u5e9c\u8c37\u53bf',
        '610823': '\u6a2a\u5c71\u53bf',
        '610824': '\u9756\u8fb9\u53bf',
        '610825': '\u5b9a\u8fb9\u53bf',
        '610826': '\u7ee5\u5fb7\u53bf',
        '610827': '\u7c73\u8102\u53bf',
        '610828': '\u4f73\u53bf',
        '610829': '\u5434\u5821\u53bf',
        '610830': '\u6e05\u6da7\u53bf',
        '610831': '\u5b50\u6d32\u53bf',
        '610832': '\u5176\u5b83\u533a',
    },
    '0,610000,610900': {
        '610902': '\u6c49\u6ee8\u533a',
        '610921': '\u6c49\u9634\u53bf',
        '610922': '\u77f3\u6cc9\u53bf',
        '610923': '\u5b81\u9655\u53bf',
        '610924': '\u7d2b\u9633\u53bf',
        '610925': '\u5c9a\u768b\u53bf',
        '610926': '\u5e73\u5229\u53bf',
        '610927': '\u9547\u576a\u53bf',
        '610928': '\u65ec\u9633\u53bf',
        '610929': '\u767d\u6cb3\u53bf',
        '610930': '\u5176\u5b83\u533a',
    },
    '0,610000,611000': {
        '611002': '\u5546\u5dde\u533a',
        '611021': '\u6d1b\u5357\u53bf',
        '611022': '\u4e39\u51e4\u53bf',
        '611023': '\u5546\u5357\u53bf',
        '611024': '\u5c71\u9633\u53bf',
        '611025': '\u9547\u5b89\u53bf',
        '611026': '\u67de\u6c34\u53bf',
        '611027': '\u5176\u5b83\u533a',
    },
    '0,620000': {
        '620100': '\u5170\u5dde\u5e02',
        '620200': '\u5609\u5cea\u5173\u5e02',
        '620300': '\u91d1\u660c\u5e02',
        '620400': '\u767d\u94f6\u5e02',
        '620500': '\u5929\u6c34\u5e02',
        '620600': '\u6b66\u5a01\u5e02',
        '620700': '\u5f20\u6396\u5e02',
        '620800': '\u5e73\u51c9\u5e02',
        '620900': '\u9152\u6cc9\u5e02',
        '621000': '\u5e86\u9633\u5e02',
        '621100': '\u5b9a\u897f\u5e02',
        '621200': '\u9647\u5357\u5e02',
        '622900': '\u4e34\u590f\u56de\u65cf\u81ea\u6cbb\u5dde',
        '623000': '\u7518\u5357\u85cf\u65cf\u81ea\u6cbb\u5dde',
    },
    '0,620000,620100': {
        '620102': '\u57ce\u5173\u533a',
        '620103': '\u4e03\u91cc\u6cb3\u533a',
        '620104': '\u897f\u56fa\u533a',
        '620105': '\u5b89\u5b81\u533a',
        '620111': '\u7ea2\u53e4\u533a',
        '620121': '\u6c38\u767b\u53bf',
        '620122': '\u768b\u5170\u53bf',
        '620123': '\u6986\u4e2d\u53bf',
        '620124': '\u5176\u5b83\u533a',
    },
    '0,620000,620200': [],
    '0,620000,620300': {
        '620302': '\u91d1\u5ddd\u533a',
        '620321': '\u6c38\u660c\u53bf',
        '620322': '\u5176\u5b83\u533a',
    },
    '0,620000,620400': {
        '620402': '\u767d\u94f6\u533a',
        '620403': '\u5e73\u5ddd\u533a',
        '620421': '\u9756\u8fdc\u53bf',
        '620422': '\u4f1a\u5b81\u53bf',
        '620423': '\u666f\u6cf0\u53bf',
        '620424': '\u5176\u5b83\u533a',
    },
    '0,620000,620500': {
        '620502': '\u79e6\u5dde\u533a',
        '620503': '\u9ea6\u79ef\u533a',
        '620521': '\u6e05\u6c34\u53bf',
        '620522': '\u79e6\u5b89\u53bf',
        '620523': '\u7518\u8c37\u53bf',
        '620524': '\u6b66\u5c71\u53bf',
        '620525': '\u5f20\u5bb6\u5ddd\u56de\u65cf\u81ea\u6cbb\u53bf',
        '620526': '\u5176\u5b83\u533a',
    },
    '0,620000,620600': {
        '620602': '\u51c9\u5dde\u533a',
        '620621': '\u6c11\u52e4\u53bf',
        '620622': '\u53e4\u6d6a\u53bf',
        '620623': '\u5929\u795d\u85cf\u65cf\u81ea\u6cbb\u53bf',
        '620624': '\u5176\u5b83\u533a',
    },
    '0,620000,620700': {
        '620702': '\u7518\u5dde\u533a',
        '620721': '\u8083\u5357\u88d5\u56fa\u65cf\u81ea\u6cbb\u53bf',
        '620722': '\u6c11\u4e50\u53bf',
        '620723': '\u4e34\u6cfd\u53bf',
        '620724': '\u9ad8\u53f0\u53bf',
        '620725': '\u5c71\u4e39\u53bf',
        '620726': '\u5176\u5b83\u533a',
    },
    '0,620000,620800': {
        '620802': '\u5d06\u5cd2\u533a',
        '620821': '\u6cfe\u5ddd\u53bf',
        '620822': '\u7075\u53f0\u53bf',
        '620823': '\u5d07\u4fe1\u53bf',
        '620824': '\u534e\u4ead\u53bf',
        '620825': '\u5e84\u6d6a\u53bf',
        '620826': '\u9759\u5b81\u53bf',
        '620827': '\u5176\u5b83\u533a',
    },
    '0,620000,620900': {
        '620902': '\u8083\u5dde\u533a',
        '620921': '\u91d1\u5854\u53bf',
        '620922': '\u5b89\u897f\u53bf',
        '620923': '\u8083\u5317\u8499\u53e4\u65cf\u81ea\u6cbb\u53bf',
        '620924': '\u963f\u514b\u585e\u54c8\u8428\u514b\u65cf\u81ea\u6cbb\u53bf',
        '620981': '\u7389\u95e8\u5e02',
        '620982': '\u6566\u714c\u5e02',
        '620983': '\u5176\u5b83\u533a',
    },
    '0,620000,621000': {
        '621002': '\u897f\u5cf0\u533a',
        '621021': '\u5e86\u57ce\u53bf',
        '621022': '\u73af\u53bf',
        '621023': '\u534e\u6c60\u53bf',
        '621024': '\u5408\u6c34\u53bf',
        '621025': '\u6b63\u5b81\u53bf',
        '621026': '\u5b81\u53bf',
        '621027': '\u9547\u539f\u53bf',
        '621028': '\u5176\u5b83\u533a',
    },
    '0,620000,621100': {
        '621102': '\u5b89\u5b9a\u533a',
        '621121': '\u901a\u6e2d\u53bf',
        '621122': '\u9647\u897f\u53bf',
        '621123': '\u6e2d\u6e90\u53bf',
        '621124': '\u4e34\u6d2e\u53bf',
        '621125': '\u6f33\u53bf',
        '621126': '\u5cb7\u53bf',
        '621127': '\u5176\u5b83\u533a',
    },
    '0,620000,621200': {
        '621202': '\u6b66\u90fd\u533a',
        '621221': '\u6210\u53bf',
        '621222': '\u6587\u53bf',
        '621223': '\u5b95\u660c\u53bf',
        '621224': '\u5eb7\u53bf',
        '621225': '\u897f\u548c\u53bf',
        '621226': '\u793c\u53bf',
        '621227': '\u5fbd\u53bf',
        '621228': '\u4e24\u5f53\u53bf',
        '621229': '\u5176\u5b83\u533a',
    },
    '0,620000,622900': {
        '622901': '\u4e34\u590f\u5e02',
        '622921': '\u4e34\u590f\u53bf',
        '622922': '\u5eb7\u4e50\u53bf',
        '622923': '\u6c38\u9756\u53bf',
        '622924': '\u5e7f\u6cb3\u53bf',
        '622925': '\u548c\u653f\u53bf',
        '622926': '\u4e1c\u4e61\u65cf\u81ea\u6cbb\u53bf',
        '622927': '\u79ef\u77f3\u5c71\u4fdd\u5b89\u65cf\u4e1c\u4e61\u65cf\u6492\u62c9\u65cf\u81ea\u6cbb\u53bf',
        '622928': '\u5176\u5b83\u533a',
    },
    '0,620000,623000': {
        '623001': '\u5408\u4f5c\u5e02',
        '623021': '\u4e34\u6f6d\u53bf',
        '623022': '\u5353\u5c3c\u53bf',
        '623023': '\u821f\u66f2\u53bf',
        '623024': '\u8fed\u90e8\u53bf',
        '623025': '\u739b\u66f2\u53bf',
        '623026': '\u788c\u66f2\u53bf',
        '623027': '\u590f\u6cb3\u53bf',
        '623028': '\u5176\u5b83\u533a',
    },
    '0,630000': {
        '630100': '\u897f\u5b81\u5e02',
        '632100': '\u6d77\u4e1c\u5730\u533a',
        '632200': '\u6d77\u5317\u85cf\u65cf\u81ea\u6cbb\u5dde',
        '632300': '\u9ec4\u5357\u85cf\u65cf\u81ea\u6cbb\u5dde',
        '632500': '\u6d77\u5357\u85cf\u65cf\u81ea\u6cbb\u5dde',
        '632600': '\u679c\u6d1b\u85cf\u65cf\u81ea\u6cbb\u5dde',
        '632700': '\u7389\u6811\u85cf\u65cf\u81ea\u6cbb\u5dde',
        '632800': '\u6d77\u897f\u8499\u53e4\u65cf\u85cf\u65cf\u81ea\u6cbb\u5dde',
    },
    '0,630000,630100': {
        '630102': '\u57ce\u4e1c\u533a',
        '630103': '\u57ce\u4e2d\u533a',
        '630104': '\u57ce\u897f\u533a',
        '630105': '\u57ce\u5317\u533a',
        '630121': '\u5927\u901a\u56de\u65cf\u571f\u65cf\u81ea\u6cbb\u53bf',
        '630122': '\u6e5f\u4e2d\u53bf',
        '630123': '\u6e5f\u6e90\u53bf',
        '630124': '\u5176\u5b83\u533a',
    },
    '0,630000,632100': {
        '632121': '\u5e73\u5b89\u53bf',
        '632122': '\u6c11\u548c\u56de\u65cf\u571f\u65cf\u81ea\u6cbb\u53bf',
        '632123': '\u4e50\u90fd\u53bf',
        '632126': '\u4e92\u52a9\u571f\u65cf\u81ea\u6cbb\u53bf',
        '632127': '\u5316\u9686\u56de\u65cf\u81ea\u6cbb\u53bf',
        '632128': '\u5faa\u5316\u6492\u62c9\u65cf\u81ea\u6cbb\u53bf',
        '632129': '\u5176\u5b83\u533a',
    },
    '0,630000,632200': {
        '632221': '\u95e8\u6e90\u56de\u65cf\u81ea\u6cbb\u53bf',
        '632222': '\u7941\u8fde\u53bf',
        '632223': '\u6d77\u664f\u53bf',
        '632224': '\u521a\u5bdf\u53bf',
        '632225': '\u5176\u5b83\u533a',
    },
    '0,630000,632300': {
        '632321': '\u540c\u4ec1\u53bf',
        '632322': '\u5c16\u624e\u53bf',
        '632323': '\u6cfd\u5e93\u53bf',
        '632324': '\u6cb3\u5357\u8499\u53e4\u65cf\u81ea\u6cbb\u53bf',
        '632325': '\u5176\u5b83\u533a',
    },
    '0,630000,632500': {
        '632521': '\u5171\u548c\u53bf',
        '632522': '\u540c\u5fb7\u53bf',
        '632523': '\u8d35\u5fb7\u53bf',
        '632524': '\u5174\u6d77\u53bf',
        '632525': '\u8d35\u5357\u53bf',
        '632526': '\u5176\u5b83\u533a',
    },
    '0,630000,632600': {
        '632621': '\u739b\u6c81\u53bf',
        '632622': '\u73ed\u739b\u53bf',
        '632623': '\u7518\u5fb7\u53bf',
        '632624': '\u8fbe\u65e5\u53bf',
        '632625': '\u4e45\u6cbb\u53bf',
        '632626': '\u739b\u591a\u53bf',
        '632627': '\u5176\u5b83\u533a',
    },
    '0,630000,632700': {
        '632721': '\u7389\u6811\u53bf',
        '632722': '\u6742\u591a\u53bf',
        '632723': '\u79f0\u591a\u53bf',
        '632724': '\u6cbb\u591a\u53bf',
        '632725': '\u56ca\u8c26\u53bf',
        '632726': '\u66f2\u9ebb\u83b1\u53bf',
        '632727': '\u5176\u5b83\u533a',
    },
    '0,630000,632800': {
        '632801': '\u683c\u5c14\u6728\u5e02',
        '632802': '\u5fb7\u4ee4\u54c8\u5e02',
        '632821': '\u4e4c\u5170\u53bf',
        '632822': '\u90fd\u5170\u53bf',
        '632823': '\u5929\u5cfb\u53bf',
        '632824': '\u5176\u5b83\u533a',
    },
    '0,640000': {
        '640100': '\u94f6\u5ddd\u5e02',
        '640200': '\u77f3\u5634\u5c71\u5e02',
        '640300': '\u5434\u5fe0\u5e02',
        '640400': '\u56fa\u539f\u5e02',
        '640500': '\u4e2d\u536b\u5e02',
    },
    '0,640000,640100': {
        '640104': '\u5174\u5e86\u533a',
        '640105': '\u897f\u590f\u533a',
        '640106': '\u91d1\u51e4\u533a',
        '640121': '\u6c38\u5b81\u53bf',
        '640122': '\u8d3a\u5170\u53bf',
        '640181': '\u7075\u6b66\u5e02',
        '640182': '\u5176\u5b83\u533a',
    },
    '0,640000,640200': {
        '640202': '\u5927\u6b66\u53e3\u533a',
        '640205': '\u60e0\u519c\u533a',
        '640221': '\u5e73\u7f57\u53bf',
        '640222': '\u5176\u5b83\u533a',
    },
    '0,640000,640300': {
        '640302': '\u5229\u901a\u533a',
        '640303': '\u7ea2\u5bfa\u5821\u533a',
        '640323': '\u76d0\u6c60\u53bf',
        '640324': '\u540c\u5fc3\u53bf',
        '640381': '\u9752\u94dc\u5ce1\u5e02',
        '640382': '\u5176\u5b83\u533a',
    },
    '0,640000,640400': {
        '640402': '\u539f\u5dde\u533a',
        '640422': '\u897f\u5409\u53bf',
        '640423': '\u9686\u5fb7\u53bf',
        '640424': '\u6cfe\u6e90\u53bf',
        '640425': '\u5f6d\u9633\u53bf',
        '640426': '\u5176\u5b83\u533a',
    },
    '0,640000,640500': {
        '640502': '\u6c99\u5761\u5934\u533a',
        '640521': '\u4e2d\u5b81\u53bf',
        '640522': '\u6d77\u539f\u53bf',
        '640523': '\u5176\u5b83\u533a',
    },
    '0,650000': {
        '650100': '\u4e4c\u9c81\u6728\u9f50\u5e02',
        '650200': '\u514b\u62c9\u739b\u4f9d\u5e02',
        '652100': '\u5410\u9c81\u756a\u5730\u533a',
        '652200': '\u54c8\u5bc6\u5730\u533a',
        '652300': '\u660c\u5409\u56de\u65cf\u81ea\u6cbb\u5dde',
        '652700': '\u535a\u5c14\u5854\u62c9\u8499\u53e4\u81ea\u6cbb\u5dde',
        '652800': '\u5df4\u97f3\u90ed\u695e\u8499\u53e4\u81ea\u6cbb\u5dde',
        '652900': '\u963f\u514b\u82cf\u5730\u533a',
        '653000': '\u514b\u5b5c\u52d2\u82cf\u67ef\u5c14\u514b\u5b5c\u81ea\u6cbb\u5dde',
        '653100': '\u5580\u4ec0\u5730\u533a',
        '653200': '\u548c\u7530\u5730\u533a',
        '654000': '\u4f0a\u7281\u54c8\u8428\u514b\u81ea\u6cbb\u5dde',
        '654200': '\u5854\u57ce\u5730\u533a',
        '654300': '\u963f\u52d2\u6cf0\u5730\u533a',
        '659001': '\u77f3\u6cb3\u5b50\u5e02',
        '659002': '\u963f\u62c9\u5c14\u5e02',
        '659003': '\u56fe\u6728\u8212\u514b\u5e02',
        '659004': '\u4e94\u5bb6\u6e20\u5e02',
    },
    '0,650000,650100': {
        '650102': '\u5929\u5c71\u533a',
        '650103': '\u6c99\u4f9d\u5df4\u514b\u533a',
        '650104': '\u65b0\u5e02\u533a',
        '650105': '\u6c34\u78e8\u6c9f\u533a',
        '650106': '\u5934\u5c6f\u6cb3\u533a',
        '650107': '\u8fbe\u5742\u57ce\u533a',
        '650108': '\u4e1c\u5c71\u533a',
        '650109': '\u7c73\u4e1c\u533a',
        '650121': '\u4e4c\u9c81\u6728\u9f50\u53bf',
        '650122': '\u5176\u5b83\u533a',
    },
    '0,650000,650200': {
        '650202': '\u72ec\u5c71\u5b50\u533a',
        '650203': '\u514b\u62c9\u739b\u4f9d\u533a',
        '650204': '\u767d\u78b1\u6ee9\u533a',
        '650205': '\u4e4c\u5c14\u79be\u533a',
        '650206': '\u5176\u5b83\u533a',
    },
    '0,650000,652100': {
        '652101': '\u5410\u9c81\u756a\u5e02',
        '652122': '\u912f\u5584\u53bf',
        '652123': '\u6258\u514b\u900a\u53bf',
        '652124': '\u5176\u5b83\u533a',
    },
    '0,650000,652200': {
        '652201': '\u54c8\u5bc6\u5e02',
        '652222': '\u5df4\u91cc\u5764\u54c8\u8428\u514b\u81ea\u6cbb\u53bf',
        '652223': '\u4f0a\u543e\u53bf',
        '652224': '\u5176\u5b83\u533a',
    },
    '0,650000,652300': {
        '652301': '\u660c\u5409\u5e02',
        '652302': '\u961c\u5eb7\u5e02',
        '652303': '\u7c73\u6cc9\u5e02',
        '652323': '\u547c\u56fe\u58c1\u53bf',
        '652324': '\u739b\u7eb3\u65af\u53bf',
        '652325': '\u5947\u53f0\u53bf',
        '652327': '\u5409\u6728\u8428\u5c14\u53bf',
        '652328': '\u6728\u5792\u54c8\u8428\u514b\u81ea\u6cbb\u53bf',
        '652329': '\u5176\u5b83\u533a',
    },
    '0,650000,652700': {
        '652701': '\u535a\u4e50\u5e02',
        '652722': '\u7cbe\u6cb3\u53bf',
        '652723': '\u6e29\u6cc9\u53bf',
        '652724': '\u5176\u5b83\u533a',
    },
    '0,650000,652800': {
        '652801': '\u5e93\u5c14\u52d2\u5e02',
        '652822': '\u8f6e\u53f0\u53bf',
        '652823': '\u5c09\u7281\u53bf',
        '652824': '\u82e5\u7f8c\u53bf',
        '652825': '\u4e14\u672b\u53bf',
        '652826': '\u7109\u8006\u56de\u65cf\u81ea\u6cbb\u53bf',
        '652827': '\u548c\u9759\u53bf',
        '652828': '\u548c\u7855\u53bf',
        '652829': '\u535a\u6e56\u53bf',
        '652830': '\u5176\u5b83\u533a',
    },
    '0,650000,652900': {
        '652901': '\u963f\u514b\u82cf\u5e02',
        '652922': '\u6e29\u5bbf\u53bf',
        '652923': '\u5e93\u8f66\u53bf',
        '652924': '\u6c99\u96c5\u53bf',
        '652925': '\u65b0\u548c\u53bf',
        '652926': '\u62dc\u57ce\u53bf',
        '652927': '\u4e4c\u4ec0\u53bf',
        '652928': '\u963f\u74e6\u63d0\u53bf',
        '652929': '\u67ef\u576a\u53bf',
        '652930': '\u5176\u5b83\u533a',
    },
    '0,650000,653000': {
        '653001': '\u963f\u56fe\u4ec0\u5e02',
        '653022': '\u963f\u514b\u9676\u53bf',
        '653023': '\u963f\u5408\u5947\u53bf',
        '653024': '\u4e4c\u6070\u53bf',
        '653025': '\u5176\u5b83\u533a',
    },
    '0,650000,653100': {
        '653101': '\u5580\u4ec0\u5e02',
        '653121': '\u758f\u9644\u53bf',
        '653122': '\u758f\u52d2\u53bf',
        '653123': '\u82f1\u5409\u6c99\u53bf',
        '653124': '\u6cfd\u666e\u53bf',
        '653125': '\u838e\u8f66\u53bf',
        '653126': '\u53f6\u57ce\u53bf',
        '653127': '\u9ea6\u76d6\u63d0\u53bf',
        '653128': '\u5cb3\u666e\u6e56\u53bf',
        '653129': '\u4f3d\u5e08\u53bf',
        '653130': '\u5df4\u695a\u53bf',
        '653131': '\u5854\u4ec0\u5e93\u5c14\u5e72\u5854\u5409\u514b\u81ea\u6cbb\u53bf',
        '653132': '\u5176\u5b83\u533a',
    },
    '0,650000,653200': {
        '653201': '\u548c\u7530\u5e02',
        '653221': '\u548c\u7530\u53bf',
        '653222': '\u58a8\u7389\u53bf',
        '653223': '\u76ae\u5c71\u53bf',
        '653224': '\u6d1b\u6d66\u53bf',
        '653225': '\u7b56\u52d2\u53bf',
        '653226': '\u4e8e\u7530\u53bf',
        '653227': '\u6c11\u4e30\u53bf',
        '653228': '\u5176\u5b83\u533a',
    },
    '0,650000,654000': {
        '654002': '\u4f0a\u5b81\u5e02',
        '654003': '\u594e\u5c6f\u5e02',
        '654021': '\u4f0a\u5b81\u53bf',
        '654022': '\u5bdf\u5e03\u67e5\u5c14\u9521\u4f2f\u81ea\u6cbb\u53bf',
        '654023': '\u970d\u57ce\u53bf',
        '654024': '\u5de9\u7559\u53bf',
        '654025': '\u65b0\u6e90\u53bf',
        '654026': '\u662d\u82cf\u53bf',
        '654027': '\u7279\u514b\u65af\u53bf',
        '654028': '\u5c3c\u52d2\u514b\u53bf',
        '654029': '\u5176\u5b83\u533a',
    },
    '0,650000,654200': {
        '654201': '\u5854\u57ce\u5e02',
        '654202': '\u4e4c\u82cf\u5e02',
        '654221': '\u989d\u654f\u53bf',
        '654223': '\u6c99\u6e7e\u53bf',
        '654224': '\u6258\u91cc\u53bf',
        '654225': '\u88d5\u6c11\u53bf',
        '654226': '\u548c\u5e03\u514b\u8d5b\u5c14\u8499\u53e4\u81ea\u6cbb\u53bf',
        '654227': '\u5176\u5b83\u533a',
    },
    '0,650000,654300': {
        '654301': '\u963f\u52d2\u6cf0\u5e02',
        '654321': '\u5e03\u5c14\u6d25\u53bf',
        '654322': '\u5bcc\u8574\u53bf',
        '654323': '\u798f\u6d77\u53bf',
        '654324': '\u54c8\u5df4\u6cb3\u53bf',
        '654325': '\u9752\u6cb3\u53bf',
        '654326': '\u5409\u6728\u4e43\u53bf',
        '654327': '\u5176\u5b83\u533a',
    },
    '0,650000,659001': [],
    '0,650000,659002': [],
    '0,650000,659003': [],
    '0,650000,659004': [],
    '0,710000': {
        '710100': '\u53f0\u5317\u5e02',
        '710200': '\u9ad8\u96c4\u5e02',
        '710300': '\u53f0\u5357\u5e02',
        '710400': '\u53f0\u4e2d\u5e02',
        '710500': '\u91d1\u95e8\u53bf',
        '710600': '\u5357\u6295\u53bf',
        '710700': '\u57fa\u9686\u5e02',
        '710800': '\u65b0\u7af9\u5e02',
        '710900': '\u5609\u4e49\u5e02',
        '711100': '\u65b0\u5317\u5e02',
        '711200': '\u5b9c\u5170\u53bf',
        '711300': '\u65b0\u7af9\u53bf',
        '711400': '\u6843\u56ed\u53bf',
        '711500': '\u82d7\u6817\u53bf',
        '711700': '\u5f70\u5316\u53bf',
        '711900': '\u5609\u4e49\u53bf',
        '712100': '\u4e91\u6797\u53bf',
        '712400': '\u5c4f\u4e1c\u53bf',
        '712500': '\u53f0\u4e1c\u53bf',
        '712600': '\u82b1\u83b2\u53bf',
        '712700': '\u6f8e\u6e56\u53bf',
    },
    '0,710000,710100': {
        '710101': '\u4e2d\u6b63\u533a',
        '710102': '\u5927\u540c\u533a',
        '710103': '\u4e2d\u5c71\u533a',
        '710104': '\u677e\u5c71\u533a',
        '710105': '\u5927\u5b89\u533a',
        '710106': '\u4e07\u534e\u533a',
        '710107': '\u4fe1\u4e49\u533a',
        '710108': '\u58eb\u6797\u533a',
        '710109': '\u5317\u6295\u533a',
        '710110': '\u5185\u6e56\u533a',
        '710111': '\u5357\u6e2f\u533a',
        '710112': '\u6587\u5c71\u533a',
        '710113': '\u5176\u5b83\u533a',
    },
    '0,710000,710200': {
        '710201': '\u65b0\u5174\u533a',
        '710202': '\u524d\u91d1\u533a',
        '710203': '\u82a9\u96c5\u533a',
        '710204': '\u76d0\u57d5\u533a',
        '710205': '\u9f13\u5c71\u533a',
        '710206': '\u65d7\u6d25\u533a',
        '710207': '\u524d\u9547\u533a',
        '710208': '\u4e09\u6c11\u533a',
        '710209': '\u5de6\u8425\u533a',
        '710210': '\u6960\u6893\u533a',
        '710211': '\u5c0f\u6e2f\u533a',
        '710212': '\u5176\u5b83\u533a',
    },
    '0,710000,710300': {
        '710301': '\u4e2d\u897f\u533a',
        '710302': '\u4e1c\u533a',
        '710303': '\u5357\u533a',
        '710304': '\u5317\u533a',
        '710305': '\u5b89\u5e73\u533a',
        '710306': '\u5b89\u5357\u533a',
        '710307': '\u5176\u5b83\u533a',
    },
    '0,710000,710400': {
        '710401': '\u4e2d\u533a',
        '710402': '\u4e1c\u533a',
        '710403': '\u5357\u533a',
        '710404': '\u897f\u533a',
        '710405': '\u5317\u533a',
        '710406': '\u5317\u5c6f\u533a',
        '710407': '\u897f\u5c6f\u533a',
        '710408': '\u5357\u5c6f\u533a',
        '710409': '\u5176\u5b83\u533a',
    },
    '0,710000,710500': [],
    '0,710000,710600': [],
    '0,710000,710700': {
        '710701': '\u4ec1\u7231\u533a',
        '710702': '\u4fe1\u4e49\u533a',
        '710703': '\u4e2d\u6b63\u533a',
        '710704': '\u4e2d\u5c71\u533a',
        '710705': '\u5b89\u4e50\u533a',
        '710706': '\u6696\u6696\u533a',
        '710707': '\u4e03\u5835\u533a',
        '710708': '\u5176\u5b83\u533a',
    },
    '0,710000,710800': {
        '710801': '\u4e1c\u533a',
        '710802': '\u5317\u533a',
        '710803': '\u9999\u5c71\u533a',
        '710804': '\u5176\u5b83\u533a',
    },
    '0,710000,710900': {
        '710901': '\u4e1c\u533a',
        '710902': '\u897f\u533a',
        '710903': '\u5176\u5b83\u533a',
    },
    '0,710000,711100': [],
    '0,710000,711200': [],
    '0,710000,711300': [],
    '0,710000,711400': [],
    '0,710000,711500': [],
    '0,710000,711700': [],
    '0,710000,711900': [],
    '0,710000,712100': [],
    '0,710000,712400': [],
    '0,710000,712500': [],
    '0,710000,712600': [],
    '0,710000,712700': [],
    '0,810000': {
        '810100': '\u9999\u6e2f\u5c9b',
        '810200': '\u4e5d\u9f99',
        '810300': '\u65b0\u754c',
    },
    '0,810000,810100': {
        '810101': '\u4e2d\u897f\u533a',
        '810102': '\u6e7e\u4ed4',
        '810103': '\u4e1c\u533a',
        '810104': '\u5357\u533a',
    },
    '0,810000,810200': {
        '810201': '\u4e5d\u9f99\u57ce\u533a',
        '810202': '\u6cb9\u5c16\u65fa\u533a',
        '810203': '\u6df1\u6c34\u57d7\u533a',
        '810204': '\u9ec4\u5927\u4ed9\u533a',
        '810205': '\u89c2\u5858\u533a',
    },
    '0,810000,810300': {
        '810301': '\u5317\u533a',
        '810302': '\u5927\u57d4\u533a',
        '810303': '\u6c99\u7530\u533a',
        '810304': '\u897f\u8d21\u533a',
        '810305': '\u5143\u6717\u533a',
        '810306': '\u5c6f\u95e8\u533a',
        '810307': '\u8343\u6e7e\u533a',
        '810308': '\u8475\u9752\u533a',
        '810309': '\u79bb\u5c9b\u533a',
    },
    '0,820000': {
        '820100': '\u6fb3\u95e8\u534a\u5c9b',
        '820200': '\u79bb\u5c9b',
    },
    '0,820000,820100': [],
    '0,820000,820200': [],
    '0,990000': {
        '990100': '\u6d77\u5916',
    },
    '0,990000,990100': [],
};

function initArea(newArea, key0) {
    let area = aLocation[key0];
    for (let key in area) {
        if (key) {
            let children = initArea([], `${key0},${key}`);
            newArea.push({
                value: key,
                label: area[key],
                children: children.length ? children : null,
            });
        }
    }
    return newArea;
}
//接收省市区编码--转换成对应 省市县名称
function translateAddress(pCode, cCode, aCode) {
    let address = '';
    let arr = aLocation[0];
    let flag = pCode in arr;
    if (flag) {
        let ckey = '0,' + pCode;
        let akey = '0,' + pCode + ',' + cCode;
        let prince = aLocation[0][pCode];
        let city = aLocation[ckey][cCode];
        let area = '';
        if (aCode !== null) {
            area = aLocation[akey][aCode];
        }
        address = prince + city + area;
    }

    return address;
}
//将省市区code转好的省市县名称的地址库
const newLocation = initArea([], '0');
export default {
    newLocation,
    aLocation,
    translateAddress,
};
